window.STORE_DATA = [
    {
        "id": "i-LGUqptlmpE",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-LGUqptlmpE",
        "name": "4Barista.hr",
        "index": "372",
        "createdAt": "2026-06-08T03:19:06.984Z",
        "updatedAt": "2026-06-08T03:19:33.634Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-LGUqptlmpE",
        "values": {
            "Store Name": "4Barista.hr",
            "Address": "",
            "Website": "https:\/\/www.4barista.hr\/subminimal-brand",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Croatia",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Online Store",
            "Modified": "2026-06-08T10:19:33.634+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-06-08T10:19:06.984+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i--VMBvLjZXv",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i--VMBvLjZXv",
        "name": "4Barista.ro",
        "index": "371",
        "createdAt": "2026-06-08T03:18:32.220Z",
        "updatedAt": "2026-06-08T03:18:58.143Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui--VMBvLjZXv",
        "values": {
            "Store Name": "4Barista.ro",
            "Address": "",
            "Website": "https:\/\/www.4barista.ro\/subminimal-brand",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Romania",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Online Store",
            "Modified": "2026-06-08T10:18:58.143+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-06-08T10:18:32.220+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-bNqQllJGx6",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-bNqQllJGx6",
        "name": "4Barista.de",
        "index": "370",
        "createdAt": "2026-06-08T03:17:52.200Z",
        "updatedAt": "2026-06-08T03:18:18.121Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-bNqQllJGx6",
        "values": {
            "Store Name": "4Barista.de",
            "Address": "",
            "Website": "https:\/\/www.4barista.de\/subminimal-brand",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Germany",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Online Store",
            "Modified": "2026-06-08T10:18:18.121+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-06-08T10:17:52.200+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-ATICZiMmr5",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ATICZiMmr5",
        "name": "4Barista.pl",
        "index": "369",
        "createdAt": "2026-06-08T03:16:46.879Z",
        "updatedAt": "2026-06-08T03:17:35.776Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ATICZiMmr5",
        "values": {
            "Store Name": "4Barista.pl",
            "Address": "",
            "Website": "https:\/\/www.4barista.pl\/subminimal-brand",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Poland",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Online Store",
            "Modified": "2026-06-08T10:17:35.776+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-06-08T10:16:46.879+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-v6fN5L9RTt",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-v6fN5L9RTt",
        "name": "4Barista.hu",
        "index": "368",
        "createdAt": "2026-06-08T03:16:44.174Z",
        "updatedAt": "2026-06-08T03:17:06.688Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-v6fN5L9RTt",
        "values": {
            "Store Name": "4Barista.hu",
            "Address": "",
            "Website": "https:\/\/www.4barista.hu\/subminimal-brand",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Hungary",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Online Store",
            "Modified": "2026-06-08T10:17:06.688+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-06-08T10:16:44.174+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-uUWck8PAT7",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-uUWck8PAT7",
        "name": "4Barista.cz",
        "index": "367",
        "createdAt": "2026-06-08T03:08:48.409Z",
        "updatedAt": "2026-06-08T03:16:36.459Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-uUWck8PAT7",
        "values": {
            "Store Name": "4Barista.cz",
            "Address": "",
            "Website": "https:\/\/www.4barista.cz\/subminimal-brand",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Czech Republic",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Online Store",
            "Modified": "2026-06-08T10:16:36.459+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-06-08T10:08:48.409+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-_dH9hvVcPP",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-_dH9hvVcPP",
        "name": "4Barista.sk",
        "index": "366",
        "createdAt": "2026-06-08T03:05:30.509Z",
        "updatedAt": "2026-06-08T03:06:44.233Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-_dH9hvVcPP",
        "values": {
            "Store Name": "4Barista.sk",
            "Address": "",
            "Website": "https:\/\/www.4barista.sk\/subminimal-brand",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Slovakia",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Online Store",
            "Modified": "2026-06-08T10:06:44.233+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-06-08T10:05:30.509+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-bDGQ6y_7GM",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-bDGQ6y_7GM",
        "name": "4Barista.sk",
        "index": "365",
        "createdAt": "2026-06-08T03:04:37.739Z",
        "updatedAt": "2026-06-08T03:07:42.726Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-bDGQ6y_7GM",
        "values": {
            "Store Name": "4Barista.sk",
            "Address": "",
            "Website": "https:\/\/www.4barista.sk\/subminimal-brand",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Slovakia",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Reseller",
            "Modified": "2026-06-08T10:07:42.726+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":true}",
            "Deleted": "1",
            "Created on": "2026-06-08T10:04:37.739+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-4xcFkl2VF4",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-4xcFkl2VF4",
        "name": "4Barista.sk",
        "index": "364",
        "createdAt": "2026-06-08T03:04:02.752Z",
        "updatedAt": "2026-06-08T03:07:44.296Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-4xcFkl2VF4",
        "values": {
            "Store Name": "4Barista.sk",
            "Address": "",
            "Website": "",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Slovakia",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Reseller",
            "Modified": "2026-06-08T10:07:44.296+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":true}",
            "Deleted": "1",
            "Created on": "2026-06-08T10:04:02.752+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-VIGzNfKgkR",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-VIGzNfKgkR",
        "name": "4Barista",
        "index": "334",
        "createdAt": "2026-06-04T07:41:08.190Z",
        "updatedAt": "2026-06-04T07:41:15.612Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-VIGzNfKgkR",
        "values": {
            "Store Name": "4Barista",
            "Address": "",
            "Website": "",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "",
            "Modified": "2026-06-04T14:41:15.612+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-06-04T14:41:08.190+07:00",
            "Type": "",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-2hcDSQM4ya",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-2hcDSQM4ya",
        "name": "4Barista.sk",
        "index": "335",
        "createdAt": "2026-06-04T02:16:38.117Z",
        "updatedAt": "2026-06-04T02:17:04.668Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-2hcDSQM4ya",
        "values": {
            "Store Name": "4Barista.sk",
            "Address": "",
            "Website": "",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Slovakia",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "",
            "Modified": "2026-06-04T09:17:04.668+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-06-04T09:16:38.117+07:00",
            "Type": "",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-fEDCsxprvp",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-fEDCsxprvp",
        "name": "4Barista.sk",
        "index": "361",
        "createdAt": "2026-06-04T02:14:50.388Z",
        "updatedAt": "2026-06-04T02:15:27.589Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-fEDCsxprvp",
        "values": {
            "Store Name": "4Barista.sk",
            "Address": "",
            "Website": "",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "",
            "Modified": "2026-06-04T09:15:27.589+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-06-04T09:14:50.388+07:00",
            "Type": "",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-oG2bB5oeBP",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-oG2bB5oeBP",
        "name": "",
        "index": "363",
        "createdAt": "2026-03-24T04:44:17.673Z",
        "updatedAt": "2026-03-24T04:47:35.996Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-oG2bB5oeBP",
        "values": {
            "Store Name": "",
            "Address": "",
            "Website": "",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "",
            "Modified": "2026-03-24T11:47:35.996+07:00",
            "Modified by": "Dominic Symons",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":true}",
            "Deleted": "1",
            "Created on": "2026-03-24T11:44:17.673+07:00",
            "Type": "",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-u89qhvDmVg",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-u89qhvDmVg",
        "name": "",
        "index": "362",
        "createdAt": "2026-03-24T04:41:52.453Z",
        "updatedAt": "2026-03-24T04:47:21.411Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-u89qhvDmVg",
        "values": {
            "Store Name": "",
            "Address": "",
            "Website": "",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "La Tour-de-Peilz",
            "Postal Code": "",
            "Country": "Switzerland",
            "State": "Canton of Vaud",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T11:47:21.411+07:00",
            "Modified by": "Dominic Symons",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":true}",
            "Deleted": "1",
            "Created on": "2026-03-24T11:41:52.453+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-AOWVpYGVm6",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-AOWVpYGVm6",
        "name": "",
        "index": "13",
        "createdAt": "2026-02-26T13:51:02.168Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-AOWVpYGVm6",
        "values": {
            "Store Name": "",
            "Address": "",
            "Website": "",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Czech Republic",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-26T20:51:02.168+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Czech Republic",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-xonhK1U8xx",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-xonhK1U8xx",
        "name": "The Coffee Coaching Club",
        "index": "301",
        "createdAt": "2026-02-25T01:07:32.332Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-xonhK1U8xx",
        "values": {
            "Store Name": "The Coffee Coaching Club",
            "Address": "Gerberngasse 44",
            "Website": "https:\/\/www.coffeecoachingclub.ch\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/4WAnGC37QNbw7wFr9",
            "City": "Bern",
            "Postal Code": "3011",
            "Country": "Switzerland",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Coaching Club",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-25T08:07:32.332+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Switzerland",
            "Copy of State": "",
            "Copy of City": "Bern"
        }
    },
    {
        "id": "i-eaEEQCgcZ1",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-eaEEQCgcZ1",
        "name": "We Are Four Coffee",
        "index": "3",
        "createdAt": "2026-02-24T10:25:20.788Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-eaEEQCgcZ1",
        "values": {
            "Store Name": "We Are Four Coffee",
            "Address": "",
            "Website": "https:\/\/www.wearefour.cl\/",
            "Phone": "",
            "Email": "contacto@wearefour.cl",
            "Google Maps Pin": "",
            "City": "Sierra bella",
            "Postal Code": "",
            "Country": "Chile",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "WR4C",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T17:25:20.788+07:00",
            "Type": "Distributor",
            "New Country": "Chile",
            "New City": "",
            "New State": "",
            "Copy of Country": "Chile",
            "Copy of State": "",
            "Copy of City": "Sierra bella"
        }
    },
    {
        "id": "i-2sTlJn02CB",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-2sTlJn02CB",
        "name": "Typica",
        "index": "1",
        "createdAt": "2026-02-24T10:23:34.302Z",
        "updatedAt": "2026-03-04T16:15:27.012Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-2sTlJn02CB",
        "values": {
            "Store Name": "Typica",
            "Address": "Enebakkveien 117B",
            "Website": "https:\/\/www.typica.no\/",
            "Phone": "+47 22 44 35 36",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Oslo",
            "Postal Code": "0680",
            "Country": "Norway",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:15:27.012+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Typica",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T17:23:34.302+07:00",
            "Type": "Distributor",
            "New Country": "Norway",
            "New City": "Oslo",
            "New State": "Oslo",
            "Copy of Country": "Norway",
            "Copy of State": "",
            "Copy of City": "Oslo"
        }
    },
    {
        "id": "i-bkuaIsKxUW",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-bkuaIsKxUW",
        "name": "The Roasting House",
        "index": "2",
        "createdAt": "2026-02-24T10:21:29.820Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-bkuaIsKxUW",
        "values": {
            "Store Name": "The Roasting House",
            "Address": "8543 al namara Street Alsahafa District",
            "Website": "https:\/\/www.roastinghouse.sa\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Riyadh",
            "Postal Code": "",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Roasting House",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T17:21:29.820+07:00",
            "Type": "Distributor",
            "New Country": "Saudi Arabia",
            "New City": "Riyadh",
            "New State": "Riyadh Region",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Riyadh"
        }
    },
    {
        "id": "i-gWWTUbjUYD",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-gWWTUbjUYD",
        "name": "Origo",
        "index": "4",
        "createdAt": "2026-02-24T10:19:38.391Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-gWWTUbjUYD",
        "values": {
            "Store Name": "Origo",
            "Address": "",
            "Website": "https:\/\/origocoffee.ro\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Cernica",
            "Postal Code": "",
            "Country": "Romania",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Origo Coffee",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T17:19:38.391+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Romania",
            "Copy of State": "",
            "Copy of City": "Cernica"
        }
    },
    {
        "id": "i-fFYyqdzaV0",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-fFYyqdzaV0",
        "name": "Noza",
        "index": "5",
        "createdAt": "2026-02-24T10:18:02.223Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-fFYyqdzaV0",
        "values": {
            "Store Name": "Noza",
            "Address": "24 rue james watt",
            "Website": "https:\/\/WWW.NOZADIS.COM",
            "Phone": "+33321606002",
            "Email": "info@nozadis.com",
            "Google Maps Pin": "",
            "City": "Dainville",
            "Postal Code": "62000",
            "Country": "France",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "NOZA",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T17:18:02.223+07:00",
            "Type": "Distributor",
            "New Country": "France",
            "New City": "",
            "New State": "",
            "Copy of Country": "France",
            "Copy of State": "",
            "Copy of City": "Dainville"
        }
    },
    {
        "id": "i-OrAPBD0LHh",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-OrAPBD0LHh",
        "name": "Newo",
        "index": "6",
        "createdAt": "2026-02-24T10:16:22.496Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-OrAPBD0LHh",
        "values": {
            "Store Name": "Newo",
            "Address": "",
            "Website": "http:\/\/outinargentina.com.ar\/",
            "Phone": "+541141982201",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Buenos Aires",
            "Postal Code": "",
            "Country": "Argentina",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Newo",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T17:16:22.496+07:00",
            "Type": "Distributor",
            "New Country": "Argentina",
            "New City": "Buenos Aires",
            "New State": "Buenos Aires Province",
            "Copy of Country": "Argentina",
            "Copy of State": "",
            "Copy of City": "Buenos Aires"
        }
    },
    {
        "id": "i-QCKmy4w3Mm",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-QCKmy4w3Mm",
        "name": "Meptico",
        "index": "8",
        "createdAt": "2026-02-24T10:13:51.574Z",
        "updatedAt": "2026-04-07T14:27:40.307Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-QCKmy4w3Mm",
        "values": {
            "Store Name": "Meptico",
            "Address": "PB: 90729\u060c Zouk Mosbeh Industrial Zone\u060c Badaoui Street",
            "Website": "",
            "Phone": "+961 9 220 886",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/FNkKvrh1ocTWcPfy7",
            "City": "Jdeideh",
            "Postal Code": "",
            "Country": "Lebanon",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-04-07T21:27:40.307+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Meptico",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T17:13:51.574+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Lebanon",
            "Copy of State": "",
            "Copy of City": "Jdeideh"
        }
    },
    {
        "id": "i-ihM467xqsQ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ihM467xqsQ",
        "name": "Coffee Accessories",
        "index": "9",
        "createdAt": "2026-02-24T10:10:34.717Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ihM467xqsQ",
        "values": {
            "Store Name": "Coffee Accessories",
            "Address": "",
            "Website": "https:\/\/hrubyy-pomel.com.ua\/ua\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Ukraine",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Accesories",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T17:10:34.717+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Ukraine",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-Cvy21CRU2a",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Cvy21CRU2a",
        "name": "Bork",
        "index": "10",
        "createdAt": "2026-02-24T10:08:03.176Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Cvy21CRU2a",
        "values": {
            "Store Name": "Bork",
            "Address": "",
            "Website": "https:\/\/www.bork.ru\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Russia",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Bork",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T17:08:03.176+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Russia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-gV64yWFRpY",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-gV64yWFRpY",
        "name": "Korebi Coffee",
        "index": "7",
        "createdAt": "2026-02-24T10:04:06.810Z",
        "updatedAt": "2026-03-11T14:52:12.443Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-gV64yWFRpY",
        "values": {
            "Store Name": "Korebi Coffee",
            "Address": "A 501, Mondeal Heights, Sarkhej - Gandhinagar Hwy, near Novotel Hotel, Ahmedabad",
            "Website": "https:\/\/korebi.coffee\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/UStGnZSgQe9UWcAK7",
            "City": "Gujarat",
            "Postal Code": "380015",
            "Country": "India",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-11T21:52:12.443+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Korebi Coffee",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T17:04:06.810+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "India",
            "Copy of State": "",
            "Copy of City": "Gujarat"
        }
    },
    {
        "id": "i-_Su7rVAKwf",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-_Su7rVAKwf",
        "name": "GUSTO GLOBAL",
        "index": "11",
        "createdAt": "2026-02-24T10:02:41.039Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-_Su7rVAKwf",
        "values": {
            "Store Name": "GUSTO GLOBAL",
            "Address": "C. Juan Ramon Jimenez, 18",
            "Website": "",
            "Phone": "+34 952 96 08 74",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Colmenar",
            "Postal Code": "29170",
            "Country": "Spain",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Gusto Global",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T17:02:41.039+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Spain",
            "Copy of State": "",
            "Copy of City": "Colmenar"
        }
    },
    {
        "id": "i-PWsRDU19Nf",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-PWsRDU19Nf",
        "name": "For People",
        "index": "12",
        "createdAt": "2026-02-24T09:58:48.716Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-PWsRDU19Nf",
        "values": {
            "Store Name": "For People",
            "Address": "Sulova 1356\/5",
            "Website": "https:\/\/www.bioforpeople.cz\/",
            "Phone": "+420 739 238 634",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Zbraslav",
            "Postal Code": "1560",
            "Country": "Czech Republic",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "For People",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T16:58:48.716+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Czech Republic",
            "Copy of State": "",
            "Copy of City": "Zbraslav"
        }
    },
    {
        "id": "i-cVh7CUnIdc",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-cVh7CUnIdc",
        "name": "Folka Cafe",
        "index": "16",
        "createdAt": "2026-02-24T09:55:26.529Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-cVh7CUnIdc",
        "values": {
            "Store Name": "Folka Cafe",
            "Address": "",
            "Website": "https:\/\/folkasolutions.com\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Monterrey",
            "Postal Code": "",
            "Country": "Mexico",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Folka Cafe",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T16:55:26.529+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Mexico",
            "Copy of State": "",
            "Copy of City": "Monterrey"
        }
    },
    {
        "id": "i-Kf4vLyyZXh",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Kf4vLyyZXh",
        "name": "exs nordic",
        "index": "15",
        "createdAt": "2026-02-24T09:45:40.623Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Kf4vLyyZXh",
        "values": {
            "Store Name": "exs nordic",
            "Address": "Gl. Kongevej 84",
            "Website": "https:\/\/exsnordic.com\/",
            "Phone": "+45 70 25 11 52",
            "Email": "mikkel@exsnordic.com",
            "Google Maps Pin": "",
            "City": "Frederiksberg",
            "Postal Code": "1850",
            "Country": "Denmark",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Exs Nordic",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T16:45:40.623+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Denmark",
            "Copy of State": "",
            "Copy of City": "Frederiksberg"
        }
    },
    {
        "id": "i-ZVG-ReCcrI",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ZVG-ReCcrI",
        "name": "Espresso Solutions",
        "index": "14",
        "createdAt": "2026-02-24T09:43:23.310Z",
        "updatedAt": "2026-04-07T14:25:01.817Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ZVG-ReCcrI",
        "values": {
            "Store Name": "Espresso Solutions",
            "Address": "Unit 3A, Gatwick Gate Industrial Estate, Charlwood Rd, Lowfield Heath",
            "Website": "https:\/\/espresso-solutions.co.uk\/",
            "Phone": "+44 1293 769825",
            "Email": "sales@espresso-solutions.co.uk",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/aBpLwKjmnkDTRSWN7",
            "City": "Gatwick",
            "Postal Code": "RH11 0TG",
            "Country": "United Kingdom",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-04-07T21:25:01.817+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Espresso Solutions",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T16:43:23.310+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Kingdom",
            "Copy of State": "",
            "Copy of City": "Gatwick"
        }
    },
    {
        "id": "i-WWbofkhJ9O",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-WWbofkhJ9O",
        "name": "Duttenhofer",
        "index": "17",
        "createdAt": "2026-02-24T09:41:51.089Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-WWbofkhJ9O",
        "values": {
            "Store Name": "Duttenhofer",
            "Address": "Alfred-Nobel-Stra\u00dfe 6",
            "Website": "https:\/\/www.duttenhofer.de\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/uFG6jaUzniRax9nt8",
            "City": "W\u00dcRZBURG",
            "Postal Code": "97080",
            "Country": "Germany",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Duttenhofer",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T16:41:51.089+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "W\u00dcRZBURG"
        }
    },
    {
        "id": "i-rZq0l4ot1Y",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-rZq0l4ot1Y",
        "name": "Brewing Gadgets India",
        "index": "19",
        "createdAt": "2026-02-24T09:39:19.251Z",
        "updatedAt": "2026-03-11T14:51:05.952Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-rZq0l4ot1Y",
        "values": {
            "Store Name": "Brewing Gadgets India",
            "Address": "52, near Ayyapa Swamy Temple, Nanjappa Layout, Yelachenahalli,",
            "Website": "https:\/\/brewinggadgets.in\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/koFmYF17WF2FJWj4A",
            "City": "Bangalore",
            "Postal Code": "560111",
            "Country": "India",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-11T21:51:05.952+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Brewing Gadgets (IN)",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T16:39:19.251+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "India",
            "Copy of State": "",
            "Copy of City": "Bangalore"
        }
    },
    {
        "id": "i-I1nqclXqJQ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-I1nqclXqJQ",
        "name": "Brewing Gadgets",
        "index": "18",
        "createdAt": "2026-02-24T09:37:03.286Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-I1nqclXqJQ",
        "values": {
            "Store Name": "Brewing Gadgets",
            "Address": "B1, B2 Light industrial Units 04 - Dubai Silicon Oasis",
            "Website": "https:\/\/brewinggadgets.com\/",
            "Phone": "+97142325554",
            "Email": "care@brewinggadgets.com",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Brewing Gadgets (AE)",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T16:37:03.286+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-mkfTq3DyLX",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-mkfTq3DyLX",
        "name": "BellaBarista",
        "index": "20",
        "createdAt": "2026-02-24T09:34:48.051Z",
        "updatedAt": "2026-04-07T14:24:28.907Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-mkfTq3DyLX",
        "values": {
            "Store Name": "BellaBarista",
            "Address": "Nene Court the Embankment",
            "Website": "https:\/\/bellabarista.co.uk\/",
            "Phone": "+44 1933 273275",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/6QdfZrdff3R3VsXF7",
            "City": "Wellingborough",
            "Postal Code": "NN8 1LD",
            "Country": "United Kingdom",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-04-07T21:24:28.907+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "BellaBarista",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T16:34:48.051+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Kingdom",
            "Copy of State": "",
            "Copy of City": "Wellingborough"
        }
    },
    {
        "id": "i-oGANEK7bEA",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-oGANEK7bEA",
        "name": "Cafexpress",
        "index": "21",
        "createdAt": "2026-02-24T09:33:23.677Z",
        "updatedAt": "2026-04-07T14:39:09.519Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-oGANEK7bEA",
        "values": {
            "Store Name": "Cafexpress",
            "Address": "Juan Martincich, Cd. del Este",
            "Website": "https:\/\/www.cafexpress.com.py",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/XdGYz78CxMKQhT1B8",
            "City": "Asuncion",
            "Postal Code": "100164",
            "Country": "Paraguay",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-04-07T21:39:09.519+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Altatec",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T16:33:23.677+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Paraguay",
            "Copy of State": "",
            "Copy of City": "Asuncion"
        }
    },
    {
        "id": "i-yudv08z7R6",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-yudv08z7R6",
        "name": "Belco",
        "index": "22",
        "createdAt": "2026-02-24T09:30:52.874Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-yudv08z7R6",
        "values": {
            "Store Name": "Belco",
            "Address": "28 Rue Fran\u00e7ois Arago",
            "Website": "https:\/\/www.belco.fr\/en",
            "Phone": "+33 5 56 16 56 56",
            "Email": "belco@belco.fr",
            "Google Maps Pin": "",
            "City": "M\u00e9rignac",
            "Postal Code": "33700",
            "Country": "France",
            "State": "",
            "Created by": "Indra Putranto",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-24T16:30:52.874+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "France",
            "Copy of State": "",
            "Copy of City": "M\u00e9rignac"
        }
    },
    {
        "id": "i-xapOFKLP8F",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-xapOFKLP8F",
        "name": "Wake Hong Kong",
        "index": "360",
        "createdAt": "2026-02-16T15:14:46.419Z",
        "updatedAt": "2026-03-11T14:36:51.147Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-xapOFKLP8F",
        "values": {
            "Store Name": "Wake Hong Kong",
            "Address": "WAKE Concept Store, Shop 3-8, G\/F, Far East Mansion, 5-6 Middle Rd, Tsim Sha Tsui",
            "Website": "https:\/\/wake.store",
            "Phone": "+852 2813 1393",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/D7DrDXYByKvgZE5k9",
            "City": "Hong Kong",
            "Postal Code": "",
            "Country": "Hong Kong",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:36:51.147+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T22:14:46.419+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Hong Kong",
            "Copy of State": "",
            "Copy of City": "Hong Kong"
        }
    },
    {
        "id": "i-7YUEclyRpk",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-7YUEclyRpk",
        "name": "We The Daily",
        "index": "359",
        "createdAt": "2026-02-16T15:13:34.923Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-7YUEclyRpk",
        "values": {
            "Store Name": "We The Daily",
            "Address": "",
            "Website": "https:\/\/www.tokopedia.com\/the-daily-coffee",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Jakarta Barat",
            "Postal Code": "",
            "Country": "Indonesia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Online Store",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T22:13:34.923+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Indonesia",
            "Copy of State": "",
            "Copy of City": "Jakarta Barat"
        }
    },
    {
        "id": "i-glj3U0gg85",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-glj3U0gg85",
        "name": "Vektorplus OG",
        "index": "358",
        "createdAt": "2026-02-16T15:13:05.487Z",
        "updatedAt": "2026-03-24T14:59:56.674Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-glj3U0gg85",
        "values": {
            "Store Name": "Vektorplus OG",
            "Address": "Liechtensteinstra\u00dfe 15\/1",
            "Website": "https:\/\/www.vettore.at",
            "Phone": "+43 1 236 41 70",
            "Email": "service@vettore.at",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/QHcjLXfLGfZD2EFu8",
            "City": "Vienna",
            "Postal Code": "1090",
            "Country": "Austria",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T21:59:56.674+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T22:13:05.487+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Austria",
            "Copy of State": "",
            "Copy of City": "Vienna"
        }
    },
    {
        "id": "i-p3qNW85z9u",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-p3qNW85z9u",
        "name": "KAVOS DRAUGAS",
        "index": "357",
        "createdAt": "2026-02-16T15:11:14.148Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-p3qNW85z9u",
        "values": {
            "Store Name": "KAVOS DRAUGAS",
            "Address": "Savanori\u0173 pr. 136",
            "Website": "https:\/\/www.kavosdraugas.lt",
            "Phone": "+370 699 44844",
            "Email": "hello@coffeefriend.eu",
            "Google Maps Pin": "",
            "City": "Brastos",
            "Postal Code": "44148",
            "Country": "Lithuania",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T22:11:14.148+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Lithuania",
            "Copy of State": "",
            "Copy of City": "Brastos"
        }
    },
    {
        "id": "i-40p1QzkJZF",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-40p1QzkJZF",
        "name": "Toms Espresso Shop",
        "index": "356",
        "createdAt": "2026-02-16T15:09:48.812Z",
        "updatedAt": "2026-03-24T14:59:40.997Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-40p1QzkJZF",
        "values": {
            "Store Name": "Toms Espresso Shop",
            "Address": "K\u00e4rntner Str. 16",
            "Website": "https:\/\/tomsespressoshop.at\/",
            "Phone": "+43 677 62463733",
            "Email": "info@tomsespressoshop.at",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/sxZpAiLgHGci3Mj29",
            "City": "Lienz",
            "Postal Code": "9900",
            "Country": "Austria",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T21:59:40.997+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T22:09:48.812+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Austria",
            "Copy of State": "",
            "Copy of City": "Lienz"
        }
    },
    {
        "id": "i-31OJNBcGFb",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-31OJNBcGFb",
        "name": "The ISO Builder Limited",
        "index": "355",
        "createdAt": "2026-02-16T15:08:21.999Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-31OJNBcGFb",
        "values": {
            "Store Name": "The ISO Builder Limited",
            "Address": "Room 13, 15\/F, Technology Park (Dali Plaza), 18 On Lai Street, Shek Mun, Shatin",
            "Website": "https:\/\/www.qualitylife.coffee",
            "Phone": "+852 5760 5600",
            "Email": "jason@qualitylife.coffee",
            "Google Maps Pin": "",
            "City": "Hong Kong",
            "Postal Code": "",
            "Country": "Hong Kong",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T22:08:21.999+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Hong Kong",
            "Copy of State": "",
            "Copy of City": "Hong Kong"
        }
    },
    {
        "id": "i-ZOPxrFEv5m",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ZOPxrFEv5m",
        "name": "The Cumulus Coffee Company",
        "index": "354",
        "createdAt": "2026-02-16T15:07:24.307Z",
        "updatedAt": "2026-03-09T14:23:10.870Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ZOPxrFEv5m",
        "values": {
            "Store Name": "The Cumulus Coffee Company",
            "Address": "104 West 40th Street, 7th Floor",
            "Website": "https:\/\/cumuluscoffee.com",
            "Phone": "+1 646-283-6334",
            "Email": "info@cumuluscoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/8smx8p9wLNuR8Vgi9",
            "City": "New York",
            "Postal Code": "10018",
            "Country": "United States",
            "State": "NY",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:23:10.870+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T22:07:24.307+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "NY",
            "Copy of City": "New York"
        }
    },
    {
        "id": "i-2Gi06DtmOM",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-2Gi06DtmOM",
        "name": "THE COFFEE LAB",
        "index": "353",
        "createdAt": "2026-02-16T15:05:48.758Z",
        "updatedAt": "2026-04-07T14:37:36.848Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-2Gi06DtmOM",
        "values": {
            "Store Name": "THE COFFEE LAB",
            "Address": "B02, Marina Views, Marina Cubes, Port Rashid",
            "Website": "https:\/\/thecoffeelab.ae",
            "Phone": "+917 4 546 4670",
            "Email": "support@thecoffeelab.ae",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/i3q5Q3zpgdnpFSk69",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:37:36.848+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T22:05:48.758+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-tZqiHaTxzm",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-tZqiHaTxzm",
        "name": "The Coffee District Philippines",
        "index": "352",
        "createdAt": "2026-02-16T15:05:02.703Z",
        "updatedAt": "2026-03-10T14:54:42.571Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-tZqiHaTxzm",
        "values": {
            "Store Name": "The Coffee District Philippines",
            "Address": "140, Maginhawa Street, Sikatuna Village",
            "Website": "https:\/\/www.thecoffeedistrict.com\/",
            "Phone": "+63 917103908",
            "Email": "cdistrictph@gmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/sNwFE8iSvmrqyjYE7",
            "City": "Quezon City",
            "Postal Code": "",
            "Country": "Philippines",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:54:42.571+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T22:05:02.703+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Philippines",
            "Copy of State": "",
            "Copy of City": "Quezon City"
        }
    },
    {
        "id": "i-1FWTobySuo",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-1FWTobySuo",
        "name": "That's Coffee GmbH",
        "index": "351",
        "createdAt": "2026-02-16T15:04:02.453Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-1FWTobySuo",
        "values": {
            "Store Name": "That's Coffee GmbH",
            "Address": "Louisenstra\u00dfe 64",
            "Website": "https:\/\/thats-coffee.de",
            "Phone": "+49 173 54 73 071",
            "Email": "hallo@thats-coffee.de",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ad8kSMFJhkf9hFbA9",
            "City": "Dresden",
            "Postal Code": "01099",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T22:04:02.453+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Dresden"
        }
    },
    {
        "id": "i-jDhJL7Ydnf",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-jDhJL7Ydnf",
        "name": "Sur La Table",
        "index": "350",
        "createdAt": "2026-02-16T15:03:02.123Z",
        "updatedAt": "2026-03-09T14:18:10.145Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-jDhJL7Ydnf",
        "values": {
            "Store Name": "Sur La Table",
            "Address": "3333 Bear St Space 241",
            "Website": "https:\/\/www.surlatable.com",
            "Phone": "+1 317-559-2041",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/HZx5ZarLqfFEQUpi7",
            "City": "Costa Mesa",
            "Postal Code": "92626",
            "Country": "United States",
            "State": "California",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:18:10.145+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T22:03:02.123+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-2u_ZpGAl19",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-2u_ZpGAl19",
        "name": "SUNFAR HK",
        "index": "349",
        "createdAt": "2026-02-16T15:01:38.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-2u_ZpGAl19",
        "values": {
            "Store Name": "SUNFAR HK",
            "Address": "",
            "Website": "https:\/\/www.productpro.com.hk",
            "Phone": "",
            "Email": "info@productpro.com.hk",
            "Google Maps Pin": "",
            "City": "Hong Kong",
            "Postal Code": "",
            "Country": "Hong Kong",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T22:01:38.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Hong Kong",
            "Copy of State": "",
            "Copy of City": "Hong Kong"
        }
    },
    {
        "id": "i-8KsJWUF83u",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-8KsJWUF83u",
        "name": "Storming Gravity",
        "index": "348",
        "createdAt": "2026-02-16T14:59:32.987Z",
        "updatedAt": "2026-03-23T15:00:27.119Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-8KsJWUF83u",
        "values": {
            "Store Name": "Storming Gravity",
            "Address": "",
            "Website": "https:\/\/storminggravity.com",
            "Phone": "+60 12 682 8852",
            "Email": "talktous@storminggravity.com",
            "Google Maps Pin": "https:\/\/share.google\/25m3zVNIu3DEFIBt0",
            "City": "Kuala Lumpur",
            "Postal Code": "",
            "Country": "Malaysia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T22:00:27.119+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:59:32.987+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Malaysia",
            "Copy of State": "",
            "Copy of City": "Kuala Lumpur"
        }
    },
    {
        "id": "i-c_-652nMf4",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-c_-652nMf4",
        "name": "SOME Coffee Roastery",
        "index": "347",
        "createdAt": "2026-02-16T14:59:30.591Z",
        "updatedAt": "2026-03-12T14:58:28.725Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-c_-652nMf4",
        "values": {
            "Store Name": "SOME Coffee Roastery",
            "Address": "Al Lazekeiah, Al Muruj, Riyadh",
            "Website": "https:\/\/somecoffee.com\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/NZTXJifMy7MpbkAf6",
            "City": "Riyadh",
            "Postal Code": "12282",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T21:58:28.725+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:59:30.591+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Riyadh"
        }
    },
    {
        "id": "i-TLav1f5izI",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-TLav1f5izI",
        "name": "Shotkw",
        "index": "346",
        "createdAt": "2026-02-16T14:59:03.578Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-TLav1f5izI",
        "values": {
            "Store Name": "Shotkw",
            "Address": "",
            "Website": "https:\/\/shotkw.com",
            "Phone": "",
            "Email": "info@shotkw.com",
            "Google Maps Pin": "",
            "City": "Kuwait",
            "Postal Code": "",
            "Country": "Kuwait",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:59:03.578+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Kuwait",
            "Copy of State": "",
            "Copy of City": "Kuwait"
        }
    },
    {
        "id": "i-Aa9DieC60P",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Aa9DieC60P",
        "name": "Scott Rao Coffee Books",
        "index": "345",
        "createdAt": "2026-02-16T14:57:50.561Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Aa9DieC60P",
        "values": {
            "Store Name": "Scott Rao Coffee Books",
            "Address": "",
            "Website": "https:\/\/www.scottrao.com",
            "Phone": "",
            "Email": "scott@scottrao.com",
            "Google Maps Pin": "",
            "City": "Huntington Beach",
            "Postal Code": "",
            "Country": "United States",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Online Store",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:57:50.561+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "",
            "Copy of City": "Huntington Beach"
        }
    },
    {
        "id": "i-_G9G3UfSqv",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-_G9G3UfSqv",
        "name": "Schamong Kaffee",
        "index": "344",
        "createdAt": "2026-02-16T14:57:01.076Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-_G9G3UfSqv",
        "values": {
            "Store Name": "Schamong Kaffee",
            "Address": "Venloer Stra\u00dfe 535",
            "Website": "https:\/\/kaffeeroester.de",
            "Phone": "+49 221 130 560 30",
            "Email": "office@schamong.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/8VFY2mYTSdnFaxFS6",
            "City": "Cologne",
            "Postal Code": "50825",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:57:01.076+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Cologne"
        }
    },
    {
        "id": "i-8_09dZfYUT",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-8_09dZfYUT",
        "name": "Roxy Espresso GmbH",
        "index": "343",
        "createdAt": "2026-02-16T14:56:09.353Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-8_09dZfYUT",
        "values": {
            "Store Name": "Roxy Espresso GmbH",
            "Address": "Blumenstra\u00dfe 4",
            "Website": "https:\/\/roxy-espresso.com",
            "Phone": "",
            "Email": "info@roxy-espresso.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/QDDnqR5nnTeErX3i9",
            "City": "F\u00fcrstenfeldbruck",
            "Postal Code": "82556",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:56:09.353+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "F\u00fcrstenfeldbruck"
        }
    },
    {
        "id": "i-Nvhbxd0Kpf",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Nvhbxd0Kpf",
        "name": "Rotbart Kaffee",
        "index": "342",
        "createdAt": "2026-02-16T14:54:57.682Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Nvhbxd0Kpf",
        "values": {
            "Store Name": "Rotbart Kaffee",
            "Address": "Carl-Zeiss-Stra\u00dfe 8",
            "Website": "https:\/\/www.rotbart-kaffee.de",
            "Phone": "+49 151 64502286",
            "Email": "info@rotbart-kaffee.de",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/Mpa4ca7bRhgJXHbo9",
            "City": "Leonberg",
            "Postal Code": "71229",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:54:57.682+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Leonberg"
        }
    },
    {
        "id": "i-8CzIi_-xJb",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-8CzIi_-xJb",
        "name": "Rheinland Coffee",
        "index": "341",
        "createdAt": "2026-02-16T14:53:58.848Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-8CzIi_-xJb",
        "values": {
            "Store Name": "Rheinland Coffee",
            "Address": "Kaldauer Stra\u00dfe 14",
            "Website": "https:\/\/rheinland.coffee",
            "Phone": "+49 2241 9559325",
            "Email": "info@rheinland.coffee",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/xPg51irgBu4sXJYWA",
            "City": "Siegburg",
            "Postal Code": "53721",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:53:58.848+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Siegburg"
        }
    },
    {
        "id": "i-b_w0foGK53",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-b_w0foGK53",
        "name": "Rasa Kopi",
        "index": "340",
        "createdAt": "2026-02-16T14:53:02.289Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-b_w0foGK53",
        "values": {
            "Store Name": "Rasa Kopi",
            "Address": "Schillerstra\u00dfe 30",
            "Website": "https:\/\/www.rasakopi.cafe",
            "Phone": "",
            "Email": "info@rasakopi.cafe",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/PNGR8ffBijGZsa7WA",
            "City": "Munich",
            "Postal Code": "80336",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:53:02.289+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Munich"
        }
    },
    {
        "id": "i-89UqAB14Us",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-89UqAB14Us",
        "name": "Pullman Coffee USA",
        "index": "339",
        "createdAt": "2026-02-16T14:52:07.751Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-89UqAB14Us",
        "values": {
            "Store Name": "Pullman Coffee USA",
            "Address": "",
            "Website": "https:\/\/pullmancoffeeusa.com",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Cincinnati",
            "Postal Code": "",
            "Country": "United States",
            "State": "OH",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:52:07.751+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "OH",
            "Copy of City": "Cincinnati"
        }
    },
    {
        "id": "i-Ad1f8-v260",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Ad1f8-v260",
        "name": "32Do \/ Dewata",
        "index": "338",
        "createdAt": "2026-02-16T14:49:13.774Z",
        "updatedAt": "2026-03-24T14:24:58.447Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Ad1f8-v260",
        "values": {
            "Store Name": "32Do \/ Dewata",
            "Address": "Jl. Lebak Sari No.77, Petitenget, Kerobokan Kelod, Kec. Kuta Utara, Kabupaten",
            "Website": "https:\/\/www.instagram.com\/32dobali\/?hl=en",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/P6FGyoijAtwy2HUo6",
            "City": "Bali",
            "Postal Code": "",
            "Country": "Indonesia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T21:24:58.447+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:49:13.774+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Indonesia",
            "Copy of State": "",
            "Copy of City": "Bali"
        }
    },
    {
        "id": "i-jwe7DPwe2u",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-jwe7DPwe2u",
        "name": "Prontopresso",
        "index": "337",
        "createdAt": "2026-02-16T14:48:25.491Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-jwe7DPwe2u",
        "values": {
            "Store Name": "Prontopresso",
            "Address": "Hochkreuz 4",
            "Website": "https:\/\/prontopresso.webnode.page",
            "Phone": "+49 7554 2101 118",
            "Email": "service@prontopresso.de",
            "Google Maps Pin": "",
            "City": "Salem",
            "Postal Code": "88682",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:48:25.491+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Salem"
        }
    },
    {
        "id": "i-10KaMwJ58x",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-10KaMwJ58x",
        "name": "Prime Cherry",
        "index": "336",
        "createdAt": "2026-02-16T14:45:45.214Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-10KaMwJ58x",
        "values": {
            "Store Name": "Prime Cherry",
            "Address": "",
            "Website": "https:\/\/primecherry.com",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Iran",
            "Postal Code": "",
            "Country": "Iran",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:45:45.214+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Iran",
            "Copy of State": "",
            "Copy of City": "Iran"
        }
    },
    {
        "id": "i-GJLOmrpUnG",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-GJLOmrpUnG",
        "name": "Prevail Coffee",
        "index": "333",
        "createdAt": "2026-02-16T14:44:39.047Z",
        "updatedAt": "2026-03-06T14:59:17.071Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-GJLOmrpUnG",
        "values": {
            "Store Name": "Prevail Coffee",
            "Address": "39 Dexter Ave, Suite 102",
            "Website": "https:\/\/prevailcoffee.com\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/frAeXtsUa5DyAbju9",
            "City": "Montgomery",
            "Postal Code": "36104",
            "Country": "United States",
            "State": "AL",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-06T21:59:17.071+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:44:39.047+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "AL",
            "Copy of City": "Montgomery"
        }
    },
    {
        "id": "i-N3p9InK5iR",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-N3p9InK5iR",
        "name": "PowerBrew Coffee",
        "index": "332",
        "createdAt": "2026-02-16T14:39:04.262Z",
        "updatedAt": "2026-03-11T14:21:41.313Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-N3p9InK5iR",
        "values": {
            "Store Name": "PowerBrew Coffee",
            "Address": "No. 222, Zhongshan 1st Rd, Sinsing District",
            "Website": "https:\/\/www.powerbrewcoffee.com",
            "Phone": "+886 985 411 866",
            "Email": "service@powerbrewcoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/88JtHsLinjdyxKax5",
            "City": "Kaohsiung",
            "Postal Code": "800",
            "Country": "Taiwan",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:21:41.313+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:39:04.262+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Taiwan",
            "Copy of State": "",
            "Copy of City": "Kaohsiung"
        }
    },
    {
        "id": "i-5YC3vaOriE",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-5YC3vaOriE",
        "name": "Porto Rico Importing Company",
        "index": "331",
        "createdAt": "2026-02-16T14:33:04.851Z",
        "updatedAt": "2026-03-06T14:54:12.153Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-5YC3vaOriE",
        "values": {
            "Store Name": "Porto Rico Importing Company",
            "Address": "201 Bleecker St",
            "Website": "https:\/\/portorico.com",
            "Phone": "1-800-453-5908",
            "Email": "questions@portorico.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/NsgNpscutPhvkxAS9",
            "City": "New York",
            "Postal Code": "10012",
            "Country": "United States",
            "State": "NY",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-06T21:54:12.153+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:33:04.851+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "NY",
            "Copy of City": "New York"
        }
    },
    {
        "id": "i-sS-HFl1pkH",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-sS-HFl1pkH",
        "name": "PERCUP",
        "index": "330",
        "createdAt": "2026-02-16T14:29:09.543Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-sS-HFl1pkH",
        "values": {
            "Store Name": "PERCUP",
            "Address": "",
            "Website": "https:\/\/percup.com",
            "Phone": "",
            "Email": "support@percup.com",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:29:09.543+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-FXWk4LAfqO",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-FXWk4LAfqO",
        "name": "Pantry Magic",
        "index": "329",
        "createdAt": "2026-02-16T14:28:09.242Z",
        "updatedAt": "2026-03-24T14:29:47.443Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-FXWk4LAfqO",
        "values": {
            "Store Name": "Pantry Magic",
            "Address": "Jl. Kemang Raya No.14b, Bangka",
            "Website": "https:\/\/pantry-magic.id",
            "Phone": "+62 21 718-2573",
            "Email": "pmjk@pantry-magic.id",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/zq6isNXF1RKcqzne8",
            "City": "South Jakarta",
            "Postal Code": "12730",
            "Country": "Indonesia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T21:29:47.443+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:28:09.242+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Indonesia",
            "Copy of State": "",
            "Copy of City": "South Jakarta"
        }
    },
    {
        "id": "i-CrgKgjPkX9",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-CrgKgjPkX9",
        "name": "Oriental Technology Limited",
        "index": "328",
        "createdAt": "2026-02-16T14:18:01.587Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-CrgKgjPkX9",
        "values": {
            "Store Name": "Oriental Technology Limited",
            "Address": "MOKO New Century Plaza, 4\/F, 418\r\n; Kwai Fong: Metroplaza, 2\/F, 299D. Pop Up Kiosk",
            "Website": "https:\/\/www.otlmall.com",
            "Phone": "+852 5485 9227",
            "Email": "cs@otlmall.com",
            "Google Maps Pin": "",
            "City": "Hong Kong",
            "Postal Code": "",
            "Country": "Hong Kong",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:18:01.587+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Hong Kong",
            "Copy of State": "",
            "Copy of City": "Hong Kong"
        }
    },
    {
        "id": "i-5hjmbicENi",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-5hjmbicENi",
        "name": "Novotrade \/ Java Jives",
        "index": "327",
        "createdAt": "2026-02-16T14:17:44.262Z",
        "updatedAt": "2026-03-23T14:55:15.749Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-5hjmbicENi",
        "values": {
            "Store Name": "Novotrade \/ Java Jives",
            "Address": "Tzoumagias 5",
            "Website": "https:\/\/javajives.gr",
            "Phone": "+30 210 620 4040",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/UVeAmj6bQ49b9Tog7",
            "City": "Athens",
            "Postal Code": "11362",
            "Country": "Greece",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:55:15.749+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:17:44.262+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Greece",
            "Copy of State": "",
            "Copy of City": "Athens"
        }
    },
    {
        "id": "i-tBX3NQPoJ5",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-tBX3NQPoJ5",
        "name": "N\u00f6lker & N\u00f6lker",
        "index": "326",
        "createdAt": "2026-02-16T14:14:56.466Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-tBX3NQPoJ5",
        "values": {
            "Store Name": "N\u00f6lker & N\u00f6lker",
            "Address": "Lange Str. 37",
            "Website": "https:\/\/noelker-noelker.de\/",
            "Phone": "+49 (0) 441 15577",
            "Email": "frage@noelker-noelker.de",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/PuiGzvstxQpTDWQx8",
            "City": "Oldenburg",
            "Postal Code": "26122",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:14:56.466+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Oldenburg"
        }
    },
    {
        "id": "i-IRp9H7q1gQ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-IRp9H7q1gQ",
        "name": "Cocoa Runners",
        "index": "325",
        "createdAt": "2026-02-16T14:13:59.096Z",
        "updatedAt": "2026-04-07T14:23:55.720Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-IRp9H7q1gQ",
        "values": {
            "Store Name": "Cocoa Runners",
            "Address": "13 Charterhouse Square, Barbican",
            "Website": "https:\/\/cocoarunners.com\/",
            "Phone": "",
            "Email": "team@cocoarunners.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/4N9vFHxyYWnTCYuQA",
            "City": "London",
            "Postal Code": "EC1M 6AX",
            "Country": "United Kingdom",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:23:55.720+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:13:59.096+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Kingdom",
            "Copy of State": "",
            "Copy of City": "London"
        }
    },
    {
        "id": "i-WPfSLNx_kc",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-WPfSLNx_kc",
        "name": "Natur Bohne",
        "index": "324",
        "createdAt": "2026-02-16T14:13:13.790Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-WPfSLNx_kc",
        "values": {
            "Store Name": "Natur Bohne",
            "Address": "",
            "Website": "https:\/\/naturbohne.de\/",
            "Phone": "+49 7454 8704864",
            "Email": "hello@naturbohne.de",
            "Google Maps Pin": "",
            "City": "V\u00f6hringen",
            "Postal Code": "",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:13:13.790+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "V\u00f6hringen"
        }
    },
    {
        "id": "i-Hhn7aQiDF_",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Hhn7aQiDF_",
        "name": "4barista",
        "index": "323",
        "createdAt": "2026-02-16T14:12:10.578Z",
        "updatedAt": "2026-06-04T06:11:55.532Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Hhn7aQiDF_",
        "values": {
            "Store Name": "4barista",
            "Address": "Bo\u017eeny N\u011bmcovej",
            "Website": "https:\/\/www.4barista.com",
            "Phone": "+421 944 750 100",
            "Email": "info@4barista.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/CqkUe8HoZJSwLZwt9",
            "City": "Ko\u0161ice",
            "Postal Code": "04001",
            "Country": "Slovakia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-06-04T13:11:55.532+07:00",
            "Modified by": "Indra Putranto",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:12:10.578+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Slovakia",
            "Copy of State": "",
            "Copy of City": "Ko\u0161ice"
        }
    },
    {
        "id": "i-3DHCa28zJ6",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-3DHCa28zJ6",
        "name": "Martin Auer GmbH",
        "index": "322",
        "createdAt": "2026-02-16T14:06:01.857Z",
        "updatedAt": "2026-03-24T14:54:34.961Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-3DHCa28zJ6",
        "values": {
            "Store Name": "Martin Auer GmbH",
            "Address": "Maggstra\u00dfe 2",
            "Website": "https:\/\/www.martinauer.at",
            "Phone": "+43 316 8040 100",
            "Email": "office@martinauer.at",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/51DD2HrNffoUm2iR9",
            "City": "Graz",
            "Postal Code": "8042",
            "Country": "Austria",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T21:54:34.961+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:06:01.857+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Austria",
            "Copy of State": "",
            "Copy of City": "Graz"
        }
    },
    {
        "id": "i-8uOknYRPp9",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-8uOknYRPp9",
        "name": "MAP ARGENTINA SRL",
        "index": "321",
        "createdAt": "2026-02-16T14:03:04.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-8uOknYRPp9",
        "values": {
            "Store Name": "MAP ARGENTINA SRL",
            "Address": "",
            "Website": "",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Buenos Aires",
            "Postal Code": "",
            "Country": "Argentina",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:03:04.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Argentina",
            "Copy of State": "",
            "Copy of City": "Buenos Aires"
        }
    },
    {
        "id": "i-xqaEfnlypq",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-xqaEfnlypq",
        "name": "macchina-caff\u00e8",
        "index": "320",
        "createdAt": "2026-02-16T14:02:19.301Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-xqaEfnlypq",
        "values": {
            "Store Name": "macchina-caff\u00e8",
            "Address": "Alte Sch\u00f6nhauser Stra\u00dfe 26",
            "Website": "https:\/\/macchina-caffe.de",
            "Phone": "+49 (0)30 28384414",
            "Email": "info@macchina-caffe.de",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/DT8uUqUVE4tfYcgy5",
            "City": "Berlin",
            "Postal Code": "10119",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T21:02:19.301+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Berlin"
        }
    },
    {
        "id": "i-vaDr4QSG8-",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-vaDr4QSG8-",
        "name": "Lov Lov Coffee",
        "index": "319",
        "createdAt": "2026-02-16T13:57:40.389Z",
        "updatedAt": "2026-03-11T14:26:14.223Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-vaDr4QSG8-",
        "values": {
            "Store Name": "Lov Lov Coffee",
            "Address": "Hong Kong, Shek Mun, On Lai St, 11\u865f923\u5ba4",
            "Website": "https:\/\/www.lovlovcoffee.com.hk",
            "Phone": "+852 2882 6997",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/CgAeX1jz9E6oiSs57",
            "City": "Hong Kong",
            "Postal Code": "",
            "Country": "Hong Kong",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:26:14.223+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:57:40.389+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Hong Kong",
            "Copy of State": "",
            "Copy of City": "Hong Kong"
        }
    },
    {
        "id": "i-HnyrvBHtZq",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-HnyrvBHtZq",
        "name": "Lizzy's Fresh Coffee",
        "index": "318",
        "createdAt": "2026-02-16T13:56:31.467Z",
        "updatedAt": "2026-03-06T14:50:05.752Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-HnyrvBHtZq",
        "values": {
            "Store Name": "Lizzy's Fresh Coffee",
            "Address": "491 10th St, A-3",
            "Website": "https:\/\/www.lizzysfreshcoffee.com",
            "Phone": "+1 208-806-0212",
            "Email": "orders@lizzysfreshcoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/zfpNWCMf6B1qCfp18",
            "City": "Ketchum",
            "Postal Code": "83340",
            "Country": "United States",
            "State": "ID",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-06T21:50:05.752+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:56:31.467+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "ID",
            "Copy of City": "Ketchum"
        }
    },
    {
        "id": "i-PY73yTnh1B",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-PY73yTnh1B",
        "name": "Liquid",
        "index": "317",
        "createdAt": "2026-02-16T13:55:57.121Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-PY73yTnh1B",
        "values": {
            "Store Name": "Liquid",
            "Address": "Al Madina Al Munawwarah Rd, Al Uraija Al Wusta",
            "Website": "https:\/\/liquid-sa.com\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Riyadh",
            "Postal Code": "12769",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:55:57.121+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Riyadh"
        }
    },
    {
        "id": "i-CObb9_xxTK",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-CObb9_xxTK",
        "name": "Lilla Kafferosteriet",
        "index": "316",
        "createdAt": "2026-02-16T13:52:56.521Z",
        "updatedAt": "2026-04-07T14:22:27.046Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-CObb9_xxTK",
        "values": {
            "Store Name": "Lilla Kafferosteriet",
            "Address": "Baltzarsgatan 24",
            "Website": "https:\/\/www.lillakafferosteriet.se",
            "Phone": "+46 40 48 20 00",
            "Email": "info@lillakafferosteriet.se",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/QSSxqyC1B9DykamU9",
            "City": "Malmo",
            "Postal Code": "21136",
            "Country": "Sweden",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:22:27.046+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:52:56.521+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Sweden",
            "Copy of State": "",
            "Copy of City": "Malmo"
        }
    },
    {
        "id": "i-cEfgyOXcQa",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-cEfgyOXcQa",
        "name": "La Cultura del Caff\u00e8",
        "index": "315",
        "createdAt": "2026-02-16T13:46:23.144Z",
        "updatedAt": "2026-03-24T14:51:49.944Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-cEfgyOXcQa",
        "values": {
            "Store Name": "La Cultura del Caff\u00e8",
            "Address": "Hafenstra\u00dfe 57",
            "Website": "https:\/\/lcdc.at",
            "Phone": "+43 2732 70655",
            "Email": "office@lcdc.at",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/aMm4EPME4qfSNqDaA",
            "City": "Krems an der Donau",
            "Postal Code": "3500",
            "Country": "Austria",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T21:51:49.944+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:46:23.144+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Austria",
            "Copy of State": "",
            "Copy of City": "Krems an der Donau"
        }
    },
    {
        "id": "i-NoV0XBeKHY",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-NoV0XBeKHY",
        "name": "La Barista Gmbh",
        "index": "314",
        "createdAt": "2026-02-16T13:46:02.276Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-NoV0XBeKHY",
        "values": {
            "Store Name": "La Barista Gmbh",
            "Address": "Rosengasse 342",
            "Website": "https:\/\/la-barista.com",
            "Phone": "+49 162 8944932",
            "Email": "info@la-barista.shop",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/wHPrt9SeqxQWd8dT9",
            "City": "Landshut",
            "Postal Code": "84028",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:46:02.276+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Landshut"
        }
    },
    {
        "id": "i-tZDmRdM178",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-tZDmRdM178",
        "name": "La Barba Coffee",
        "index": "313",
        "createdAt": "2026-02-16T13:46:01.900Z",
        "updatedAt": "2026-03-06T14:43:59.482Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-tZDmRdM178",
        "values": {
            "Store Name": "La Barba Coffee",
            "Address": "1155 Richards St",
            "Website": "https:\/\/labarbacoffee.com",
            "Phone": "+1 801-918-8173",
            "Email": "info@labarbacoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ANXFrW4h97WTkbGcA",
            "City": "Salt Lake City",
            "Postal Code": "84101",
            "Country": "United States",
            "State": "UT",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-06T21:43:59.482+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:46:01.900+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "UT",
            "Copy of City": "Salt Lake City"
        }
    },
    {
        "id": "i-npkJbLk23S",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-npkJbLk23S",
        "name": "Kofi Kaffeebar",
        "index": "312",
        "createdAt": "2026-02-16T13:43:56.452Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-npkJbLk23S",
        "values": {
            "Store Name": "Kofi Kaffeebar",
            "Address": "Hufschmiede 13",
            "Website": "https:\/\/kofi.de",
            "Phone": "",
            "Email": "Info@kofi.de",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/i9rFTRNx6zWYyNRa7",
            "City": "Minden",
            "Postal Code": "32423",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:43:56.452+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Minden"
        }
    },
    {
        "id": "i-GfUIoEMiWt",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-GfUIoEMiWt",
        "name": "KL5 Coffee",
        "index": "311",
        "createdAt": "2026-02-16T13:40:14.912Z",
        "updatedAt": "2026-03-06T14:38:52.653Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-GfUIoEMiWt",
        "values": {
            "Store Name": "KL5 Coffee",
            "Address": "144 Waterbury St",
            "Website": "https:\/\/kl5coffee.com",
            "Phone": "+1 929-265-0042",
            "Email": "shop@kl5coffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/HWL72XeEbfQ5m7BD6",
            "City": "New York",
            "Postal Code": "11206",
            "Country": "United States",
            "State": "NY",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-06T21:38:52.653+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:40:14.912+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "NY",
            "Copy of City": "New York"
        }
    },
    {
        "id": "i-0KRCjPfHxh",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-0KRCjPfHxh",
        "name": "Kirill Ershov",
        "index": "310",
        "createdAt": "2026-02-16T13:26:04.157Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-0KRCjPfHxh",
        "values": {
            "Store Name": "Kirill Ershov",
            "Address": "",
            "Website": "https:\/\/www.instagram.com\/synchrostationradio\/?hl=en",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Barcelona",
            "Postal Code": "",
            "Country": "Spain",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:26:04.157+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Spain",
            "Copy of State": "",
            "Copy of City": "Barcelona"
        }
    },
    {
        "id": "i-eD8MiRSB0n",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-eD8MiRSB0n",
        "name": "Kinabalu Peak",
        "index": "309",
        "createdAt": "2026-02-16T13:26:03.749Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-eD8MiRSB0n",
        "values": {
            "Store Name": "Kinabalu Peak",
            "Address": "No. 15, Lorong Galing 109, Jalan Air Putih",
            "Website": "https:\/\/www.kinabalupeak.com",
            "Phone": "+60 10-901 1640",
            "Email": "kinabalupeak@hotmail.com \/ kinabalupeak@gmail.com",
            "Google Maps Pin": "",
            "City": "Kuantan",
            "Postal Code": "25300",
            "Country": "Malaysia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:26:03.749+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Malaysia",
            "Copy of State": "",
            "Copy of City": "Kuantan"
        }
    },
    {
        "id": "i-DOLKmchZqp",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-DOLKmchZqp",
        "name": "KFE Die Kaffeer\u00f6sterei",
        "index": "307",
        "createdAt": "2026-02-16T13:22:55.851Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-DOLKmchZqp",
        "values": {
            "Store Name": "KFE Die Kaffeer\u00f6sterei",
            "Address": "Maximilianstra\u00dfe 2",
            "Website": "https:\/\/www.kfe-kaffee.de",
            "Phone": "+49 6341 144141",
            "Email": "info@kfe-kaffee.de",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/u96JtYwn6UWjZXHRA",
            "City": "Landau in der Pfalz",
            "Postal Code": "76829",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:22:55.851+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Landau in der Pfalz"
        }
    },
    {
        "id": "i-DgQ_9DVURb",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-DgQ_9DVURb",
        "name": "Kauai Coffee Company",
        "index": "306",
        "createdAt": "2026-02-16T13:21:51.318Z",
        "updatedAt": "2026-03-06T14:37:00.799Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-DgQ_9DVURb",
        "values": {
            "Store Name": "Kauai Coffee Company",
            "Address": "870 Halewili Rd",
            "Website": "https:\/\/kauaicoffee.com",
            "Phone": "+1 800-545-8605",
            "Email": "info@kauaicoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/EKL4cpmdG6wDeeXs5",
            "City": "Kalaheo",
            "Postal Code": "96741",
            "Country": "United States",
            "State": "HI",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-06T21:37:00.799+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:21:51.318+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "HI",
            "Copy of City": "Kalaheo"
        }
    },
    {
        "id": "i-Im3VNJ-1lb",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Im3VNJ-1lb",
        "name": "Kaladi Brothers Coffee",
        "index": "305",
        "createdAt": "2026-02-16T13:19:22.237Z",
        "updatedAt": "2026-03-06T14:34:27.140Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Im3VNJ-1lb",
        "values": {
            "Store Name": "Kaladi Brothers Coffee",
            "Address": "6921 Brayton Dr, Anchorage",
            "Website": "https:\/\/kaladi.com",
            "Phone": "",
            "Email": "info@kaladi.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ofYR8wiBqvjvRzsk7",
            "City": "Anchorage",
            "Postal Code": "99507",
            "Country": "United States",
            "State": "Alaska",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-06T21:34:27.140+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:19:22.237+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "",
            "Copy of City": "Anchorage"
        }
    },
    {
        "id": "i-pXYIKrV10V",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-pXYIKrV10V",
        "name": "Kafferiket",
        "index": "304",
        "createdAt": "2026-02-16T13:15:51.801Z",
        "updatedAt": "2026-04-07T14:22:02.528Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-pXYIKrV10V",
        "values": {
            "Store Name": "Kafferiket",
            "Address": "Von Lingensv\u00e4g 41",
            "Website": "https:\/\/kafferiket.com\/",
            "Phone": "+46 73 502 02 81",
            "Email": "CustomerCare@kafferiket.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/E6fJnwJXai7NzAVZ8",
            "City": "Malmo",
            "Postal Code": "21371",
            "Country": "Sweden",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:22:02.528+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:15:51.801+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Sweden",
            "Copy of State": "",
            "Copy of City": "Malmo"
        }
    },
    {
        "id": "i-WI45zFQX23",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-WI45zFQX23",
        "name": "Kaffeeothek E.U.",
        "index": "303",
        "createdAt": "2026-02-16T13:14:38.077Z",
        "updatedAt": "2026-03-24T14:50:17.869Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-WI45zFQX23",
        "values": {
            "Store Name": "Kaffeeothek E.U.",
            "Address": "Stadtplatz 42",
            "Website": "https:\/\/www.kaffeeothek.at",
            "Phone": "+43 7242 350199",
            "Email": "bohne@kaffeeothek.at",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/uyHd7tiYrWfPTvkZ7",
            "City": "Wels",
            "Postal Code": "4600",
            "Country": "Austria",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T21:50:17.869+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-16T20:14:38.077+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Austria",
            "Copy of State": "",
            "Copy of City": "Wels"
        }
    },
    {
        "id": "i-9JYKVoK8oJ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-9JYKVoK8oJ",
        "name": "Kaffeemacher:innen",
        "index": "302",
        "createdAt": "2026-02-13T15:04:46.463Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-9JYKVoK8oJ",
        "values": {
            "Store Name": "Kaffeemacher:innen",
            "Address": "Otto-Lilienthal-Stra\u00dfe 13",
            "Website": "https:\/\/kaffeemacher.de",
            "Phone": "+49 (0) 2064 4567220",
            "Email": "kontakt@kaffeemacher.de",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/Liopg5o2QPQQYLoD7",
            "City": "Dinslaken",
            "Postal Code": "46539",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T22:04:46.463+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Dinslaken"
        }
    },
    {
        "id": "i-TWVhYet3x-",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-TWVhYet3x-",
        "name": "Kaffeemacher",
        "index": "300",
        "createdAt": "2026-02-13T15:03:46.205Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-TWVhYet3x-",
        "values": {
            "Store Name": "Kaffeemacher",
            "Address": "G\u00fcterstrasse 140",
            "Website": "https:\/\/kaffeemacher.ch",
            "Phone": "+41 61 413 72 84",
            "Email": "kontakt@kaffeemacher.ch",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/bXNJ8ZWQKYqk2MG8A",
            "City": "Basel",
            "Postal Code": "4053",
            "Country": "Switzerland",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T22:03:46.205+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Switzerland",
            "Copy of State": "",
            "Copy of City": "Basel"
        }
    },
    {
        "id": "i-oBjpGo1Ucs",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-oBjpGo1Ucs",
        "name": "Kaffee.de",
        "index": "299",
        "createdAt": "2026-02-13T15:02:20.809Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-oBjpGo1Ucs",
        "values": {
            "Store Name": "Kaffee.de",
            "Address": "Stra\u00df\u00e4cker 2",
            "Website": "https:\/\/www.kaffee.de",
            "Phone": "+49 8161 976259-10",
            "Email": "nfo@kaffee.de",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/3kmebzAjd2VneL6g6",
            "City": "Salching",
            "Postal Code": "94330",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T22:02:20.809+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Salching"
        }
    },
    {
        "id": "i-Vd2WjfcH6v",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Vd2WjfcH6v",
        "name": "KaffeBox",
        "index": "298",
        "createdAt": "2026-02-13T15:01:49.119Z",
        "updatedAt": "2026-04-07T14:18:25.489Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Vd2WjfcH6v",
        "values": {
            "Store Name": "KaffeBox",
            "Address": "Tunebakken 17",
            "Website": "https:\/\/www.kaffebox.no",
            "Phone": "+47 48 47 09 47",
            "Email": "post@kaffebox.no",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/eGSUVZr3Q1UpPREt9",
            "City": "Sarpsborg",
            "Postal Code": "1725",
            "Country": "Norway",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:18:25.489+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T22:01:49.119+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Norway",
            "Copy of State": "",
            "Copy of City": "Sarpsborg"
        }
    },
    {
        "id": "i-rdol4jqH1Q",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-rdol4jqH1Q",
        "name": "KAFEINGO",
        "index": "297",
        "createdAt": "2026-02-13T15:00:32.978Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-rdol4jqH1Q",
        "values": {
            "Store Name": "KAFEINGO",
            "Address": "Ahi Evran Cad. Renta\u015f \u0130\u015f Merkezi No: 29\/102, Maslak, Sar\u0131yer",
            "Website": "https:\/\/kafeingo.com",
            "Phone": "+90 549 661 12 30",
            "Email": "info@kafeingo.com",
            "Google Maps Pin": "",
            "City": "Istanbul",
            "Postal Code": "",
            "Country": "Turkey",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Kafeingo",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T22:00:32.978+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Turkey",
            "Copy of State": "",
            "Copy of City": "Istanbul"
        }
    },
    {
        "id": "i-xxVJ10FHVD",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-xxVJ10FHVD",
        "name": "Intelligentsia Coffee",
        "index": "296",
        "createdAt": "2026-02-13T14:59:27.326Z",
        "updatedAt": "2026-03-06T14:32:16.875Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-xxVJ10FHVD",
        "values": {
            "Store Name": "Intelligentsia Coffee",
            "Address": "3123 N Broadway Chicago",
            "Website": "https:\/\/www.intelligentsia.com\/",
            "Phone": "+1 312-563-0023",
            "Email": "info@intelligentsia.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/CoJnp5o21quRuj7P7",
            "City": "Chicago",
            "Postal Code": "60657",
            "Country": "United States",
            "State": "Illinois",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-06T21:32:16.875+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:59:27.326+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "",
            "Copy of City": "Chicago"
        }
    },
    {
        "id": "i--cM-SwQV5h",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i--cM-SwQV5h",
        "name": "Flair Espresso",
        "index": "295",
        "createdAt": "2026-02-13T14:56:45.789Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui--cM-SwQV5h",
        "values": {
            "Store Name": "Flair Espresso",
            "Address": "",
            "Website": "https:\/\/flairespresso.com",
            "Phone": "+1 617-812-2277",
            "Email": "service@flairespresso.com",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "United States",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:56:45.789+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-GS8m461IJE",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-GS8m461IJE",
        "name": "IKAWA Coffee",
        "index": "294",
        "createdAt": "2026-02-13T14:53:08.241Z",
        "updatedAt": "2026-04-07T14:24:11.264Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-GS8m461IJE",
        "values": {
            "Store Name": "IKAWA Coffee",
            "Address": "30 Engate Street",
            "Website": "https:\/\/www.ikawacoffee.com",
            "Phone": "+44 (0) 20 7729 5664",
            "Email": "info@ikawacoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/JcfjMSq1PRXhotg66",
            "City": "London",
            "Postal Code": "SE13 7HA",
            "Country": "United Kingdom",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:24:11.264+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:53:08.241+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Kingdom",
            "Copy of State": "",
            "Copy of City": "London"
        }
    },
    {
        "id": "i-SDiDjV71ai",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-SDiDjV71ai",
        "name": "Holyberry",
        "index": "293",
        "createdAt": "2026-02-13T14:51:00.081Z",
        "updatedAt": "2026-04-07T14:29:33.784Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-SDiDjV71ai",
        "values": {
            "Store Name": "Holyberry",
            "Address": "\u0441\u0442\u0440\u043e\u0435\u043d\u0438\u0435 7, Pravdy Ulitsa, 24, 1 Etazh, Moscow,",
            "Website": "https:\/\/holyberry.ru",
            "Phone": "+7 495 108 34 26",
            "Email": "coffee@holyberry.ru",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/DYbEMasg7LQ7oJRg7",
            "City": "",
            "Postal Code": "127137",
            "Country": "Russia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:29:33.784+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:51:00.081+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Russia",
            "Copy of State": "",
            "Copy of City": "Khimki"
        }
    },
    {
        "id": "i-IRUPAQmkTu",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-IRUPAQmkTu",
        "name": "Tajer Coffee",
        "index": "292",
        "createdAt": "2026-02-13T14:49:50.414Z",
        "updatedAt": "2026-04-07T14:37:12.958Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-IRUPAQmkTu",
        "values": {
            "Store Name": "Tajer Coffee",
            "Address": "",
            "Website": "https:\/\/tajercoffee.ae\/",
            "Phone": "+971 50 388 43 22",
            "Email": "sales@tajercoffee.ae",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/okS4FfwGFp3pktuS9",
            "City": "Abu Dhabi",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:37:12.958+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:49:50.414+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Abu Dhabi"
        }
    },
    {
        "id": "i-B_LWNVSzjq",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-B_LWNVSzjq",
        "name": "Good Food Better",
        "index": "291",
        "createdAt": "2026-02-13T14:48:01.166Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-B_LWNVSzjq",
        "values": {
            "Store Name": "Good Food Better",
            "Address": "Gerhard Marcks Strasse 15",
            "Website": "https:\/\/claraundcarlo.coffee\/",
            "Phone": "",
            "Email": "hello@goodfoodbetter.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/cPAwvJCk8N3i49Mm8",
            "City": "Mannheim",
            "Postal Code": "68165",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:48:01.166+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Mannheim"
        }
    },
    {
        "id": "i-Zwf2u9syZn",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Zwf2u9syZn",
        "name": "Gimme! Coffee",
        "index": "290",
        "createdAt": "2026-02-13T14:46:51.509Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Zwf2u9syZn",
        "values": {
            "Store Name": "Gimme! Coffee",
            "Address": "430 N Cayuga St",
            "Website": "https:\/\/gimmecoffee.com\/",
            "Phone": "+1 607-272-8564",
            "Email": "info@gimmecoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/13czvR8q2KR6Mseb8",
            "City": "Ithaca",
            "Postal Code": "14850",
            "Country": "United States",
            "State": "NY",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:46:51.509+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "NY",
            "Copy of City": "Ithaca"
        }
    },
    {
        "id": "i-nvMTKY4_kL",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-nvMTKY4_kL",
        "name": "GentleFox",
        "index": "289",
        "createdAt": "2026-02-13T14:44:03.135Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-nvMTKY4_kL",
        "values": {
            "Store Name": "GentleFox",
            "Address": "Zenklova 24\/54",
            "Website": "https:\/\/www.gentlefox.cz",
            "Phone": "+420 602 375 801",
            "Email": "michal.pavlac@gentlefox.cz",
            "Google Maps Pin": "",
            "City": "Prague",
            "Postal Code": "18000",
            "Country": "Czech Republic",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:44:03.135+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Czech Republic",
            "Copy of State": "",
            "Copy of City": "Prague"
        }
    },
    {
        "id": "i-g92NcI6vVx",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-g92NcI6vVx",
        "name": "ENTSUKI COFFEE",
        "index": "288",
        "createdAt": "2026-02-13T14:43:04.485Z",
        "updatedAt": "2026-03-11T14:25:09.661Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-g92NcI6vVx",
        "values": {
            "Store Name": "ENTSUKI COFFEE",
            "Address": "Shop 517, 5\/F, 99COMMONS, 99 Pui To Road, Tuen Mun, New Territories",
            "Website": "https:\/\/entsukicoffee.com\/",
            "Phone": "+852 9549 3065",
            "Email": "info@entsukicoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/BphhjQqC4JfYaf2n7",
            "City": "Hong Kong",
            "Postal Code": "",
            "Country": "Hong Kong",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:25:09.661+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:43:04.485+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Hong Kong",
            "Copy of State": "",
            "Copy of City": "Hong Kong"
        }
    },
    {
        "id": "i-7cwWfs4Vyo",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-7cwWfs4Vyo",
        "name": "Entrebox",
        "index": "287",
        "createdAt": "2026-02-13T14:42:09.853Z",
        "updatedAt": "2026-03-11T14:24:32.977Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-7cwWfs4Vyo",
        "values": {
            "Store Name": "Entrebox",
            "Address": "1\/F, Block 4, Lee Son Industrial Building, 28 Ng Fong Street, Diamond Hill",
            "Website": "https:\/\/www.entreboxhk.com",
            "Phone": "+852 5482 9237",
            "Email": "info@entreboxhk.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/soq6NEkVqwZhMwCP7",
            "City": "Hong Kong",
            "Postal Code": "",
            "Country": "Hong Kong",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:24:32.977+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:42:09.853+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Hong Kong",
            "Copy of State": "",
            "Copy of City": "Hong Kong"
        }
    },
    {
        "id": "i-AACdXVWPfA",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-AACdXVWPfA",
        "name": "Elitano Coffee",
        "index": "286",
        "createdAt": "2026-02-13T14:36:00.234Z",
        "updatedAt": "2026-04-07T14:34:37.112Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-AACdXVWPfA",
        "values": {
            "Store Name": "Elitano Coffee",
            "Address": "al rashydia 1-Al naseem street , al Rashydia Shops - shop no.13 - Ajman -",
            "Website": "https:\/\/www.instagram.com\/elitano_coffee\/?hl=en",
            "Phone": "+971 50 209 8094",
            "Email": "info@elitanocoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/afdVUiPW9uvRK2AQ8",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:34:37.112+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:36:00.234+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-74Qhwf8dk9",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-74Qhwf8dk9",
        "name": "DITEK",
        "index": "285",
        "createdAt": "2026-02-13T14:35:55.559Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-74Qhwf8dk9",
        "values": {
            "Store Name": "DITEK",
            "Address": "200 \u0110\u01b0\u1eddng 3\/2, Ph\u01b0\u1eddng 12, Qu\u1eadn 10",
            "Website": "https:\/\/www.facebook.com\/DiTek.vn\/",
            "Phone": "+84 97 777 52 00",
            "Email": "ditek.vn@gmail.com",
            "Google Maps Pin": "",
            "City": "Ho Chi Minh City",
            "Postal Code": "",
            "Country": "Vietnam",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:35:55.559+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Vietnam",
            "Copy of State": "",
            "Copy of City": "Ho Chi Minh City"
        }
    },
    {
        "id": "i-M_T14VW-je",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-M_T14VW-je",
        "name": "DieR\u00f6ster GmbH",
        "index": "284",
        "createdAt": "2026-02-13T14:34:54.830Z",
        "updatedAt": "2026-03-24T14:38:46.201Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-M_T14VW-je",
        "values": {
            "Store Name": "DieR\u00f6ster GmbH",
            "Address": "Wei\u00dfenwolffstra\u00dfe 14",
            "Website": "https:\/\/www.dieroester.at",
            "Phone": "+43 732 272915",
            "Email": "kaffeegenuss@dieroester.at",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/SPYRbLxoe9Q6gGeZ7",
            "City": "Steyregg",
            "Postal Code": "4221",
            "Country": "Austria",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T21:38:46.201+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:34:54.830+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Austria",
            "Copy of State": "",
            "Copy of City": "Steyregg"
        }
    },
    {
        "id": "i-5nK_AneKVp",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-5nK_AneKVp",
        "name": "Das-Kaffeewerk e. K.",
        "index": "283",
        "createdAt": "2026-02-13T14:34:02.257Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-5nK_AneKVp",
        "values": {
            "Store Name": "Das-Kaffeewerk e. K.",
            "Address": "Hamburger Str. 84",
            "Website": "https:\/\/www.das-kaffeewerk.de",
            "Phone": "+49 4193 8800273",
            "Email": "info@das-kaffeewerk.de",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/hM3T6jWr1THSrfBb8",
            "City": "Henstedt-Ulzburg",
            "Postal Code": "24558",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:34:02.257+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Henstedt-Ulzburg"
        }
    },
    {
        "id": "i-1fNCNYvwvn",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-1fNCNYvwvn",
        "name": "Create Sky Limited",
        "index": "282",
        "createdAt": "2026-02-13T14:29:51.195Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-1fNCNYvwvn",
        "values": {
            "Store Name": "Create Sky Limited",
            "Address": "Unit 1502, 15\/F, Carnival Commercial Building, 18 Java Road, North Point",
            "Website": "http:\/\/www.createsky.com.hk",
            "Phone": "+852 3590 2488",
            "Email": "info@createsky.com.hk",
            "Google Maps Pin": "",
            "City": "Hong Kong",
            "Postal Code": "",
            "Country": "Hong Kong",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:29:51.195+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Hong Kong",
            "Copy of State": "",
            "Copy of City": "Hong Kong"
        }
    },
    {
        "id": "i-StS9MHnoWw",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-StS9MHnoWw",
        "name": "CORTADO CAFE",
        "index": "281",
        "createdAt": "2026-02-13T14:20:14.184Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-StS9MHnoWw",
        "values": {
            "Store Name": "CORTADO CAFE",
            "Address": "Shop 35y, Road 35, Block 931",
            "Website": "https:\/\/cortado-cafe.com\/",
            "Phone": "+973 3365 1762",
            "Email": "info@cortado-cafe.com",
            "Google Maps Pin": "",
            "City": "East Riffa",
            "Postal Code": "",
            "Country": "Bahrain",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Cowpresso",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:20:14.184+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Bahrain",
            "Copy of State": "",
            "Copy of City": "East Riffa"
        }
    },
    {
        "id": "i-YH9Q8s0Smh",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-YH9Q8s0Smh",
        "name": "Cometeer",
        "index": "280",
        "createdAt": "2026-02-13T14:14:56.030Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-YH9Q8s0Smh",
        "values": {
            "Store Name": "Cometeer",
            "Address": "21 Great Republic Dr",
            "Website": "https:\/\/cometeer.com",
            "Phone": "617-812-2277",
            "Email": "support@cometeer.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/KscQMyVyU3yKGkXu8",
            "City": "Gloucester",
            "Postal Code": "01930",
            "Country": "United States",
            "State": "MA",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:14:56.030+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "MA",
            "Copy of City": "Gloucester"
        }
    },
    {
        "id": "i-tSG50XRBnR",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-tSG50XRBnR",
        "name": "Coffeenatics",
        "index": "279",
        "createdAt": "2026-02-13T14:10:21.625Z",
        "updatedAt": "2026-03-24T14:29:21.732Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-tSG50XRBnR",
        "values": {
            "Store Name": "Coffeenatics",
            "Address": "Jl. Teuku Cik Ditiro No. 8K, Madras Hulu, Medan Polonia",
            "Website": "https:\/\/www.thecoffeenatics.com",
            "Phone": "+62 61 452 1960",
            "Email": "info@thecoffeenatics.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/HhC3LKmjYYcuua2r8",
            "City": "Medan",
            "Postal Code": "20152",
            "Country": "Indonesia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T21:29:21.732+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:10:21.625+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Indonesia",
            "Copy of State": "",
            "Copy of City": "Medan"
        }
    },
    {
        "id": "i-eC0KOuqb8L",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-eC0KOuqb8L",
        "name": "CoffeeJoy",
        "index": "278",
        "createdAt": "2026-02-13T14:09:30.676Z",
        "updatedAt": "2026-04-07T14:21:08.212Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-eC0KOuqb8L",
        "values": {
            "Store Name": "CoffeeJoy",
            "Address": "Beringvej 19",
            "Website": "https:\/\/coffeejoy.dk",
            "Phone": "+45 40 80 20 80",
            "Email": "info@coffeejoy.dk",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/irnb7pAENF5nfwxw6",
            "City": "Hasselager",
            "Postal Code": "8361",
            "Country": "Denmark",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:21:08.212+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:09:30.676+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Denmark",
            "Copy of State": "",
            "Copy of City": "Hasselager"
        }
    },
    {
        "id": "i-6mJR9_1q0Q",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-6mJR9_1q0Q",
        "name": "Coffee Equipment Shop",
        "index": "277",
        "createdAt": "2026-02-13T14:08:16.067Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-6mJR9_1q0Q",
        "values": {
            "Store Name": "Coffee Equipment Shop",
            "Address": "13449 NW 42nd Ave Office #2",
            "Website": "https:\/\/coffeeequipmentshop.miami",
            "Phone": "786-383-6559",
            "Email": "nikitak@coffeeequipmentshop.miami",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/nPRBMgjMhLjy1N4u5",
            "City": "Opa-locka",
            "Postal Code": "33054",
            "Country": "United States",
            "State": "FL",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:08:16.067+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "FL",
            "Copy of City": "Opa-locka"
        }
    },
    {
        "id": "i-mdpYEjUGVH",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-mdpYEjUGVH",
        "name": "Coffee Blends Zone",
        "index": "276",
        "createdAt": "2026-02-13T14:06:42.643Z",
        "updatedAt": "2026-04-07T14:42:05.683Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-mdpYEjUGVH",
        "values": {
            "Store Name": "Coffee Blends Zone",
            "Address": "Building 716 Road 3514, Jeblat Hebshi,",
            "Website": "https:\/\/coffeeblendszone.com\/",
            "Phone": "+973 3222 2562",
            "Email": "info@coffeeblendszone.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/j6kte5UYKaUKksiH6",
            "City": "",
            "Postal Code": "",
            "Country": "Bahrain",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:42:05.683+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T21:06:42.643+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Bahrain",
            "Copy of State": "",
            "Copy of City": "Manama"
        }
    },
    {
        "id": "i-tGUatkUNWu",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-tGUatkUNWu",
        "name": "Cityroast K\u00f8benhavn",
        "index": "275",
        "createdAt": "2026-02-13T13:58:02.257Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-tGUatkUNWu",
        "values": {
            "Store Name": "Cityroast K\u00f8benhavn",
            "Address": "Holmbladsgade 91",
            "Website": "https:\/\/cityroast.dk\/",
            "Phone": "+45 31 39 17 10",
            "Email": "et@cityroast.dk",
            "Google Maps Pin": "",
            "City": "Copenhagen",
            "Postal Code": "2300",
            "Country": "Denmark",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:58:02.257+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Denmark",
            "Copy of State": "",
            "Copy of City": "Copenhagen"
        }
    },
    {
        "id": "i-polfN3TUFF",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-polfN3TUFF",
        "name": "Christy Tan",
        "index": "274",
        "createdAt": "2026-02-13T13:55:39.177Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-polfN3TUFF",
        "values": {
            "Store Name": "Christy Tan",
            "Address": "",
            "Website": "https:\/\/www.tokopedia.com\/subminimal",
            "Phone": "",
            "Email": "christytan.job@gmail.com",
            "Google Maps Pin": "",
            "City": "Jakarta Barat",
            "Postal Code": "",
            "Country": "Indonesia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:55:39.177+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Indonesia",
            "Copy of State": "",
            "Copy of City": "Jakarta Barat"
        }
    },
    {
        "id": "i-nVcF4NrPdW",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-nVcF4NrPdW",
        "name": "Casa del Caff\u00e9",
        "index": "273",
        "createdAt": "2026-02-13T13:42:21.619Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-nVcF4NrPdW",
        "values": {
            "Store Name": "Casa del Caff\u00e9",
            "Address": "Hauptmarkt 6",
            "Website": "https:\/\/www.lacasadelcaffe.de\/",
            "Phone": "+49 651 9941703",
            "Email": "info@casadelcaffe.de",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/tYpfotnQ2gBff7JY6",
            "City": "Trier",
            "Postal Code": "54290",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:42:21.619+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Trier"
        }
    },
    {
        "id": "i-_sq0pKnJd_",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-_sq0pKnJd_",
        "name": "CAPTN Products GmbH",
        "index": "272",
        "createdAt": "2026-02-13T13:40:19.015Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-_sq0pKnJd_",
        "values": {
            "Store Name": "CAPTN Products GmbH",
            "Address": "Frankenstra\u00dfe 29",
            "Website": "https:\/\/captncoffee.com\/",
            "Phone": "+49 40 209 19 182",
            "Email": "info@captncoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/tXBsfGZ1CHLUihsg8",
            "City": "Hamburg",
            "Postal Code": "20097",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:40:19.015+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Hamburg"
        }
    },
    {
        "id": "i-N_J2KH7DYM",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-N_J2KH7DYM",
        "name": "Cafino",
        "index": "271",
        "createdAt": "2026-02-13T13:37:49.208Z",
        "updatedAt": "2026-04-07T14:41:24.603Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-N_J2KH7DYM",
        "values": {
            "Store Name": "Cafino",
            "Address": "Av. Morangueira, 1414 - Jardim Alvorada, Maring\u00e1 - PR,",
            "Website": "https:\/\/www.cafino.com.br\/",
            "Phone": "+55 35 3241-2679",
            "Email": "luiz@cafino.com.br",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/KjZuPWseQRbcAHYH6",
            "City": "",
            "Postal Code": "87033-070,",
            "Country": "Brazil",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:41:24.603+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:37:49.208+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Brazil",
            "Copy of State": "",
            "Copy of City": "S\u00e3o Gon\u00e7alo do Sapuca\u00ed"
        }
    },
    {
        "id": "i-gC6SFKgNuZ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-gC6SFKgNuZ",
        "name": "Caffenatic",
        "index": "270",
        "createdAt": "2026-02-13T13:34:51.079Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-gC6SFKgNuZ",
        "values": {
            "Store Name": "Caffenatic",
            "Address": "",
            "Website": "https:\/\/www.instagram.com\/caffenatic\/?hl=en",
            "Phone": "",
            "Email": "info@kaffenatic.com",
            "Google Maps Pin": "",
            "City": "Bandar Seri Begawan",
            "Postal Code": "",
            "Country": "Brunei",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:34:51.079+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Brunei",
            "Copy of State": "",
            "Copy of City": "Bandar Seri Begawan"
        }
    },
    {
        "id": "i-ZDyeo6RkZ6",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ZDyeo6RkZ6",
        "name": "C&A Aristodemou Cater Metal Ltd",
        "index": "269",
        "createdAt": "2026-02-13T13:33:05.042Z",
        "updatedAt": "2026-04-07T14:14:36.465Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ZDyeo6RkZ6",
        "values": {
            "Store Name": "C&A Aristodemou Cater Metal Ltd",
            "Address": "Dimitri Vikela, Strovolos",
            "Website": "https:\/\/catermetal.com",
            "Phone": "+357 22421457",
            "Email": "info@catermetal.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/mkvaEoot8qMxHKgU9",
            "City": "",
            "Postal Code": "2033",
            "Country": "Cyprus",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:14:36.465+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:33:05.042+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Cyprus",
            "Copy of State": "",
            "Copy of City": "Nicosia"
        }
    },
    {
        "id": "i-ef37Kkjc_m",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ef37Kkjc_m",
        "name": "BYK Solutions",
        "index": "268",
        "createdAt": "2026-02-13T13:31:41.086Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ef37Kkjc_m",
        "values": {
            "Store Name": "BYK Solutions",
            "Address": "Hawally, Block 11, Al-Othman Street, Al-Bahar Center",
            "Website": "https:\/\/byksolutions.com",
            "Phone": "+965 2261 2411",
            "Email": "info@byksolutions.com",
            "Google Maps Pin": "",
            "City": "Hawally",
            "Postal Code": "",
            "Country": "Kuwait",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:31:41.086+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Kuwait",
            "Copy of State": "",
            "Copy of City": "Hawally"
        }
    },
    {
        "id": "i-RW9N3Z9uSv",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-RW9N3Z9uSv",
        "name": "Brewout Coffee Co",
        "index": "267",
        "createdAt": "2026-02-13T13:30:21.451Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-RW9N3Z9uSv",
        "values": {
            "Store Name": "Brewout Coffee Co",
            "Address": "Abraham-Lincoln-Stra\u00dfe 3",
            "Website": "https:\/\/brewout.de\/",
            "Phone": "+49 151 42449286",
            "Email": "info@brewout.de",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/wRvD5rB8i9irp4hCA",
            "City": "Mainz",
            "Postal Code": "55122",
            "Country": "Germany",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:30:21.451+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Mainz"
        }
    },
    {
        "id": "i-mwTnJ8X7gW",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-mwTnJ8X7gW",
        "name": "Brew 92",
        "index": "266",
        "createdAt": "2026-02-13T13:23:08.652Z",
        "updatedAt": "2026-03-12T14:53:18.363Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-mwTnJ8X7gW",
        "values": {
            "Store Name": "Brew 92",
            "Address": "Prince Saud Al Faisal, Al Khalidiyyah",
            "Website": "https:\/\/www.brew92.com\/",
            "Phone": "+966 56 484 3439",
            "Email": "info@brew92.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/3nvBfngsLdbT67C47",
            "City": "Jeddah",
            "Postal Code": "23423",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T21:53:18.363+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:23:08.652+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Jeddah"
        }
    },
    {
        "id": "i-ZOgDa2_q7P",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ZOgDa2_q7P",
        "name": "Bon grain de caf\u00e9",
        "index": "265",
        "createdAt": "2026-02-13T13:20:46.818Z",
        "updatedAt": "2026-04-07T14:40:01.441Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ZOgDa2_q7P",
        "values": {
            "Store Name": "Bon grain de caf\u00e9",
            "Address": "Route de Heiri, Faa'a",
            "Website": "bongraindecafe@gmail.com",
            "Phone": "+689 87 23 20 20",
            "Email": "https:\/\/bongraindecafe.com\/",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/CBkfhJy8X5vzMZ328",
            "City": "Tahiti",
            "Postal Code": "98704",
            "Country": "French Polynesia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:40:01.441+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:20:46.818+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "French Polynesia",
            "Copy of State": "",
            "Copy of City": "Tahiti"
        }
    },
    {
        "id": "i-lq8JiIN9C-",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-lq8JiIN9C-",
        "name": "Bohnendealer",
        "index": "264",
        "createdAt": "2026-02-13T13:17:01.716Z",
        "updatedAt": "2026-03-24T14:34:08.296Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-lq8JiIN9C-",
        "values": {
            "Store Name": "Bohnendealer",
            "Address": "Schusterstra\u00dfe 12\/C",
            "Website": "https:\/\/www.bohnendealer.coffee\/",
            "Phone": "+43 677 61732597",
            "Email": "support@bohnendealer.coffee",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ZqcaGMQVqRh71EEw6",
            "City": "Munchendorf",
            "Postal Code": "2482",
            "Country": "Austria",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T21:34:08.296+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:17:01.716+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Austria",
            "Copy of State": "",
            "Copy of City": "Munchendorf"
        }
    },
    {
        "id": "i-jUpQEyEv8m",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-jUpQEyEv8m",
        "name": "Blue Star Coffee",
        "index": "263",
        "createdAt": "2026-02-13T13:15:40.700Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-jUpQEyEv8m",
        "values": {
            "Store Name": "Blue Star Coffee",
            "Address": "1240 E Methow Valley Hwy",
            "Website": "https:\/\/bluestarcoffeeroasters.com\/",
            "Phone": "509-997-2583",
            "Email": "info@bluestarcoffeeroasters.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/3Vjo1T3eQA2CpjaAA",
            "City": "Twisp",
            "Postal Code": "98856",
            "Country": "United States",
            "State": "WA",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:15:40.700+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "WA",
            "Copy of City": "Twisp"
        }
    },
    {
        "id": "i-ngOOg6SdG5",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ngOOg6SdG5",
        "name": "Blue Bottle",
        "index": "262",
        "createdAt": "2026-02-13T13:11:17.082Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ngOOg6SdG5",
        "values": {
            "Store Name": "Blue Bottle",
            "Address": "480 9th St",
            "Website": "https:\/\/bluebottlecoffee.com\/",
            "Phone": "510-653-3394",
            "Email": "support@bluebottlecoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/hL9HW2594WDRFyY26",
            "City": "Oakland",
            "Postal Code": "94607",
            "Country": "United States",
            "State": "CA",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:11:17.082+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "CA",
            "Copy of City": "Oakland"
        }
    },
    {
        "id": "i-iW3ziVcPTK",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-iW3ziVcPTK",
        "name": "BIB-FOODS Ltd",
        "index": "261",
        "createdAt": "2026-02-13T13:08:16.292Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-iW3ziVcPTK",
        "values": {
            "Store Name": "BIB-FOODS Ltd",
            "Address": "Southern Industrial Zone, ul. \"Industrialna\" 47",
            "Website": "https:\/\/kafeto.bg\/",
            "Phone": "+359 88 986 6066",
            "Email": "ivan.mangalski@kafeto.bg",
            "Google Maps Pin": "",
            "City": "burgas",
            "Postal Code": "8002",
            "Country": "Bulgaria",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:08:16.292+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Bulgaria",
            "Copy of State": "",
            "Copy of City": "burgas"
        }
    },
    {
        "id": "i-1PBG3Jg1BW",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-1PBG3Jg1BW",
        "name": "Berry & Bean",
        "index": "260",
        "createdAt": "2026-02-13T13:05:37.810Z",
        "updatedAt": "2026-04-07T14:19:49.707Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-1PBG3Jg1BW",
        "values": {
            "Store Name": "Berry & Bean",
            "Address": "Bredskiftevej 22B",
            "Website": "https:\/\/berrybean.com\/",
            "Phone": "+45 8627 3570",
            "Email": "kontakt@berrybean.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/enQFUmbfskC2pfDG8",
            "City": "Aarhus",
            "Postal Code": "8210",
            "Country": "Denmark",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:19:49.707+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:05:37.810+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Denmark",
            "Copy of State": "",
            "Copy of City": "Aarhus"
        }
    },
    {
        "id": "i--o13TCzzEo",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i--o13TCzzEo",
        "name": "Beanstock Coffee Roasters",
        "index": "259",
        "createdAt": "2026-02-13T13:04:07.575Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui--o13TCzzEo",
        "values": {
            "Store Name": "Beanstock Coffee Roasters",
            "Address": "165 Holmes Rd Unit 2",
            "Website": "https:\/\/beanstockcoffee.com\/",
            "Phone": "508-255-9939",
            "Email": "hello@beanstockcoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/LrQknfze1VFezM9dA",
            "City": "Eastham",
            "Postal Code": "02642",
            "Country": "United States",
            "State": "MA",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:04:07.575+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "MA",
            "Copy of City": "Eastham"
        }
    },
    {
        "id": "i-4c10RAyMER",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-4c10RAyMER",
        "name": "Bean Green",
        "index": "258",
        "createdAt": "2026-02-13T13:02:30.196Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-4c10RAyMER",
        "values": {
            "Store Name": "Bean Green",
            "Address": "Pol.Ind. Alhaurin de la Torre Fase 2 Avenida 9, Nave 69",
            "Website": "https:\/\/bean-green.com\/",
            "Phone": "",
            "Email": "info@bean-green.com",
            "Google Maps Pin": "",
            "City": "Alhaur\u00edn de la Torre",
            "Postal Code": "29130",
            "Country": "Spain",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T20:02:30.196+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Spain",
            "Copy of State": "",
            "Copy of City": "Alhaur\u00edn de la Torre"
        }
    },
    {
        "id": "i-uXZD2iAXW6",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-uXZD2iAXW6",
        "name": "Baristatools.kw",
        "index": "257",
        "createdAt": "2026-02-13T11:38:37.476Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-uXZD2iAXW6",
        "values": {
            "Store Name": "Baristatools.kw",
            "Address": "",
            "Website": "https:\/\/baristatoolskw.com\/",
            "Phone": "",
            "Email": "info@baristatoolskw.com",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Kuwait",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T18:38:37.476+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Kuwait",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-HqzPeNPXnd",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-HqzPeNPXnd",
        "name": "Barista Expert",
        "index": "256",
        "createdAt": "2026-02-13T11:34:45.282Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-HqzPeNPXnd",
        "values": {
            "Store Name": "Barista Expert",
            "Address": "Strada Icoanei 42",
            "Website": "https:\/\/baristaexpert.ro",
            "Phone": "+40 733 931 430",
            "Email": "office@baristaexpert.ro",
            "Google Maps Pin": "",
            "City": "Bucure\u0219ti,",
            "Postal Code": "030167",
            "Country": "Romania",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T18:34:45.282+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Romania",
            "Copy of State": "",
            "Copy of City": "Bucure\u0219ti,"
        }
    },
    {
        "id": "i-a9pqlNCdUh",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-a9pqlNCdUh",
        "name": "Badeta Koffiebranders",
        "index": "255",
        "createdAt": "2026-02-13T11:33:02.311Z",
        "updatedAt": "2026-03-11T14:41:04.903Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-a9pqlNCdUh",
        "values": {
            "Store Name": "Badeta Koffiebranders",
            "Address": "Tweede van der Helststraat 18H",
            "Website": "https:\/\/badeta.nl",
            "Phone": "+31 20 233 1358",
            "Email": "info@badeta.nl",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/MJHjLXJ4D76GoeVo6",
            "City": "Amsterdam",
            "Postal Code": "1072 PD",
            "Country": "Netherlands",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:41:04.903+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T18:33:02.311+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Netherlands",
            "Copy of State": "",
            "Copy of City": "Amsterdam"
        }
    },
    {
        "id": "i-YDLdmyIikJ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-YDLdmyIikJ",
        "name": "Bad Artist Coffee",
        "index": "254",
        "createdAt": "2026-02-13T11:31:28.475Z",
        "updatedAt": "2026-03-23T14:58:07.190Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-YDLdmyIikJ",
        "values": {
            "Store Name": "Bad Artist Coffee",
            "Address": "10a, Jalan SS 2\/10, SS 2",
            "Website": "https:\/\/badartistcoffee.com",
            "Phone": "",
            "Email": "badartistcoffee@gmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/wuW7dFk3LztxmPD26",
            "City": "Petaling Jaya",
            "Postal Code": "47300",
            "Country": "Malaysia",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:58:07.190+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T18:31:28.475+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Malaysia",
            "Copy of State": "",
            "Copy of City": "Petaling Jaya"
        }
    },
    {
        "id": "i-DrwPsYwRpf",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-DrwPsYwRpf",
        "name": "Arista Lab",
        "index": "253",
        "createdAt": "2026-02-13T11:29:41.130Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-DrwPsYwRpf",
        "values": {
            "Store Name": "Arista Lab",
            "Address": "",
            "Website": "",
            "Phone": "408-547-5500",
            "Email": "info@arista.com",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "United States",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T18:29:41.130+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-OaZIBUtT7W",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-OaZIBUtT7W",
        "name": "Anodyne Coffee Roasting Co.",
        "index": "252",
        "createdAt": "2026-02-13T11:28:26.501Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-OaZIBUtT7W",
        "values": {
            "Store Name": "Anodyne Coffee Roasting Co.",
            "Address": "224 W Bruce St",
            "Website": "https:\/\/anodynecoffee.com\/",
            "Phone": "414-763-1143",
            "Email": "erica@anodynecoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/5KNtva6WT5g2VJmw5",
            "City": "Milwaukee",
            "Postal Code": "53204",
            "Country": "United States",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T18:28:26.501+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "",
            "Copy of City": "Milwaukee"
        }
    },
    {
        "id": "i-bQt7D6BRd2",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-bQt7D6BRd2",
        "name": "Ametora Matcha",
        "index": "308",
        "createdAt": "2026-02-13T11:14:24.994Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-bQt7D6BRd2",
        "values": {
            "Store Name": "Ametora Matcha",
            "Address": "",
            "Website": "https:\/\/ametoramatcha.com",
            "Phone": "",
            "Email": "ametoravintage@gmail.com",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "United States",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T18:14:24.994+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-4KjyhWAZRW",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-4KjyhWAZRW",
        "name": "Almenhaz Coffee Supply",
        "index": "251",
        "createdAt": "2026-02-13T11:14:23.680Z",
        "updatedAt": "2026-04-07T14:33:54.264Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-4KjyhWAZRW",
        "values": {
            "Store Name": "Almenhaz Coffee Supply",
            "Address": "Al Nahyan \u2013 E20\u201101 Zayed Educational Campus \/ 37 Al Rijaybah Street",
            "Website": "almenhaz.com",
            "Phone": "+971 2 444 1130",
            "Email": "info@almenhaz.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/YNmzWwZujzs7WKVt9",
            "City": "Abu Dhabi",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:33:54.264+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T18:14:23.680+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Abu Dhabi"
        }
    },
    {
        "id": "i-0pduERLe6E",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-0pduERLe6E",
        "name": "ALMANEGRA",
        "index": "250",
        "createdAt": "2026-02-13T11:08:58.920Z",
        "updatedAt": "2026-04-07T14:31:57.574Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-0pduERLe6E",
        "values": {
            "Store Name": "ALMANEGRA",
            "Address": "Av. Universidad 420\u2011A, Narvarte Poniente, Benito Ju\u00e1rez",
            "Website": "almanegracafe.mx",
            "Phone": "+52 55 4162 5899",
            "Email": "info@almanegracafe.mx",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/4LeEweWfFrJVzfWRA",
            "City": "Mexico",
            "Postal Code": "03023",
            "Country": "Mexico",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:31:57.574+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T18:08:58.920+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Mexico",
            "Copy of State": "",
            "Copy of City": "Mexico"
        }
    },
    {
        "id": "i-OOEHrDtII7",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-OOEHrDtII7",
        "name": "ALL GOOD S.A.",
        "index": "249",
        "createdAt": "2026-02-13T11:05:11.442Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-OOEHrDtII7",
        "values": {
            "Store Name": "ALL GOOD S.A.",
            "Address": "UL. Mazowiecka 24I \/ U9",
            "Website": "www.coffeedesk.com",
            "Phone": "+48 730 88 25 25",
            "Email": "sklep@coffeedesk.pl",
            "Google Maps Pin": "",
            "City": "Ko\u0142obrzeg",
            "Postal Code": "78-100",
            "Country": "Poland",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T18:05:11.442+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Poland",
            "Copy of State": "",
            "Copy of City": "Ko\u0142obrzeg"
        }
    },
    {
        "id": "i-MDGDixkTwP",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-MDGDixkTwP",
        "name": "Alcor Invest 2000 S.R.L.",
        "index": "248",
        "createdAt": "2026-02-13T11:05:04.921Z",
        "updatedAt": "2026-04-07T14:11:43.883Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-MDGDixkTwP",
        "values": {
            "Store Name": "Alcor Invest 2000 S.R.L.",
            "Address": "Str. Baicului 82, Sector 2",
            "Website": "http:\/\/www.alcor\u2011holding.ro\/",
            "Phone": "+40 021 321 68 52",
            "Email": "adrian.neagu@alcor-holding.ro",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/8GDKVnD3YszyXdfz5",
            "City": "Bucharest",
            "Postal Code": "021784",
            "Country": "Romania",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:11:43.883+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T18:05:04.921+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Romania",
            "Copy of State": "",
            "Copy of City": "Bucharest"
        }
    },
    {
        "id": "i-LwS1KQtIQ_",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-LwS1KQtIQ_",
        "name": "AKULOV & TUNSKYY LDA (94\u00b0)",
        "index": "247",
        "createdAt": "2026-02-13T10:03:30.218Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-LwS1KQtIQ_",
        "values": {
            "Store Name": "AKULOV & TUNSKYY LDA (94\u00b0)",
            "Address": "Rua Jos\u00e9 Relvas 32, 1\u00ba DTO",
            "Website": "",
            "Phone": "",
            "Email": "illiaakulov@gmail.com",
            "Google Maps Pin": "",
            "City": "Lisboa",
            "Postal Code": "1900\u2011284",
            "Country": "Portugal",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T17:03:30.218+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Portugal",
            "Copy of State": "",
            "Copy of City": "Lisboa"
        }
    },
    {
        "id": "i-BRu0f8kNGG",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-BRu0f8kNGG",
        "name": "Akronym UK Limited",
        "index": "246",
        "createdAt": "2026-02-13T09:45:39.455Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-BRu0f8kNGG",
        "values": {
            "Store Name": "Akronym UK Limited",
            "Address": "International House, 64 Nile Street",
            "Website": "",
            "Phone": "",
            "Email": "rochelle@drinkmorning.com",
            "Google Maps Pin": "",
            "City": "London",
            "Postal Code": "N1 7SR",
            "Country": "United Kingdom",
            "State": "",
            "Created by": "Jason Patrick",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-02-13T16:45:39.455+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Kingdom",
            "Copy of State": "",
            "Copy of City": "London"
        }
    },
    {
        "id": "i-mMDivnSOOa",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-mMDivnSOOa",
        "name": "Mad About Coffee and Tea",
        "index": "0",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:25:09.891Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-mMDivnSOOa",
        "values": {
            "Store Name": "Mad About Coffee and Tea",
            "Address": "Shop 2\/3 Parap Place",
            "Website": "https:\/\/www.madaboutcoffeeandtea.com\/",
            "Phone": "",
            "Email": "madaboutcoffeeandtea@gmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/jokgpAzrnRs3sPhJ6",
            "City": "Parap",
            "Postal Code": "0820",
            "Country": "Australia",
            "State": "Northern Territory",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:25:09.891+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "Australia",
            "New City": "Parap",
            "New State": "Northern Territory",
            "Copy of Country": "Australia",
            "Copy of State": "Northern Territory",
            "Copy of City": "Parap"
        }
    },
    {
        "id": "i-5zagt8VlVR",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-5zagt8VlVR",
        "name": "Image Coffee",
        "index": "23",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-5zagt8VlVR",
        "values": {
            "Store Name": "Image Coffee",
            "Address": "United States",
            "Website": "https:\/\/image.coffee\/",
            "Phone": "",
            "Email": "info@image.coffee",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "United States",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Online Store",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-UCgr1lIGEH",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-UCgr1lIGEH",
        "name": "Ziptac",
        "index": "24",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-UCgr1lIGEH",
        "values": {
            "Store Name": "Ziptac",
            "Address": "",
            "Website": "https:\/\/www.ziptac.com.au\/",
            "Phone": "",
            "Email": "dewy@ziptac.com.au",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-O8bLzFImkq",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-O8bLzFImkq",
        "name": "NYUAD COFFEE SHOP",
        "index": "25",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-O8bLzFImkq",
        "values": {
            "Store Name": "NYUAD COFFEE SHOP",
            "Address": "",
            "Website": "www.blacksmith.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Abu Dhabi",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Abu Dhabi"
        }
    },
    {
        "id": "i-5Kkeqw8hSi",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-5Kkeqw8hSi",
        "name": "Benki Brewing Tools",
        "index": "26",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-11T14:48:53.731Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-5Kkeqw8hSi",
        "values": {
            "Store Name": "Benki Brewing Tools",
            "Address": "No.15, 37th B Cross, 9th A Main Rd, 4th Block, 5th Block, Jayanagar",
            "Website": "https:\/\/www.benkibrewingtools.com\/",
            "Phone": "919663270520",
            "Email": "crm@benkibrewingtools.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/HCL9uB9otczRedie9",
            "City": "Bengaluru",
            "Postal Code": "560041",
            "Country": "India",
            "State": "Karnataka",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:48:53.731+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Benki",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "India",
            "Copy of State": "Karnataka",
            "Copy of City": "Bengaluru"
        }
    },
    {
        "id": "i-UhXGULKcco",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-UhXGULKcco",
        "name": "Virgin Megastore Mecca HHR Station",
        "index": "27",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-12T15:03:04.763Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-UhXGULKcco",
        "values": {
            "Store Name": "Virgin Megastore Mecca HHR Station",
            "Address": "Makkah Haramain High-Speed Railway (HHR) Station",
            "Website": "www.virginmegastore.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/XeaS2aePSYR6qhvD9",
            "City": "Mecca",
            "Postal Code": "",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T22:03:04.763+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Mecca"
        }
    },
    {
        "id": "i-Lkzs2PO9Ru",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Lkzs2PO9Ru",
        "name": "Virgin Megastore Mercato Mall",
        "index": "28",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Lkzs2PO9Ru",
        "values": {
            "Store Name": "Virgin Megastore Mercato Mall",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-4vdlrskTmr",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-4vdlrskTmr",
        "name": "Eko kapsule",
        "index": "29",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-11T14:55:02.749Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-4vdlrskTmr",
        "values": {
            "Store Name": "Eko kapsule",
            "Address": "B\u00fadkov\u00e1 22",
            "Website": "https:\/\/www.ekokapsule.sk\/subminimal-brand",
            "Phone": "421.944.750.100",
            "Email": "info@ekokapsule.sk",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/XDGUzcnCtudELWM18",
            "City": "Bratislava",
            "Postal Code": "81104",
            "Country": "Slovakia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:55:02.749+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "The God Shot",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Slovakia",
            "Copy of State": "",
            "Copy of City": "Ko\u0161ice"
        }
    },
    {
        "id": "i-fuPUJ2SgSp",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-fuPUJ2SgSp",
        "name": "Virgin Megastore YAS Mall",
        "index": "30",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-fuPUJ2SgSp",
        "values": {
            "Store Name": "Virgin Megastore YAS Mall",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-FRFzbJ03hy",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-FRFzbJ03hy",
        "name": "OTLMALL",
        "index": "31",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-FRFzbJ03hy",
        "values": {
            "Store Name": "OTLMALL",
            "Address": "143A-B, 1\/F, MOKO, Mong Kok",
            "Website": "www.otlmall.com",
            "Phone": "9157 5245",
            "Email": "sales@otlmall.com",
            "Google Maps Pin": "",
            "City": "Mong Kok",
            "Postal Code": "",
            "Country": "Hong Kong",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Hong Kong",
            "Copy of State": "",
            "Copy of City": "Mong Kok"
        }
    },
    {
        "id": "i-4SdMzLWzyK",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-4SdMzLWzyK",
        "name": "Franklin Inc.",
        "index": "32",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-4SdMzLWzyK",
        "values": {
            "Store Name": "Franklin Inc.",
            "Address": "#403, 5-9 Kanayamacho",
            "Website": "https:\/\/subminimal.tokyo",
            "Phone": "5032000595",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Kawaguchi",
            "Postal Code": "332-0014",
            "Country": "Japan",
            "State": "Saitama-Ken",
            "Created by": "Dominic Symons",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Franklin",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Japan",
            "Copy of State": "Saitama-Ken",
            "Copy of City": "Kawaguchi"
        }
    },
    {
        "id": "i-rPbujSu16-",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-rPbujSu16-",
        "name": "Virgin Megastore Villaggio",
        "index": "33",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-12T14:50:44.482Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-rPbujSu16-",
        "values": {
            "Store Name": "Virgin Megastore Villaggio",
            "Address": "Vilaggio Mall, Al Waab St,",
            "Website": "www.virginmegastore.qa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/iMBsXAjr61fCWWdD8",
            "City": "Doha",
            "Postal Code": "",
            "Country": "Qatar",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T21:50:44.482+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Qatar",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-hnmKcZZf2w",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-hnmKcZZf2w",
        "name": "Virgin Megastore The Dubai Mall",
        "index": "34",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-hnmKcZZf2w",
        "values": {
            "Store Name": "Virgin Megastore The Dubai Mall",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-y0LooYC0VW",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-y0LooYC0VW",
        "name": "Cirelli Coffee Roasting Co",
        "index": "35",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:45:34.943Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-y0LooYC0VW",
        "values": {
            "Store Name": "Cirelli Coffee Roasting Co",
            "Address": "568 Port Road",
            "Website": "https:\/\/www.cirellicoffee.com.au\/",
            "Phone": "",
            "Email": "enquiries@cirellicoffee.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/rxK1Ne6etxJPBB5UA",
            "City": "Allenby Gardens",
            "Postal Code": "5009",
            "Country": "Australia",
            "State": "South Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:45:34.943+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "South Australia",
            "Copy of City": "Allenby Gardens"
        }
    },
    {
        "id": "i-ra4nPTeNz_",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ra4nPTeNz_",
        "name": "The Barista House",
        "index": "36",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ra4nPTeNz_",
        "values": {
            "Store Name": "The Barista House",
            "Address": "",
            "Website": "https:\/\/thebaristahouse.com.au\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-kfzQW6JLZe",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-kfzQW6JLZe",
        "name": "Inka Coffee",
        "index": "37",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-kfzQW6JLZe",
        "values": {
            "Store Name": "Inka Coffee",
            "Address": "Eumundi Parkside Market, 90-92 Memorial Dr",
            "Website": "https:\/\/inkacoffee.com.au\/",
            "Phone": "",
            "Email": "barista@eumundiholeinthewallcoffee.com.au",
            "Google Maps Pin": "",
            "City": "Eumundi",
            "Postal Code": "4562",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Queensland",
            "Copy of City": "Eumundi"
        }
    },
    {
        "id": "i-_bmlfv_uH3",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-_bmlfv_uH3",
        "name": "Fika Cafe",
        "index": "38",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-_bmlfv_uH3",
        "values": {
            "Store Name": "Fika Cafe",
            "Address": "28 Kensington Avenue",
            "Website": "http:\/\/www.fika.ca",
            "Phone": "",
            "Email": "info@fika.ca",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/5wYjQBXrZZHkQR7c9",
            "City": "Toronto",
            "Postal Code": "M5T 2J9",
            "Country": "Canada",
            "State": "Ontario",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Ontario",
            "Copy of City": "Toronto"
        }
    },
    {
        "id": "i-IxAEzB4FmF",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-IxAEzB4FmF",
        "name": "Industry Beans- Fitzroy Caf\u00e9",
        "index": "39",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:01:06.881Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-IxAEzB4FmF",
        "values": {
            "Store Name": "Industry Beans- Fitzroy Caf\u00e9",
            "Address": "70-76 Westgarth Street",
            "Website": "https:\/\/industrybeans.com\/",
            "Phone": "",
            "Email": "fitzroy@industrybeans.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/RmGxsp8jFT54iBgy5",
            "City": "Fitzroy",
            "Postal Code": "3065",
            "Country": "Australia",
            "State": "Victoria",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:01:06.881+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Victoria",
            "Copy of City": "Fitzroy"
        }
    },
    {
        "id": "i-BnuIZxyXxd",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-BnuIZxyXxd",
        "name": "Van Pommeren",
        "index": "40",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-11T14:46:38.324Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-BnuIZxyXxd",
        "values": {
            "Store Name": "Van Pommeren",
            "Address": "Lijnmarkt 47",
            "Website": "https:\/\/www.vanpommeren.nl\/Subminimal",
            "Phone": "320302316769",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/aPx9WLkJg6vHVZyo7",
            "City": "Utrecht",
            "Postal Code": "3511 KG",
            "Country": "Netherlands",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:46:38.324+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "The God Shot",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Netherlands",
            "Copy of State": "",
            "Copy of City": "Utrecht"
        }
    },
    {
        "id": "i-RK-5JGl_Ll",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-RK-5JGl_Ll",
        "name": "Little House Coffee Company",
        "index": "41",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:17:33.931Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-RK-5JGl_Ll",
        "values": {
            "Store Name": "Little House Coffee Company",
            "Address": "14\/46-48 Abel St",
            "Website": "https:\/\/littlehousecoffeeco.com.au\/",
            "Phone": "",
            "Email": "littlehousecoffeeco@gmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/KTq5r2GDfKK99FC1A",
            "City": "Jamisontown",
            "Postal Code": "2750",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:17:33.931+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Jamisontown"
        }
    },
    {
        "id": "i-hi6AgSqcuR",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-hi6AgSqcuR",
        "name": "MODERN HOMES",
        "index": "42",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-11T14:59:43.222Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-hi6AgSqcuR",
        "values": {
            "Store Name": "MODERN HOMES",
            "Address": "Al Maha Center, Salwa Rd",
            "Website": "www.51east.com",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/HKXVwG8XzNdw9dgC8",
            "City": "Doha",
            "Postal Code": "",
            "Country": "Qatar",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:59:43.222+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Qatar",
            "Copy of State": "",
            "Copy of City": "Doha"
        }
    },
    {
        "id": "i-qyzvDOQO0S",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-qyzvDOQO0S",
        "name": "CENTRAL RAMA III",
        "index": "43",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:43:49.765Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-qyzvDOQO0S",
        "values": {
            "Store Name": "CENTRAL RAMA III",
            "Address": "79\/3 Sathupradit Road, Chongnonsee, Yannawa",
            "Website": "www.central.co.th",
            "Phone": "66026735555",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/cd37uguKZ3kHAnoL6",
            "City": "Bangkok",
            "Postal Code": "10120",
            "Country": "Thailand",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:43:49.765+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "DOTBKK",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Thailand",
            "Copy of State": "",
            "Copy of City": "Bangkok"
        }
    },
    {
        "id": "i-RhgKo7TFuu",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-RhgKo7TFuu",
        "name": "Everything Kitchen",
        "index": "44",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T12:59:15.324Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-RhgKo7TFuu",
        "values": {
            "Store Name": "Everything Kitchen",
            "Address": "Shop 1043, Level 1 Westfield Bondi Junction, 500 Oxford Street, Bondi Junction",
            "Website": "https:\/\/everything-kitchen.com.au\/",
            "Phone": "(02) 93892351",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/dFSWDEoDyF8ZPQkN6",
            "City": "Sydney",
            "Postal Code": "2022",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T19:59:15.324+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Sydney"
        }
    },
    {
        "id": "i-ApDTMfv7As",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ApDTMfv7As",
        "name": "Coffee Circle",
        "index": "45",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ApDTMfv7As",
        "values": {
            "Store Name": "Coffee Circle",
            "Address": "Lindower Str. 18,",
            "Website": "https:\/\/www.coffeecircle.com\/de\/p\/subminimal-nanofoamer",
            "Phone": "",
            "Email": "info@coffeecircle.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/Si8NATNEwyzD55tm8",
            "City": "Berlin",
            "Postal Code": "13347",
            "Country": "Germany",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Berlin"
        }
    },
    {
        "id": "i-bIRHQnotPd",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-bIRHQnotPd",
        "name": "Virgin Megastore Ibn Battuta Mall",
        "index": "46",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-bIRHQnotPd",
        "values": {
            "Store Name": "Virgin Megastore Ibn Battuta Mall",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-OQdfV26I5Z",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-OQdfV26I5Z",
        "name": "The God Shot",
        "index": "47",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:53:06.006Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-OQdfV26I5Z",
        "values": {
            "Store Name": "The God Shot",
            "Address": "Vuurkruisenlaan 4,",
            "Website": "www.thegodshot.be",
            "Phone": "",
            "Email": "Info@thegodshot.be",
            "Google Maps Pin": "https:\/\/share.google\/QqHHFBP5ZsQaiTDLD",
            "City": "Hasselt",
            "Postal Code": "3500",
            "Country": "Belgium",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Distributor,Online Store",
            "Modified": "2026-03-23T21:53:06.006+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "The God Shot",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Distributor, Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Belgium",
            "Copy of State": "",
            "Copy of City": "Hasselt"
        }
    },
    {
        "id": "i-bf4cGF4W90",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-bf4cGF4W90",
        "name": "SULALAT COFFEE TRADING EST.",
        "index": "48",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-12T14:59:32.635Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-bf4cGF4W90",
        "values": {
            "Store Name": "SULALAT COFFEE TRADING EST.",
            "Address": "2329 Makkah Al Mukarramah Branch Road Store #2 Ground floor, Najm al Qurais Building",
            "Website": "www.sulalat.com",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/dNwmZ4f8U29cEJnd8",
            "City": "Riyadh",
            "Postal Code": "12821",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T21:59:32.635+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Riyadh"
        }
    },
    {
        "id": "i-7rkSkUAth-",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-7rkSkUAth-",
        "name": "Jokoka",
        "index": "49",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-7rkSkUAth-",
        "values": {
            "Store Name": "Jokoka",
            "Address": "Online",
            "Website": "",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Online Store",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-wV35Snmo31",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-wV35Snmo31",
        "name": "Yardsale Trading Co.",
        "index": "50",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:46:15.168Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-wV35Snmo31",
        "values": {
            "Store Name": "Yardsale Trading Co.",
            "Address": "94 Maitland Rd",
            "Website": "https:\/\/yardsaletradingco.com\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/9CiXRzLYSxaEJp538",
            "City": "Islington",
            "Postal Code": "2296",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:46:15.168+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Islington"
        }
    },
    {
        "id": "i-pETi83VPja",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-pETi83VPja",
        "name": "kafes barista",
        "index": "51",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-pETi83VPja",
        "values": {
            "Store Name": "kafes barista",
            "Address": "Parodos Sof.Venizelou",
            "Website": "http:\/\/www.kafesbarista.gr\/subminimal-brand",
            "Phone": "",
            "Email": "info@kafesbarista.gr",
            "Google Maps Pin": "",
            "City": "Thessaloniki",
            "Postal Code": "54628",
            "Country": "Greece",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "The God Shot",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Greece",
            "Copy of State": "",
            "Copy of City": "Thessaloniki"
        }
    },
    {
        "id": "i-pZPtNkfOyr",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-pZPtNkfOyr",
        "name": "Amazon Middle East",
        "index": "52",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-pZPtNkfOyr",
        "values": {
            "Store Name": "Amazon Middle East",
            "Address": "",
            "Website": "www.amazon.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-kUp-BtQCcC",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-kUp-BtQCcC",
        "name": "Virgin Megastore Roshana Mall",
        "index": "53",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:14:28.853Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-kUp-BtQCcC",
        "values": {
            "Store Name": "Virgin Megastore Roshana Mall",
            "Address": "Al Tahlia St, Roshana Mall",
            "Website": "www.virginmegastore.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/WmanpbK5jhNJZhCp8",
            "City": "Jeddah",
            "Postal Code": "",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:14:28.853+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Jeddah"
        }
    },
    {
        "id": "i-nNzdVH6FmU",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-nNzdVH6FmU",
        "name": "Muzhan Coffee-Xinzhuang Founding Store",
        "index": "54",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-11T14:19:27.546Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-nNzdVH6FmU",
        "values": {
            "Store Name": "Muzhan Coffee-Xinzhuang Founding Store",
            "Address": "No. 412, Xintai Road Xinzhuang District",
            "Website": "https:\/\/www.muzhan-coffee.com\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/odQi1AWmE4VquRJG7",
            "City": "New Taipei City",
            "Postal Code": "242",
            "Country": "Taiwan",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:19:27.546+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Taiwan",
            "Copy of State": "",
            "Copy of City": "New Taipei City"
        }
    },
    {
        "id": "i-D9Y7vJbDSb",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-D9Y7vJbDSb",
        "name": "Afaq Q Tech",
        "index": "55",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-D9Y7vJbDSb",
        "values": {
            "Store Name": "Afaq Q Tech",
            "Address": "",
            "Website": "www.amazon.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-nKJf-_sy_W",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-nKJf-_sy_W",
        "name": "Adventure Curated",
        "index": "56",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-nKJf-_sy_W",
        "values": {
            "Store Name": "Adventure Curated",
            "Address": "",
            "Website": "https:\/\/adventurecurated.com\/",
            "Phone": "611800953877",
            "Email": "hello@adventurecurated.com",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-LFfnuRTO72",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-LFfnuRTO72",
        "name": "BUILDEX",
        "index": "57",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-LFfnuRTO72",
        "values": {
            "Store Name": "BUILDEX",
            "Address": "",
            "Website": "www.buildexstores.com",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Muscat",
            "Postal Code": "",
            "Country": "Oman",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Oman",
            "Copy of State": "",
            "Copy of City": "Muscat"
        }
    },
    {
        "id": "i-6HPTuh4f9k",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-6HPTuh4f9k",
        "name": "cafe barista",
        "index": "58",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-6HPTuh4f9k",
        "values": {
            "Store Name": "cafe barista",
            "Address": "Rue Ettore BUGATTI",
            "Website": "https:\/\/www.cafebarista.fr\/subminimal-brand",
            "Phone": "",
            "Email": "info@cafebarista.fr",
            "Google Maps Pin": "",
            "City": "Erstein",
            "Postal Code": "67119",
            "Country": "France",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "France",
            "Copy of State": "",
            "Copy of City": "Erstein"
        }
    },
    {
        "id": "i-YN6kTsJKgc",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-YN6kTsJKgc",
        "name": "Cottle Coffee",
        "index": "59",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:52:39.914Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-YN6kTsJKgc",
        "values": {
            "Store Name": "Cottle Coffee",
            "Address": "300 Coventry Street",
            "Website": "https:\/\/www.cottlecoffee.com.au\/",
            "Phone": "610396994121",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/eF4EiMnLbHsXMgNs8",
            "City": "South Melbourne",
            "Postal Code": "3205",
            "Country": "Australia",
            "State": "Victoria",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:52:39.914+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Victoria",
            "Copy of City": "South Melbourne"
        }
    },
    {
        "id": "i-lNDXcgC9Wo",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-lNDXcgC9Wo",
        "name": "Basic Barista",
        "index": "60",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-lNDXcgC9Wo",
        "values": {
            "Store Name": "Basic Barista",
            "Address": "",
            "Website": "https:\/\/thebasicbarista.com\/",
            "Phone": "",
            "Email": "info@thebasicbarista.com",
            "Google Maps Pin": "",
            "City": "Melbourne",
            "Postal Code": "",
            "Country": "Australia",
            "State": "Victoria",
            "Created by": "Dominic Symons",
            "Type editable": "Online Store",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Victoria",
            "Copy of City": "Melbourne"
        }
    },
    {
        "id": "i-tusWexCVCl",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-tusWexCVCl",
        "name": "Industry Beans- Newstead Caf\u00e9 & Roastery",
        "index": "61",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:01:27.323Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-tusWexCVCl",
        "values": {
            "Store Name": "Industry Beans- Newstead Caf\u00e9 & Roastery",
            "Address": "18 Proe Street",
            "Website": "https:\/\/industrybeans.com\/",
            "Phone": "",
            "Email": "newstead@industrybeans.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/bra3m58pqXEtc78SA",
            "City": "Newstead",
            "Postal Code": "4006",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:01:27.323+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Queensland",
            "Copy of City": "Newstead"
        }
    },
    {
        "id": "i-x4akT2xWaT",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-x4akT2xWaT",
        "name": "Benjamin Barker",
        "index": "62",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:50:03.780Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-x4akT2xWaT",
        "values": {
            "Store Name": "Benjamin Barker",
            "Address": "391 Orchard Rd",
            "Website": "https:\/\/www.benjaminbarker.co\/pages\/subminimal?_pos=1&_sid=d374f25c3&_ss=r",
            "Phone": "6562811521",
            "Email": "ECOMMERCE@BENJAMINBARKER.CO",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/4QBF3aceHaN4BSDw7",
            "City": "Singapore",
            "Postal Code": "238872",
            "Country": "Singapore",
            "State": "Singapore",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:50:03.780+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Cowpresso",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Singapore",
            "Copy of State": "Singapore",
            "Copy of City": "Singapore"
        }
    },
    {
        "id": "i-bpbbXFuI9X",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-bpbbXFuI9X",
        "name": "Virgin Megastore Arab Mall",
        "index": "63",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-12T15:00:39.641Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-bpbbXFuI9X",
        "values": {
            "Store Name": "Virgin Megastore Arab Mall",
            "Address": "Madinah Al-Munawarah Rd (An Nuzhah District), Mall of Arabia",
            "Website": "www.virginmegastore.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/FHcHxUYdtTGqxCwXA",
            "City": "Jeddah",
            "Postal Code": "",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T22:00:39.641+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Jeddah"
        }
    },
    {
        "id": "i-pf-X_J1-F1",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-pf-X_J1-F1",
        "name": "Virgin Megastore Mirdif City Centre",
        "index": "64",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-pf-X_J1-F1",
        "values": {
            "Store Name": "Virgin Megastore Mirdif City Centre",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-12EUc5346-",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-12EUc5346-",
        "name": "Caf\u00e9 Le Rack \u00e0 B\u00e9cik",
        "index": "65",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-12EUc5346-",
        "values": {
            "Store Name": "Caf\u00e9 Le Rack \u00e0 B\u00e9cik",
            "Address": "6700 Place des Miliciens",
            "Website": "https:\/\/www.lafbike.com\/cafe\/",
            "Phone": "",
            "Email": "info@cafelerackabecik.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/PYsYmcUqCXwNjXJ96",
            "City": "Trois-Rivi\u00e8res",
            "Postal Code": "G9A\u202f5C9",
            "Country": "Canada",
            "State": "Quebec",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Quebec",
            "Copy of City": "Trois-Rivi\u00e8res"
        }
    },
    {
        "id": "i-18NUqs7dvW",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-18NUqs7dvW",
        "name": "Br\u00fblerie du Quai",
        "index": "66",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-18NUqs7dvW",
        "values": {
            "Store Name": "Br\u00fblerie du Quai",
            "Address": "200 rue du Quai",
            "Website": "www.brulerieduquai.com",
            "Phone": "",
            "Email": "info@brulerieduquai.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/cXAhHrYfJm8kx2KQ9",
            "City": "Carleton",
            "Postal Code": "G0C 1J0",
            "Country": "Canada",
            "State": "Quebec",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Quebec",
            "Copy of City": "Carleton"
        }
    },
    {
        "id": "i-e38ByHKVpo",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-e38ByHKVpo",
        "name": "Virgin Megastore Reem Island Mall",
        "index": "67",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-e38ByHKVpo",
        "values": {
            "Store Name": "Virgin Megastore Reem Island Mall",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-xLxxU9AMJ7",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-xLxxU9AMJ7",
        "name": "Lonsdale Street Roasters",
        "index": "68",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:24:24.847Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-xLxxU9AMJ7",
        "values": {
            "Store Name": "Lonsdale Street Roasters",
            "Address": "4\/23 Lonsdale St",
            "Website": "https:\/\/lonsdalestreetroasters.com\/",
            "Phone": "261083661",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/rzZPZZFSktwHL1E97",
            "City": "Canberra",
            "Postal Code": "2612",
            "Country": "Australia",
            "State": "Australian Capital Territory",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:24:24.847+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Australian Capital Territory",
            "Copy of City": "Canberra"
        }
    },
    {
        "id": "i-DV17zlXKK9",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-DV17zlXKK9",
        "name": "Cafun\u00e9 Boutique",
        "index": "69",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-DV17zlXKK9",
        "values": {
            "Store Name": "Cafun\u00e9 Boutique",
            "Address": "7080 Rue Alexandra",
            "Website": "www.cafune.ca",
            "Phone": "",
            "Email": "home@cafune.ca",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/Mjmq7fTa2yHQ9Bxz8",
            "City": "Montreal",
            "Postal Code": "H2S 3J5",
            "Country": "Canada",
            "State": "Quebec",
            "Created by": "Dominic Symons",
            "Type editable": "Distributor,Online Store",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Cafune",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Distributor, Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Quebec",
            "Copy of City": "Montreal"
        }
    },
    {
        "id": "i-1_OO_28vDL",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-1_OO_28vDL",
        "name": "Java Gourmet",
        "index": "70",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-1_OO_28vDL",
        "values": {
            "Store Name": "Java Gourmet",
            "Address": "",
            "Website": "https:\/\/javagourmet.com.au\/",
            "Phone": "611300780871",
            "Email": "doug@javagourmet.com.au",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-rsRFCQ6_B6",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-rsRFCQ6_B6",
        "name": "Melvourni",
        "index": "71",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-rsRFCQ6_B6",
        "values": {
            "Store Name": "Melvourni",
            "Address": "",
            "Website": "https:\/\/www.melvourni.com\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-QMVaBxTeFB",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-QMVaBxTeFB",
        "name": "Anthony\u2019s Espresso Equipment",
        "index": "72",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-QMVaBxTeFB",
        "values": {
            "Store Name": "Anthony\u2019s Espresso Equipment",
            "Address": "3200 Dufferin Street, Unit 11",
            "Website": "www.anthonysespresso.com",
            "Phone": "14167830555",
            "Email": "info@anthonysespresso.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/PX36gs2UYv2pjqxi7",
            "City": "Toronto",
            "Postal Code": "M6A 3B2",
            "Country": "Canada",
            "State": "Ontario",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Ontario",
            "Copy of City": "Toronto"
        }
    },
    {
        "id": "i-An-HKprQaz",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-An-HKprQaz",
        "name": "Aslan Coffee",
        "index": "73",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-An-HKprQaz",
        "values": {
            "Store Name": "Aslan Coffee",
            "Address": "",
            "Website": "https:\/\/www.aslancoffee.com.au\/",
            "Phone": "",
            "Email": "aslan@aslancoffee.com.au",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-UjwCc5WfSI",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-UjwCc5WfSI",
        "name": "Central Coast Coffee",
        "index": "74",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:43:44.003Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-UjwCc5WfSI",
        "values": {
            "Store Name": "Central Coast Coffee",
            "Address": "1\/80 Somersby Falls Road",
            "Website": "https:\/\/www.centralcoastcoffee.com.au\/collections\/subminimal",
            "Phone": "",
            "Email": "sales@centralcoastcoffee.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/NpFE43azn3josbfx7",
            "City": "Somersby",
            "Postal Code": "2250",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:43:44.003+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Somersby"
        }
    },
    {
        "id": "i-WiXT79skV6",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-WiXT79skV6",
        "name": "Ningaloo Roast",
        "index": "75",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:34:33.543Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-WiXT79skV6",
        "values": {
            "Store Name": "Ningaloo Roast",
            "Address": "71 Olivia Terrace,",
            "Website": "https:\/\/www.ningalooroast.com.au\/",
            "Phone": "",
            "Email": "donna@ningalooroast.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/FGfuCSeRMjJRhtbQ6",
            "City": "Carnarvon",
            "Postal Code": "6701",
            "Country": "Australia",
            "State": "Western Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:34:33.543+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-8wWeodA1nu",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-8wWeodA1nu",
        "name": "Coffee Craft \/ Patio Coffee Roasters",
        "index": "76",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:49:47.127Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-8wWeodA1nu",
        "values": {
            "Store Name": "Coffee Craft \/ Patio Coffee Roasters",
            "Address": "217-219 Richmond Rd",
            "Website": "https:\/\/patiocoffee.com.au\/",
            "Phone": "",
            "Email": "hello@patiocoffee.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/EMw2pgTcj3mgAMuS7",
            "City": "Richmond",
            "Postal Code": "5033",
            "Country": "Australia",
            "State": "South Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:49:47.127+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "South Australia",
            "Copy of City": "Glandore"
        }
    },
    {
        "id": "i-NGrFYYP1b-",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-NGrFYYP1b-",
        "name": "NAMSHI",
        "index": "77",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:35:20.490Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-NGrFYYP1b-",
        "values": {
            "Store Name": "NAMSHI",
            "Address": "Unit 3219-2-3, Emaar Gold & Diamond Park",
            "Website": "www.namshi.com",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/yT9GaJjoNWquSpBNA",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:35:20.490+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-j3eU9qzV8x",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-j3eU9qzV8x",
        "name": "RV Online",
        "index": "78",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-j3eU9qzV8x",
        "values": {
            "Store Name": "RV Online",
            "Address": "",
            "Website": "https:\/\/www.rvonline.com.au\/",
            "Phone": "1300 05 2020",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-SoseMBFSoz",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-SoseMBFSoz",
        "name": "Benjamin Barker",
        "index": "79",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:51:36.094Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-SoseMBFSoz",
        "values": {
            "Store Name": "Benjamin Barker",
            "Address": "Temasek Blvd",
            "Website": "https:\/\/www.benjaminbarker.co\/pages\/subminimal?_pos=1&_sid=d374f25c3&_ss=r",
            "Phone": "6562811521",
            "Email": "ECOMMERCE@BENJAMINBARKER.CO",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/7EtGKxQmW3SW2yaD6",
            "City": "Singapore",
            "Postal Code": "",
            "Country": "Singapore",
            "State": "Singapore",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:51:36.094+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Cowpresso",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Singapore",
            "Copy of State": "Singapore",
            "Copy of City": "Singapore"
        }
    },
    {
        "id": "i-agVqMcHF9x",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-agVqMcHF9x",
        "name": "Virgin Megastore Al Maryah Island",
        "index": "80",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-agVqMcHF9x",
        "values": {
            "Store Name": "Virgin Megastore Al Maryah Island",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-dFpfcO5dGw",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-dFpfcO5dGw",
        "name": "Virgin Megastore Riyadh Boulevard - Times Square",
        "index": "81",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:09:09.015Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-dFpfcO5dGw",
        "values": {
            "Store Name": "Virgin Megastore Riyadh Boulevard - Times Square",
            "Address": "",
            "Website": "www.virginmegastore.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/Zgkeibw1bZUrftnz8",
            "City": "Riyadh",
            "Postal Code": "",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:09:09.015+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Riyadh"
        }
    },
    {
        "id": "i-EmbNoS9D0e",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-EmbNoS9D0e",
        "name": "Tinka Coffee Brewers",
        "index": "82",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:38:04.070Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-EmbNoS9D0e",
        "values": {
            "Store Name": "Tinka Coffee Brewers",
            "Address": "147 St John Street",
            "Website": "https:\/\/www.tinkacoffeebrewers.com.au\/",
            "Phone": "",
            "Email": "hello@tinkacoffeebrewers.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/AHKaRXKY5w2d3Q6a7",
            "City": "Launceston",
            "Postal Code": "7250",
            "Country": "Australia",
            "State": "Tasmania",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:38:04.070+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Tasmania",
            "Copy of City": "Launceston"
        }
    },
    {
        "id": "i-T11zdz4jPa",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-T11zdz4jPa",
        "name": "Virgin Megastore Dammam Airport",
        "index": "83",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-12T15:02:23.997Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-T11zdz4jPa",
        "values": {
            "Store Name": "Virgin Megastore Dammam Airport",
            "Address": "King Fahd International Airport (DMM)",
            "Website": "www.virginmegastore.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/u4Y5ZUF9iBHMq3819",
            "City": "Dammam",
            "Postal Code": "",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T22:02:23.997+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Dammam"
        }
    },
    {
        "id": "i-R4GrodvKlX",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-R4GrodvKlX",
        "name": "White Horse Coffee",
        "index": "84",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:41:25.732Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-R4GrodvKlX",
        "values": {
            "Store Name": "White Horse Coffee",
            "Address": "Unit 10\/44-46 Flora St",
            "Website": "https:\/\/whitehorsecoffee.com.au\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/Mp4RRBtsPTMxPLCx5",
            "City": "Kirrawee",
            "Postal Code": "2232",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:41:25.732+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-Ju2wDzX-dA",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Ju2wDzX-dA",
        "name": "Coffee Plus",
        "index": "85",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:51:21.870Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Ju2wDzX-dA",
        "values": {
            "Store Name": "Coffee Plus",
            "Address": "Shop 308, Centrepoint Shopping Centre, 70 Murray Street",
            "Website": "https:\/\/coffeeplus.com.au\/",
            "Phone": "",
            "Email": "sales@coffeeplus.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/gFxfFhyv2MvkXT7B6",
            "City": "Hobart",
            "Postal Code": "7000",
            "Country": "Australia",
            "State": "Tasmania",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:51:21.870+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Tasmania",
            "Copy of City": "Hobart"
        }
    },
    {
        "id": "i-JF3oJ1gbbg",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-JF3oJ1gbbg",
        "name": "CENTRAL CHIDLOM",
        "index": "86",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:29:22.371Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-JF3oJ1gbbg",
        "values": {
            "Store Name": "CENTRAL CHIDLOM",
            "Address": "1027 Phloen Chit Road, Lumphini, Pathum Wan",
            "Website": "www.contral.co.th",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/2BQhuuSzfhcJhgGo7",
            "City": "Bangkok",
            "Postal Code": "10330",
            "Country": "Thailand",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:29:22.371+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "DOTBKK",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Thailand",
            "Copy of State": "",
            "Copy of City": "Bangkok"
        }
    },
    {
        "id": "i-8ABe-RIa6G",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-8ABe-RIa6G",
        "name": "Neli Coffee",
        "index": "87",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:27:42.601Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-8ABe-RIa6G",
        "values": {
            "Store Name": "Neli Coffee",
            "Address": "Units 1&4\/293 MacDonnell Rd",
            "Website": "https:\/\/nelicoffee.com.au\/",
            "Phone": "610732849909",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/uBQVZ7UDqbB6z17s5",
            "City": "Clontarf",
            "Postal Code": "4019",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:27:42.601+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Queensland",
            "Copy of City": "Clontarf"
        }
    },
    {
        "id": "i-nAaJPQlSoO",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-nAaJPQlSoO",
        "name": "Alabama Sweet Home",
        "index": "88",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-nAaJPQlSoO",
        "values": {
            "Store Name": "Alabama Sweet Home",
            "Address": "Florastrasse 1",
            "Website": "www.alabama-online.ch",
            "Phone": "",
            "Email": "shop@alabama-online.ch",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/7346ozWSVoCC6QpFA",
            "City": "Biel\/Bienne",
            "Postal Code": "2502",
            "Country": "Switzerland",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Coaching Club",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Switzerland",
            "Copy of State": "",
            "Copy of City": "Biel\/Bienne"
        }
    },
    {
        "id": "i-C6oPVBuEjP",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-C6oPVBuEjP",
        "name": "AL QUOZ ROASTERY AND COFFEE SHOP",
        "index": "89",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-C6oPVBuEjP",
        "values": {
            "Store Name": "AL QUOZ ROASTERY AND COFFEE SHOP",
            "Address": "",
            "Website": "www.blacksmith.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Abu Dhabi",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Abu Dhabi"
        }
    },
    {
        "id": "i-UMO2K6i6mt",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-UMO2K6i6mt",
        "name": "Simply Coffee",
        "index": "90",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:26:40.763Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-UMO2K6i6mt",
        "values": {
            "Store Name": "Simply Coffee",
            "Address": "43A Rundle St",
            "Website": "https:\/\/www.simplycoffee.com.au\/",
            "Phone": "",
            "Email": "info@simplycoffee.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/nAZ5fVKyX4WYnQQw5",
            "City": "Kent Town",
            "Postal Code": "5067",
            "Country": "Australia",
            "State": "South Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:26:40.763+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "South Australia",
            "Copy of City": "Kent Town"
        }
    },
    {
        "id": "i-B-3jn2JszM",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-B-3jn2JszM",
        "name": "Virgin Megastore Red Sea Mall",
        "index": "91",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:07:03.441Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-B-3jn2JszM",
        "values": {
            "Store Name": "Virgin Megastore Red Sea Mall",
            "Address": "King Abdulaziz Road, Red Sea Mall",
            "Website": "www.virginmegastore.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/U4PaQZJNXv126Vk2A",
            "City": "Jeddah",
            "Postal Code": "",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:07:03.441+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Jeddah"
        }
    },
    {
        "id": "i-cVCGMcXba7",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-cVCGMcXba7",
        "name": "Cremashop",
        "index": "92",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-cVCGMcXba7",
        "values": {
            "Store Name": "Cremashop",
            "Address": "H\u00e4meentie 155 A 6. krs.",
            "Website": "https:\/\/www.cremashop.eu\/en\/shop-by-brand\/subminimal",
            "Phone": "",
            "Email": "support@cremashop.eu",
            "Google Maps Pin": "",
            "City": "Helsinki",
            "Postal Code": "00560",
            "Country": "Finland",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "The God Shot",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Finland",
            "Copy of State": "",
            "Copy of City": "Helsinki"
        }
    },
    {
        "id": "i-TxqhQmgHwj",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-TxqhQmgHwj",
        "name": "Virgin Megastore Vendome",
        "index": "93",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-12T14:49:43.848Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-TxqhQmgHwj",
        "values": {
            "Store Name": "Virgin Megastore Vendome",
            "Address": "Place Vendome Mall, Wadi Al Gaeya, Lusail, Qatar",
            "Website": "www.virginmegastore.qa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/WYXx7TWHtMw9RC2p7",
            "City": "Doha",
            "Postal Code": "",
            "Country": "Qatar",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T21:49:43.848+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Qatar",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-le__K_UuRl",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-le__K_UuRl",
        "name": "On Duty",
        "index": "94",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-le__K_UuRl",
        "values": {
            "Store Name": "On Duty",
            "Address": "",
            "Website": "http:\/\/www.onduty.com.au\/",
            "Phone": "(02) 9731 1662",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-gDif82dqqA",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-gDif82dqqA",
        "name": "Brewcompany",
        "index": "95",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-gDif82dqqA",
        "values": {
            "Store Name": "Brewcompany",
            "Address": "Siebengebirgsstra\u00dfe 92a",
            "Website": "https:\/\/www.brewcompany.de\/SUBMINIMAL_1",
            "Phone": "4902284229863",
            "Email": "info@brewcompany.de",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/JpibEFtCWRh88HvG8",
            "City": "Bonn",
            "Postal Code": "53229",
            "Country": "Germany",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "Multiple Locations",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Bonn"
        }
    },
    {
        "id": "i-9XFD6U2idz",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-9XFD6U2idz",
        "name": "Karon Farm Coffee",
        "index": "96",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:05:45.415Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-9XFD6U2idz",
        "values": {
            "Store Name": "Karon Farm Coffee",
            "Address": "10 Builders Cl,",
            "Website": "https:\/\/karonfarmcoffee.com.au\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/NJoNSPNQWktUqxT97",
            "City": "Wendouree",
            "Postal Code": "3355",
            "Country": "Australia",
            "State": "Victoria",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:05:45.415+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-wJY-cHEvgq",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-wJY-cHEvgq",
        "name": "Virgin Megastore Mall of The Emirates",
        "index": "97",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-wJY-cHEvgq",
        "values": {
            "Store Name": "Virgin Megastore Mall of The Emirates",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-_7HrqFoam2",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-_7HrqFoam2",
        "name": "Nomad Vanz",
        "index": "98",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-_7HrqFoam2",
        "values": {
            "Store Name": "Nomad Vanz",
            "Address": "369 Lynn Avenue",
            "Website": "https:\/\/shop.nomadvanz.com",
            "Phone": "16049900594",
            "Email": "shop@nomadvanz.com",
            "Google Maps Pin": "",
            "City": "Vancouver",
            "Postal Code": "V7J 2C4",
            "Country": "Canada",
            "State": "British Columbia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "British Columbia",
            "Copy of City": "Vancouver"
        }
    },
    {
        "id": "i-sO71DQewmH",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-sO71DQewmH",
        "name": "Coffee Parts",
        "index": "99",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:50:48.291Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-sO71DQewmH",
        "values": {
            "Store Name": "Coffee Parts",
            "Address": "19\/75 Corish Circle",
            "Website": "https:\/\/www.coffeeparts.com.au\/",
            "Phone": "611300129129",
            "Email": "info@coffeeparts.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/qDzYMEJqnmEBAxXC9",
            "City": "Pagewood",
            "Postal Code": "2035",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:50:48.291+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Pagewood"
        }
    },
    {
        "id": "i-y2kjtAByKH",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-y2kjtAByKH",
        "name": "Shatterbox Coffee Company",
        "index": "100",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-y2kjtAByKH",
        "values": {
            "Store Name": "Shatterbox Coffee Company",
            "Address": "1701 Douglas Street",
            "Website": "https:\/\/shatterbox.ca\/",
            "Phone": "",
            "Email": "info@shatterbox.ca",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/WPBFZHdE1LZVEGDk6",
            "City": "Victoria",
            "Postal Code": "V8W 0C1",
            "Country": "Canada",
            "State": "British Columbia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "British Columbia",
            "Copy of City": "Victoria"
        }
    },
    {
        "id": "i-zoZyq2aqUw",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-zoZyq2aqUw",
        "name": "Cisco's Coffee",
        "index": "101",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:46:05.647Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-zoZyq2aqUw",
        "values": {
            "Store Name": "Cisco's Coffee",
            "Address": "106 Chapel St",
            "Website": "https:\/\/www.ciscoscoffee.com.au\/",
            "Phone": "",
            "Email": "info@ciscoscoffeeroasters.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/pRqSaatHQjsR3api8",
            "City": "Windsor",
            "Postal Code": "3181",
            "Country": "Australia",
            "State": "Victoria",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:46:05.647+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Victoria",
            "Copy of City": "Windsor"
        }
    },
    {
        "id": "i-4H8R2mYIg_",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-4H8R2mYIg_",
        "name": "Charlie\u2019s Coffee Co.",
        "index": "102",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-4H8R2mYIg_",
        "values": {
            "Store Name": "Charlie\u2019s Coffee Co.",
            "Address": "359 Main Street",
            "Website": "https:\/\/www.charliescoffeecomanitou.com\/",
            "Phone": "",
            "Email": "hello@charliescoffeeco",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/vtrn3oR9UAqLTGbw5",
            "City": "Manitou",
            "Postal Code": "R0G 1GO",
            "Country": "Canada",
            "State": "Manitoba",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Manitoba",
            "Copy of City": "Manitou"
        }
    },
    {
        "id": "i-8p5mz3HmxA",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-8p5mz3HmxA",
        "name": "Method Brewers",
        "index": "103",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-8p5mz3HmxA",
        "values": {
            "Store Name": "Method Brewers",
            "Address": "",
            "Website": "https:\/\/themethodbrewers.com\/",
            "Phone": "639178730851",
            "Email": "methodbrewersph@gmail.com",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Philippines",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Philippines",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-6wa7ZMjSWQ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-6wa7ZMjSWQ",
        "name": "Virgin Megastore Muscat City Center",
        "index": "104",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-6wa7ZMjSWQ",
        "values": {
            "Store Name": "Virgin Megastore Muscat City Center",
            "Address": "",
            "Website": "www.virginmegastore.om",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Oman",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Oman",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-D9r1IIlbxQ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-D9r1IIlbxQ",
        "name": "Coffeeshop.ie",
        "index": "105",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-D9r1IIlbxQ",
        "values": {
            "Store Name": "Coffeeshop.ie",
            "Address": "Unit C3, Network Enterprise Park",
            "Website": "https:\/\/www.coffeeshop.ie\/subminimal-Ireland",
            "Phone": "353012011016",
            "Email": "craig@coffeeshop.ie",
            "Google Maps Pin": "",
            "City": "Kilcoole",
            "Postal Code": "",
            "Country": "Ireland",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "The God Shot",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Ireland",
            "Copy of State": "",
            "Copy of City": "Kilcoole"
        }
    },
    {
        "id": "i-xOV2Pcabyw",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-xOV2Pcabyw",
        "name": "\u96c6\u6c23\u7bb1",
        "index": "106",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-11T14:38:45.875Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-xOV2Pcabyw",
        "values": {
            "Store Name": "\u96c6\u6c23\u7bb1",
            "Address": "Hong Kong, San Po Kong, Sze Mei St, 23\u865f1\/F, Room D Lee Sum Factory Building, Block D",
            "Website": "https:\/\/www.entreboxhk.com",
            "Phone": "85254829237",
            "Email": "entreboxinfo@gmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/gxi3dZ7PGkhtFi2y8",
            "City": "Hong Kong",
            "Postal Code": "",
            "Country": "Hong Kong",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:38:45.875+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Hong Kong",
            "Copy of State": "",
            "Copy of City": "Hong Kong"
        }
    },
    {
        "id": "i-2qRMrnP6RR",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-2qRMrnP6RR",
        "name": "Cheeky Devil Coffee Roasters",
        "index": "107",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:44:35.143Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-2qRMrnP6RR",
        "values": {
            "Store Name": "Cheeky Devil Coffee Roasters",
            "Address": "229 Albion Heights Dr",
            "Website": "https:\/\/cheekydevilcoffee.com.au\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/AzyKqLKrtus9barQ7",
            "City": "Kingston",
            "Postal Code": "7050",
            "Country": "Australia",
            "State": "Tasmania",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:44:35.143+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Tasmania",
            "Copy of City": "Kingston"
        }
    },
    {
        "id": "i-ofOoO7aJua",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ofOoO7aJua",
        "name": "JAWHARAT ALRABIA",
        "index": "108",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ofOoO7aJua",
        "values": {
            "Store Name": "JAWHARAT ALRABIA",
            "Address": "Al-Madina Al-Monawara St.",
            "Website": "www.jalrabia.com",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Amman",
            "Postal Code": "",
            "Country": "Jordan",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Jordan",
            "Copy of State": "",
            "Copy of City": "Amman"
        }
    },
    {
        "id": "i-RU3c1jBKkN",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-RU3c1jBKkN",
        "name": "Drink Morning",
        "index": "109",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-RU3c1jBKkN",
        "values": {
            "Store Name": "Drink Morning",
            "Address": "",
            "Website": "https:\/\/www.drinkmorning.com\/collections\/necessities-sg\/products\/nanofoamer%E2%84%A2",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Singapore",
            "Postal Code": "",
            "Country": "Singapore",
            "State": "Singapore",
            "Created by": "Dominic Symons",
            "Type editable": "Online Store",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Singapore",
            "Copy of State": "Singapore",
            "Copy of City": "Singapore"
        }
    },
    {
        "id": "i-k-sMGdn6bP",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-k-sMGdn6bP",
        "name": "Sipping Duck",
        "index": "110",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:27:12.846Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-k-sMGdn6bP",
        "values": {
            "Store Name": "Sipping Duck",
            "Address": "29 Johnston St",
            "Website": "https:\/\/www.sippingduck.com.au\/",
            "Phone": "610740581958",
            "Email": "coffee@sippingduck.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ATnEmDbRRghjj38q6",
            "City": "Stratford",
            "Postal Code": "4870",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:27:12.846+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Queensland",
            "Copy of City": "Stratford"
        }
    },
    {
        "id": "i-qDOqfHTrfQ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-qDOqfHTrfQ",
        "name": "21 Grams",
        "index": "111",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:24:06.651Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-qDOqfHTrfQ",
        "values": {
            "Store Name": "21 Grams",
            "Address": "3 S Creek Rd",
            "Website": "https:\/\/www.21grams.com.au\/",
            "Phone": "610477414447",
            "Email": "21gramsespresso@gmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/CN94czyYujAVHsXh9",
            "City": "Dee Why",
            "Postal Code": "2099",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:24:06.651+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Dee Why"
        }
    },
    {
        "id": "i-7G3IZYkL2m",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-7G3IZYkL2m",
        "name": "Kaffee barista",
        "index": "112",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-7G3IZYkL2m",
        "values": {
            "Store Name": "Kaffee barista",
            "Address": "Litschauer Stra\u00dfe 7",
            "Website": "https:\/\/www.kaffeebarista.at\/subminimal-brand",
            "Phone": "",
            "Email": "info@kaffeebarista.at",
            "Google Maps Pin": "",
            "City": "Heidenreichstein",
            "Postal Code": "3860",
            "Country": "Austria",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "The God Shot",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Austria",
            "Copy of State": "",
            "Copy of City": "Heidenreichstein"
        }
    },
    {
        "id": "i-6K4Z8KDbFu",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-6K4Z8KDbFu",
        "name": "KX Coffee Bar",
        "index": "113",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-6K4Z8KDbFu",
        "values": {
            "Store Name": "KX Coffee Bar",
            "Address": "263 Davenport Road",
            "Website": "kxyorkville.com",
            "Phone": "14169269757",
            "Email": "info@kxhealth.ca",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ouUJJQ2ck8JtqSpk9",
            "City": "Toronto",
            "Postal Code": "M5R 1J8",
            "Country": "Canada",
            "State": "Ontario",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Ontario",
            "Copy of City": "Toronto"
        }
    },
    {
        "id": "i-B9J7fD0oSZ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-B9J7fD0oSZ",
        "name": "Virgin Megastore Dubai Hills Mall",
        "index": "114",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-B9J7fD0oSZ",
        "values": {
            "Store Name": "Virgin Megastore Dubai Hills Mall",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-jFRjwj4Tkt",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-jFRjwj4Tkt",
        "name": "CENTRAL PINKLAO",
        "index": "115",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:42:07.484Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-jFRjwj4Tkt",
        "values": {
            "Store Name": "CENTRAL PINKLAO",
            "Address": "7\/1 Boromratchonnani Road, Arun-Amarin, Bankoknoi",
            "Website": "www.central.co.th",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/UJ3pCaS214uUKZ8q6",
            "City": "Bangkok",
            "Postal Code": "10700",
            "Country": "Thailand",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:42:07.484+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "DOTBKK",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Thailand",
            "Copy of State": "",
            "Copy of City": "Bangkok"
        }
    },
    {
        "id": "i-HvOwd9yU1Z",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-HvOwd9yU1Z",
        "name": "Firebag Coffee Company",
        "index": "116",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-HvOwd9yU1Z",
        "values": {
            "Store Name": "Firebag Coffee Company",
            "Address": "271 Rattlepan Creek Crescent",
            "Website": "www.firebagcoffeecompany.com",
            "Phone": "780-215-0744",
            "Email": "firebagcoffeecompany@gmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/nuEKTc1kqG6oZptx5",
            "City": "Fort Mcmurray",
            "Postal Code": "T9K 2V4",
            "Country": "Canada",
            "State": "Alberta",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Alberta",
            "Copy of City": "Fort Mcmurray"
        }
    },
    {
        "id": "i-G4TZ7i4Esr",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-G4TZ7i4Esr",
        "name": "Bean Addiction Coffee Roasters",
        "index": "117",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:36:17.129Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-G4TZ7i4Esr",
        "values": {
            "Store Name": "Bean Addiction Coffee Roasters",
            "Address": "18\/28 Barossa Valley Way,",
            "Website": "https:\/\/www.beanaddiction.com.au\/",
            "Phone": "",
            "Email": "damien@beanaddiction.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/6VTVJa95qZviyeYCA",
            "City": "Nuriootpa",
            "Postal Code": "5355",
            "Country": "Australia",
            "State": "South Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:36:17.129+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "South Australia",
            "Copy of City": "Nuriootpa"
        }
    },
    {
        "id": "i-H5JfyYjfm0",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-H5JfyYjfm0",
        "name": "Morning",
        "index": "118",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-H5JfyYjfm0",
        "values": {
            "Store Name": "Morning",
            "Address": "",
            "Website": "https:\/\/drinkmorning.com.au\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-CFDMgBuev3",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-CFDMgBuev3",
        "name": "Siboni's Coffee",
        "index": "119",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:25:30.847Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-CFDMgBuev3",
        "values": {
            "Store Name": "Siboni's Coffee",
            "Address": "975 Pacific Highway",
            "Website": "https:\/\/www.siboniscoffee.com.au\/",
            "Phone": "294403173",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/tL9JqxHUGqvxjsVQ6",
            "City": "Pymble",
            "Postal Code": "2073",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:25:30.847+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Pymble"
        }
    },
    {
        "id": "i-OT-z_hw9Q_",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-OT-z_hw9Q_",
        "name": "Coffee Beanery",
        "index": "120",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-OT-z_hw9Q_",
        "values": {
            "Store Name": "Coffee Beanery",
            "Address": "",
            "Website": "https:\/\/www.coffeebeanery.com.au\/",
            "Phone": "611300941445",
            "Email": "info@coffeebeanery.com.au",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-ztNMnU04-G",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ztNMnU04-G",
        "name": "Just Planet",
        "index": "121",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:04:47.570Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ztNMnU04-G",
        "values": {
            "Store Name": "Just Planet",
            "Address": "37 Oshanassy St",
            "Website": "https:\/\/justplanet.com.au\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ZJ3e4rYbaUAH4EJ76",
            "City": "Sunbury",
            "Postal Code": "3429",
            "Country": "Australia",
            "State": "Victoria",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:04:47.570+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Victoria",
            "Copy of City": "Sunbury"
        }
    },
    {
        "id": "i-eTiLEvPHtq",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-eTiLEvPHtq",
        "name": "The Nile",
        "index": "122",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-eTiLEvPHtq",
        "values": {
            "Store Name": "The Nile",
            "Address": "",
            "Website": "https:\/\/www.thenile.com.au\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-LT_bW0vfOB",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-LT_bW0vfOB",
        "name": "Back to the Grind Coffee House",
        "index": "123",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-LT_bW0vfOB",
        "values": {
            "Store Name": "Back to the Grind Coffee House",
            "Address": "6 Circle Street",
            "Website": "backtothegrindcoffeehouse.com",
            "Phone": "17053352770",
            "Email": "backtothegrind@icloud.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/C9CBV4bAvNZVSy2v5",
            "City": "Kapuskasing",
            "Postal Code": "P5N 1T3",
            "Country": "Canada",
            "State": "Ontario",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Ontario",
            "Copy of City": "Kapuskasing"
        }
    },
    {
        "id": "i-0ssvNoCnp5",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-0ssvNoCnp5",
        "name": "6th STREET GENERAL TRADING L.L.C",
        "index": "124",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:32:55.494Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-0ssvNoCnp5",
        "values": {
            "Store Name": "6th STREET GENERAL TRADING L.L.C",
            "Address": "",
            "Website": "www.6thstreet.com",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ZVnVy2s9dYFX9wHP7",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:32:55.494+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-RkDgxvwF50",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-RkDgxvwF50",
        "name": "Barista Supplies",
        "index": "125",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:29:53.849Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-RkDgxvwF50",
        "values": {
            "Store Name": "Barista Supplies",
            "Address": "32 Jellico Dr",
            "Website": "https:\/\/www.baristasupplies.com.au\/",
            "Phone": "(03) 8288 2399",
            "Email": "info@baristasupplies.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/VDJkRfMfbMz7HhN16",
            "City": "Scoresby",
            "Postal Code": "3179",
            "Country": "Australia",
            "State": "Victoria",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:29:53.849+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Victoria",
            "Copy of City": "Knoxfield"
        }
    },
    {
        "id": "i-psSLPXk_PJ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-psSLPXk_PJ",
        "name": "Virgin Megastore Abu Dhabi Mall",
        "index": "126",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-psSLPXk_PJ",
        "values": {
            "Store Name": "Virgin Megastore Abu Dhabi Mall",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-yXq16mx7oH",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-yXq16mx7oH",
        "name": "kava shop",
        "index": "127",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-yXq16mx7oH",
        "values": {
            "Store Name": "kava shop",
            "Address": "Po\u0161tanska 9",
            "Website": "https:\/\/www.kavashop.hr\/subminimal-brand",
            "Phone": "385.919.181.497",
            "Email": "info@kavashop.hr",
            "Google Maps Pin": "",
            "City": "Velika Gorica",
            "Postal Code": "10410",
            "Country": "Croatia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Croatia",
            "Copy of State": "",
            "Copy of City": "Velika Gorica"
        }
    },
    {
        "id": "i-7TFkovGyGn",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-7TFkovGyGn",
        "name": "Brother of Mine Coffee Roasters",
        "index": "128",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:43:20.347Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-7TFkovGyGn",
        "values": {
            "Store Name": "Brother of Mine Coffee Roasters",
            "Address": "Unit 1\/5 Crowley St",
            "Website": "https:\/\/brotherofmine.com.au\/",
            "Phone": "610895576437",
            "Email": "info@brotherofmine.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/DMwpgQm8Cs67z8WK7",
            "City": "Port Kennedy",
            "Postal Code": "6172",
            "Country": "Australia",
            "State": "Western Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:43:20.347+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Western Australia",
            "Copy of City": "Baldivis"
        }
    },
    {
        "id": "i-83NWCj-QgZ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-83NWCj-QgZ",
        "name": "Coffee One On One",
        "index": "129",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-83NWCj-QgZ",
        "values": {
            "Store Name": "Coffee One On One",
            "Address": "Online only",
            "Website": "https:\/\/coffeeoneonone.com.au\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Online Store",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i--rWdhVQqVP",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i--rWdhVQqVP",
        "name": "Rio Coffee",
        "index": "130",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:39:38.054Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui--rWdhVQqVP",
        "values": {
            "Store Name": "Rio Coffee",
            "Address": "22 Nelson St",
            "Website": "https:\/\/riocoffee.com.au\/\/",
            "Phone": "(08) 8362 3376",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/DBHZMCc8DXEgZWaN7",
            "City": "Stepney",
            "Postal Code": "5069",
            "Country": "Australia",
            "State": "South Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:39:38.054+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "South Australia",
            "Copy of City": "Stepney"
        }
    },
    {
        "id": "i-enSeO-BvyB",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-enSeO-BvyB",
        "name": "ARTISAN COFFEE GEAR",
        "index": "131",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:12:08.091Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-enSeO-BvyB",
        "values": {
            "Store Name": "ARTISAN COFFEE GEAR",
            "Address": "Str. Constantin Dobrogeanu Gherea no 123 Sector 1",
            "Website": "www.artisancoffeegear.com",
            "Phone": "40771265352",
            "Email": "office@artisancoffee.ro",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/3HJhZWxkeVLzu9Yy6",
            "City": "Bucharest",
            "Postal Code": "013763",
            "Country": "Romania",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:12:08.091+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "The God Shot",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Romania",
            "Copy of State": "",
            "Copy of City": "Bucharest"
        }
    },
    {
        "id": "i-D7XUCzeRvJ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-D7XUCzeRvJ",
        "name": "Virgin Megastore Nakheel Mall",
        "index": "132",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-D7XUCzeRvJ",
        "values": {
            "Store Name": "Virgin Megastore Nakheel Mall",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-05QFg4oU4L",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-05QFg4oU4L",
        "name": "Leftfield Coffee",
        "index": "133",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:17:08.728Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-05QFg4oU4L",
        "values": {
            "Store Name": "Leftfield Coffee",
            "Address": "30 Drake St, Osborne Park",
            "Website": "https:\/\/www.leftfieldcoffee.com\/",
            "Phone": "",
            "Email": "info@leftfieldcoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/B5yRD1Z7dwWQwYUa9",
            "City": "Osborne Park",
            "Postal Code": "6017",
            "Country": "Australia",
            "State": "Western Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:17:08.728+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Western Australia",
            "Copy of City": "Osborne Park"
        }
    },
    {
        "id": "i-yROmjOhFWJ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-yROmjOhFWJ",
        "name": "Hit n Run Coffee Shop & Roastery",
        "index": "134",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:00:42.324Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-yROmjOhFWJ",
        "values": {
            "Store Name": "Hit n Run Coffee Shop & Roastery",
            "Address": "117 Junction Street",
            "Website": "https:\/\/hitnruncoffee.com.au\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/zsbuFEywGvzbqzeD9",
            "City": "Nowra",
            "Postal Code": "2541",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:00:42.324+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Nowra"
        }
    },
    {
        "id": "i-NA-ySZxsQm",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-NA-ySZxsQm",
        "name": "Brown Bag Coffee Roasters",
        "index": "135",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-NA-ySZxsQm",
        "values": {
            "Store Name": "Brown Bag Coffee Roasters",
            "Address": "1910 Chemin Pink, Suite 106, Gatineau",
            "Website": "www.bbcr.ca",
            "Phone": "16136861716",
            "Email": "info@bbcr.ca",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/n6AwKESEFYQFW5428",
            "City": "Quebec",
            "Postal Code": "J9J 0B3",
            "Country": "Canada",
            "State": "Quebec",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Quebec",
            "Copy of City": "Quebec"
        }
    },
    {
        "id": "i-qhxi-PdMop",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-qhxi-PdMop",
        "name": "Caf\u00e9 Hubert Saint-jean",
        "index": "136",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-qhxi-PdMop",
        "values": {
            "Store Name": "Caf\u00e9 Hubert Saint-jean",
            "Address": "4797, boul. Bourque",
            "Website": "cafehubertsaintjean.ca",
            "Phone": "",
            "Email": "info@cafehubertsaintjean.ca",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/zSabyHHqu9KumTGh7",
            "City": "Sherbrooke",
            "Postal Code": "J1N 2G6",
            "Country": "Canada",
            "State": "Quebec",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Quebec",
            "Copy of City": "Sherbrooke"
        }
    },
    {
        "id": "i-5RRDowTnh8",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-5RRDowTnh8",
        "name": "SUNNY M Specialty Coffee & Tea",
        "index": "137",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-5RRDowTnh8",
        "values": {
            "Store Name": "SUNNY M Specialty Coffee & Tea",
            "Address": "1345-4540 No. 3 Rd.",
            "Website": "sunnyspecialty.com",
            "Phone": "",
            "Email": "info@sunnymspecialty.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/bPkU5BTSJd37Je88A",
            "City": "Richmond",
            "Postal Code": "V6X4E4",
            "Country": "Canada",
            "State": "British Columbia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "British Columbia",
            "Copy of City": "Richmond"
        }
    },
    {
        "id": "i-0pJ-E45BKz",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-0pJ-E45BKz",
        "name": "Troublesome",
        "index": "138",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-0pJ-E45BKz",
        "values": {
            "Store Name": "Troublesome",
            "Address": "1090 College Street",
            "Website": "https:\/\/troublesome.co\/",
            "Phone": "",
            "Email": "hello@troublesome.co",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ybGbqF5b3S5j4LDE7",
            "City": "Toronto",
            "Postal Code": "M6H 1B3",
            "Country": "Canada",
            "State": "Ontario",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Ontario",
            "Copy of City": "Toronto"
        }
    },
    {
        "id": "i-C6QwYu-Taj",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-C6QwYu-Taj",
        "name": "Eight Ounce",
        "index": "139",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-C6QwYu-Taj",
        "values": {
            "Store Name": "Eight Ounce",
            "Address": "2040-2600 Portland St SE",
            "Website": "https:\/\/eightouncecoffee.ca\/",
            "Phone": "14034579844",
            "Email": "hello@eightouncecoffee.ca",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/bi5ZNXSi4hyMnEQP6",
            "City": "Calgary",
            "Postal Code": "T2G 4M6",
            "Country": "Canada",
            "State": "Alberta",
            "Created by": "Dominic Symons",
            "Type editable": "Distributor,Online Store",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Distributor, Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Alberta",
            "Copy of City": "Calgary"
        }
    },
    {
        "id": "i-6aC90obPb3",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-6aC90obPb3",
        "name": "Runner Duck Coffee",
        "index": "140",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:41:12.753Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-6aC90obPb3",
        "values": {
            "Store Name": "Runner Duck Coffee",
            "Address": "U2\/101 Crown St",
            "Website": "https:\/\/runnerduckcoffee.com.au\/",
            "Phone": "(02) 4229 5579",
            "Email": "info@runnerduckcoffee.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/U2L7cXhSaxMd72Lp6",
            "City": "Wollongong",
            "Postal Code": "2500",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:41:12.753+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Wollongong"
        }
    },
    {
        "id": "i-ECDDbRGTS9",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ECDDbRGTS9",
        "name": "Virgin Megastore Mall of Qatar",
        "index": "141",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-12T14:48:21.296Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ECDDbRGTS9",
        "values": {
            "Store Name": "Virgin Megastore Mall of Qatar",
            "Address": "Mall of Qatar Mall of Qatar\u060c Dukhan Hwy, Rawdat Al Jahhaniya",
            "Website": "www.virginmegastore.qa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/uNVfKVWHD8rdB8hC8",
            "City": "Doha",
            "Postal Code": "",
            "Country": "Qatar",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T21:48:21.296+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Qatar",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-WnZfs_pd0i",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-WnZfs_pd0i",
        "name": "Fox & Oak",
        "index": "142",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-WnZfs_pd0i",
        "values": {
            "Store Name": "Fox & Oak",
            "Address": "1396 Main Street",
            "Website": "foxandoak.ca",
            "Phone": "",
            "Email": "info@foxandoak.ca",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/415FHkE15b6pS6jH6",
            "City": "Squamish",
            "Postal Code": "V8B 0H3",
            "Country": "Canada",
            "State": "British Columbia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "British Columbia",
            "Copy of City": "Squamish"
        }
    },
    {
        "id": "i-1jGxDTg5Kk",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-1jGxDTg5Kk",
        "name": "Otas Day Long",
        "index": "143",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:47:11.117Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-1jGxDTg5Kk",
        "values": {
            "Store Name": "Otas Day Long",
            "Address": "Nederkouter 55",
            "Website": "https:\/\/www.oatsdaylong.com\/",
            "Phone": "09 279 99 90",
            "Email": "",
            "Google Maps Pin": "https:\/\/share.google\/7U9GnlSCEAoWvRIai",
            "City": "Gent",
            "Postal Code": "9000",
            "Country": "Belgium",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:47:11.117+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "The God Shot",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Belgium",
            "Copy of State": "",
            "Copy of City": "Gent"
        }
    },
    {
        "id": "i-4EluPnWrxw",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-4EluPnWrxw",
        "name": "Anthony\u2019s Espresso Equipment",
        "index": "144",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-4EluPnWrxw",
        "values": {
            "Store Name": "Anthony\u2019s Espresso Equipment",
            "Address": "80 Carlauren Road, Unit 12",
            "Website": "www.anthonysespresso.com",
            "Phone": "19052640433",
            "Email": "info@anthonysespresso.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/DsGLF8Zc4xu6ibrz6",
            "City": "Woodbridge",
            "Postal Code": "L4L 7Z5",
            "Country": "Canada",
            "State": "Ontario",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Ontario",
            "Copy of City": "Woodbridge"
        }
    },
    {
        "id": "i-WTDov3b5EI",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-WTDov3b5EI",
        "name": "CENTRAL BANGNA",
        "index": "145",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:29:02.798Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-WTDov3b5EI",
        "values": {
            "Store Name": "CENTRAL BANGNA",
            "Address": "585 Bangna-Trad Road, Bangna",
            "Website": "www.central.co.th",
            "Phone": "66027255000",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/jtWa9GWefKmxu3cc6",
            "City": "Bangkok",
            "Postal Code": "10260",
            "Country": "Thailand",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:29:02.798+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "DOTBKK",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Thailand",
            "Copy of State": "",
            "Copy of City": "Bangkok"
        }
    },
    {
        "id": "i-qEYjt1VN7K",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-qEYjt1VN7K",
        "name": "OTLMALL",
        "index": "146",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-qEYjt1VN7K",
        "values": {
            "Store Name": "OTLMALL",
            "Address": "299D Pop Up Kiosk, 2\/F, Metroplaza",
            "Website": "www.otlmall.com",
            "Phone": "9157 5245",
            "Email": "sales@otlmall.com",
            "Google Maps Pin": "",
            "City": "Kwai Fong",
            "Postal Code": "",
            "Country": "Hong Kong",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Hong Kong",
            "Copy of State": "",
            "Copy of City": "Kwai Fong"
        }
    },
    {
        "id": "i-SQzpl5z49y",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-SQzpl5z49y",
        "name": "Virgin Megastore Riyadh Airport",
        "index": "147",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:07:27.698Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-SQzpl5z49y",
        "values": {
            "Store Name": "Virgin Megastore Riyadh Airport",
            "Address": "",
            "Website": "www.virginmegastore.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/qre8AzqKQRfirRhM8",
            "City": "Riyadh",
            "Postal Code": "",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:07:27.698+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Riyadh"
        }
    },
    {
        "id": "i-lGdF2RsRbR",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-lGdF2RsRbR",
        "name": "Nerdware",
        "index": "148",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-lGdF2RsRbR",
        "values": {
            "Store Name": "Nerdware",
            "Address": "",
            "Website": "https:\/\/nerdware.com.au\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-m8krsGncyD",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-m8krsGncyD",
        "name": "Eko kapszula",
        "index": "149",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-m8krsGncyD",
        "values": {
            "Store Name": "Eko kapszula",
            "Address": "Teve utca 60",
            "Website": "https:\/\/www.ekokapszula.hu\/subminimal-brand",
            "Phone": "36.204.382.078",
            "Email": "info@ekokapszula.hu",
            "Google Maps Pin": "",
            "City": "Budapest",
            "Postal Code": "1139",
            "Country": "Hungary",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "The God Shot",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Hungary",
            "Copy of State": "",
            "Copy of City": "Budapest"
        }
    },
    {
        "id": "i-EHKd8LRLYr",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-EHKd8LRLYr",
        "name": "Reliquaire",
        "index": "150",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:37:30.238Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-EHKd8LRLYr",
        "values": {
            "Store Name": "Reliquaire",
            "Address": "139 Gilbert St",
            "Website": "https:\/\/www.reliquaire.com\/",
            "Phone": "364262599",
            "Email": "shop@reliquaire.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/JzGnjyhBT2BiZrxX6",
            "City": "Latrobe",
            "Postal Code": "7307",
            "Country": "Australia",
            "State": "Tasmania",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:37:30.238+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Tasmania",
            "Copy of City": "Latrobe"
        }
    },
    {
        "id": "i-TKtHhPM5ez",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-TKtHhPM5ez",
        "name": "Yahava KoffeeWorks",
        "index": "151",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-TKtHhPM5ez",
        "values": {
            "Store Name": "Yahava KoffeeWorks",
            "Address": "",
            "Website": "https:\/\/www.yahava.com.au\/",
            "Phone": "",
            "Email": "support@yahava.com.au",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-uFWXCEJpwO",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-uFWXCEJpwO",
        "name": "Mountain Designs",
        "index": "152",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-uFWXCEJpwO",
        "values": {
            "Store Name": "Mountain Designs",
            "Address": "",
            "Website": "https:\/\/www.mountaindesigns.com\/",
            "Phone": "1300 086 244",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-8pajXXfZW8",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-8pajXXfZW8",
        "name": "Fox Coffee",
        "index": "153",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T12:59:54.921Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-8pajXXfZW8",
        "values": {
            "Store Name": "Fox Coffee",
            "Address": "3 Ellison Road",
            "Website": "https:\/\/www.foxcoffee.com.au\/",
            "Phone": "610732162318",
            "Email": "info@foxcoffee.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/k5KpsxuzB8XPYkuQ8",
            "City": "Geebung",
            "Postal Code": "4034",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T19:59:54.921+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Queensland",
            "Copy of City": "Geebung"
        }
    },
    {
        "id": "i-0IR_jqqySS",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-0IR_jqqySS",
        "name": "Jones & Co Coffee",
        "index": "154",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:04:19.500Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-0IR_jqqySS",
        "values": {
            "Store Name": "Jones & Co Coffee",
            "Address": "U2\/84 Callaway St",
            "Website": "https:\/\/www.jonescocoffee.com\/",
            "Phone": "862046312",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ZB8WdYxXZsrDzRxV6",
            "City": "Wangara",
            "Postal Code": "6065",
            "Country": "Australia",
            "State": "Western Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:04:19.500+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Western Australia",
            "Copy of City": "Wangara"
        }
    },
    {
        "id": "i-DAOpdWX76k",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-DAOpdWX76k",
        "name": "AZAU",
        "index": "155",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-DAOpdWX76k",
        "values": {
            "Store Name": "AZAU",
            "Address": "",
            "Website": "https:\/\/www.azau.com.au\/",
            "Phone": "610871320688",
            "Email": "support@azau.com.au",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-aAOvrn9d0K",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-aAOvrn9d0K",
        "name": "Virgin Megastore Landmark",
        "index": "156",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-12T14:47:31.532Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-aAOvrn9d0K",
        "values": {
            "Store Name": "Virgin Megastore Landmark",
            "Address": "Landmark Mall",
            "Website": "www.virginmegastore.qa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/tN5hSd3HximhMSPB6",
            "City": "Doha",
            "Postal Code": "",
            "Country": "Qatar",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T21:47:31.532+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Qatar",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-HWeNWQDwwI",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-HWeNWQDwwI",
        "name": "edream",
        "index": "157",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:13:13.040Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-HWeNWQDwwI",
        "values": {
            "Store Name": "edream",
            "Address": "Intrarea Nisipari 23",
            "Website": "www.edream.ro",
            "Phone": "40766424241",
            "Email": "info@edream.ro",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/RaEM48jpTVQUqDG6A",
            "City": "Bucharest",
            "Postal Code": "077190",
            "Country": "Romania",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:13:13.040+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Romania",
            "Copy of State": "",
            "Copy of City": "Bucharest"
        }
    },
    {
        "id": "i-_HstW7pU7-",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-_HstW7pU7-",
        "name": "Mudsharks Cafe",
        "index": "158",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-_HstW7pU7-",
        "values": {
            "Store Name": "Mudsharks Cafe",
            "Address": "255 6th St #111, Courtenay",
            "Website": "mudsharkscoffee.com",
            "Phone": "250-338-0939",
            "Email": "info@mudsharkscoffee.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/sRPhXMcA1MppBpCaA",
            "City": "Courtenay",
            "Postal Code": "V9N 1G4",
            "Country": "Canada",
            "State": "British Columbia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "British Columbia",
            "Copy of City": "Courtenay"
        }
    },
    {
        "id": "i-6h87fuENDv",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-6h87fuENDv",
        "name": "The Red Brick",
        "index": "159",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-6h87fuENDv",
        "values": {
            "Store Name": "The Red Brick",
            "Address": "5018 50 AVE.",
            "Website": "",
            "Phone": "(780)581-8944",
            "Email": "theredbrick17@gmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/W2Tz8fhBWrFDd7SR9",
            "City": "Vermilion",
            "Postal Code": "T9X 1A2",
            "Country": "Canada",
            "State": "Alberta",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Alberta",
            "Copy of City": "Vermilion"
        }
    },
    {
        "id": "i-ZqF9Ic4sQc",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ZqF9Ic4sQc",
        "name": "Quest Coffee Roasters",
        "index": "160",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:37:10.373Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ZqF9Ic4sQc",
        "values": {
            "Store Name": "Quest Coffee Roasters",
            "Address": "20 James Street",
            "Website": "https:\/\/www.questcoffee.com.au\/",
            "Phone": "",
            "Email": "info@questcoffee.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/QGRKdr7CtiCJi3Ae6",
            "City": "Burleigh Heads",
            "Postal Code": "4220",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:37:10.373+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Queensland",
            "Copy of City": "Burleigh Heads"
        }
    },
    {
        "id": "i-zYYEWAU7cK",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-zYYEWAU7cK",
        "name": "V A H General Trading LLC",
        "index": "161",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:37:54.054Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-zYYEWAU7cK",
        "values": {
            "Store Name": "V A H General Trading LLC",
            "Address": "",
            "Website": "www.uae.bevarabia.com",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/EDxbHmQWqKrvLKE79",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:37:54.054+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-Xev1s7Lmep",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Xev1s7Lmep",
        "name": "48 EAST COFFEE ROASTERS",
        "index": "162",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:17:26.466Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Xev1s7Lmep",
        "values": {
            "Store Name": "48 EAST COFFEE ROASTERS",
            "Address": "Forty Eight East Coffee Roasters, 123 Salem Al Mubarak St",
            "Website": "www.48e.co",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/W9iX1poCgveHoAgM9",
            "City": "Salmiya",
            "Postal Code": "",
            "Country": "Kuwait",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:17:26.466+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Kuwait",
            "Copy of State": "",
            "Copy of City": "Salmiya"
        }
    },
    {
        "id": "i--1ZuppspRV",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i--1ZuppspRV",
        "name": "Barista Warehouse",
        "index": "163",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui--1ZuppspRV",
        "values": {
            "Store Name": "Barista Warehouse",
            "Address": "",
            "Website": "https:\/\/baristawarehouse.com.au\/",
            "Phone": "",
            "Email": "hello@baristawarehouse.com.au",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-BoZMh79Dea",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-BoZMh79Dea",
        "name": "Daily Scoop at Majo's",
        "index": "164",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:53:13.123Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-BoZMh79Dea",
        "values": {
            "Store Name": "Daily Scoop at Majo's",
            "Address": "69\/71 Macquarie St",
            "Website": "http:\/\/www.majosdailyscoop.com.au\/",
            "Phone": "(02) 6882 6272",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/vC5dwvVZaz4yU6UG9",
            "City": "Dubbo",
            "Postal Code": "2830",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:53:13.123+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Dubbo"
        }
    },
    {
        "id": "i-PscB5_xiS3",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-PscB5_xiS3",
        "name": "Alex Junior",
        "index": "165",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:24:56.436Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-PscB5_xiS3",
        "values": {
            "Store Name": "Alex Junior",
            "Address": "Shop 13, Corner Warburton & Leichhardt Avenues",
            "Website": "http:\/\/www.alexjunior.com.au\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/DtwWf7a9BaPnJkQNA",
            "City": "Padbury",
            "Postal Code": "6025",
            "Country": "Australia",
            "State": "Western Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:24:56.436+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Western Australia",
            "Copy of City": "Padbury"
        }
    },
    {
        "id": "i-bmoTX1BM2A",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-bmoTX1BM2A",
        "name": "Solberg & Hansen",
        "index": "166",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:18:49.929Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-bmoTX1BM2A",
        "values": {
            "Store Name": "Solberg & Hansen",
            "Address": "Enebakkveien 125",
            "Website": "https:\/\/sh.no\/",
            "Phone": "4723036820",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/2puEFvMiWraWkrWt5",
            "City": "Oslo",
            "Postal Code": "",
            "Country": "Norway",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:18:49.929+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Solberg & Hansen",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Norway",
            "Copy of State": "",
            "Copy of City": "Oslo"
        }
    },
    {
        "id": "i-0P7aUg2BJv",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-0P7aUg2BJv",
        "name": "Bearded Lady Roasters",
        "index": "167",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-0P7aUg2BJv",
        "values": {
            "Store Name": "Bearded Lady Roasters",
            "Address": "901 E 4th St",
            "Website": "www.beardedladyroasters.com",
            "Phone": "14176911822",
            "Email": "beardedladyroasters@gmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/FrUuhrf3Avnv4wdPA",
            "City": "Joplin",
            "Postal Code": "64801",
            "Country": "United States",
            "State": "MO",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "MO",
            "Copy of City": "Joplin"
        }
    },
    {
        "id": "i-r9pUut9SQ-",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-r9pUut9SQ-",
        "name": "Bunamarket",
        "index": "168",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:58:30.411Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-r9pUut9SQ-",
        "values": {
            "Store Name": "Bunamarket",
            "Address": "116, Block E, Phileo Damansara 1",
            "Website": "https:\/\/bunamarket.com\/",
            "Phone": "60104239641",
            "Email": "info@bunamarket.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/Sio72qxvaSh9Q1vq7",
            "City": "Petaling Jaya",
            "Postal Code": "46350",
            "Country": "Malaysia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:58:30.411+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Malaysia",
            "Copy of State": "",
            "Copy of City": "Petaling Jaya"
        }
    },
    {
        "id": "i-428q2T32a6",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-428q2T32a6",
        "name": "Cooee Coffee Co",
        "index": "169",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-428q2T32a6",
        "values": {
            "Store Name": "Cooee Coffee Co",
            "Address": "Online only",
            "Website": "https:\/\/www.cooeecoffeeco.com.au\/",
            "Phone": "",
            "Email": "info@cooeecoffeeco.com.au",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Online Store",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-x8cqZmT1Ay",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-x8cqZmT1Ay",
        "name": "King Carlos Coffee",
        "index": "170",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:06:09.579Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-x8cqZmT1Ay",
        "values": {
            "Store Name": "King Carlos Coffee",
            "Address": "18 Weston Rd",
            "Website": "https:\/\/kingcarloscoffee.com.au\/",
            "Phone": "(02) 9580 1300",
            "Email": "contact@kingcarloscoffee.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/7VwwaJ1u5sWha2Ad7",
            "City": "Hurstville",
            "Postal Code": "2220",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:06:09.579+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Hurstville"
        }
    },
    {
        "id": "i-hpwQShdamK",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-hpwQShdamK",
        "name": "River City Coffee Roasters",
        "index": "171",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:40:01.426Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-hpwQShdamK",
        "values": {
            "Store Name": "River City Coffee Roasters",
            "Address": "Unit 5, 30 Shore St West",
            "Website": "https:\/\/www.rivercitycoffee.com.au\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/16ofQSuTFmgd5QPW8",
            "City": "Ormiston",
            "Postal Code": "4160",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:40:01.426+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Queensland",
            "Copy of City": "Ormiston"
        }
    },
    {
        "id": "i-ZXENIXB_AZ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ZXENIXB_AZ",
        "name": "DAX caf\u00e9",
        "index": "172",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ZXENIXB_AZ",
        "values": {
            "Store Name": "DAX caf\u00e9",
            "Address": "1461 ave. Van Horne",
            "Website": "www.cafedax.com",
            "Phone": "15149419982",
            "Email": "info@cafedax.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/a653bNhCMs6gYKXD8",
            "City": "Outremont",
            "Postal Code": "H2V 1L3",
            "Country": "Canada",
            "State": "Quebec",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Quebec",
            "Copy of City": "Outremont"
        }
    },
    {
        "id": "i-AZm5fxlisK",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-AZm5fxlisK",
        "name": "Vive Berry",
        "index": "173",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-AZm5fxlisK",
        "values": {
            "Store Name": "Vive Berry",
            "Address": "",
            "Website": "https:\/\/www.viveberry.com\/",
            "Phone": "",
            "Email": "hello@viveberry.com",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-ZOFtzKNLuR",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ZOFtzKNLuR",
        "name": "Virgin Megastore Dubai Marina Mall",
        "index": "174",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ZOFtzKNLuR",
        "values": {
            "Store Name": "Virgin Megastore Dubai Marina Mall",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-g9UnuwN4OQ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-g9UnuwN4OQ",
        "name": "Coffee Tools International Co",
        "index": "175",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-g9UnuwN4OQ",
        "values": {
            "Store Name": "Coffee Tools International Co",
            "Address": "",
            "Website": "www.coffeetoolskw.com",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Kuwait",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Kuwait",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-0AjEAbg2Qe",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-0AjEAbg2Qe",
        "name": "Breeze Valley Coffee Roasters",
        "index": "176",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:41:20.544Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-0AjEAbg2Qe",
        "values": {
            "Store Name": "Breeze Valley Coffee Roasters",
            "Address": "Cafe, 172 Fox Valley Road",
            "Website": "https:\/\/shop.breezevalley.com.au\/",
            "Phone": "1300688866",
            "Email": "reception@breezevalley.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/mVBwCu9aaGZJcQ5YA",
            "City": "Wahroonga",
            "Postal Code": "2076",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:41:20.544+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Wahroonga"
        }
    },
    {
        "id": "i-L2KY-ZeutP",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-L2KY-ZeutP",
        "name": "Virgin Megastore Mall of Oman",
        "index": "177",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:56:10.534Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-L2KY-ZeutP",
        "values": {
            "Store Name": "Virgin Megastore Mall of Oman",
            "Address": "Mall of Oman",
            "Website": "www.virginmegastore.om",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/7NK8YVidARaGvoLG7",
            "City": "",
            "Postal Code": "",
            "Country": "Oman",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:56:10.534+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Oman",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-meEzIawkHP",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-meEzIawkHP",
        "name": "SOHO Coffee Roasters",
        "index": "178",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:32:39.665Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-meEzIawkHP",
        "values": {
            "Store Name": "SOHO Coffee Roasters",
            "Address": "Addie Pl",
            "Website": "https:\/\/sohocoffeeroasters.com.au\/",
            "Phone": "(08) 8340 3830",
            "Email": "office@coffeedistributors.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/jDY3snKPPfNkEtnDA",
            "City": "Adelaide",
            "Postal Code": "5000",
            "Country": "Australia",
            "State": "South Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:32:39.665+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "South Australia",
            "Copy of City": "Adelaide"
        }
    },
    {
        "id": "i-i5w6ArvaQ3",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-i5w6ArvaQ3",
        "name": "GOTA Coffee Experts",
        "index": "179",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-24T14:39:18.003Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-i5w6ArvaQ3",
        "values": {
            "Store Name": "GOTA Coffee Experts",
            "Address": "Mariahilfer Stra\u00dfe 192",
            "Website": "https:\/\/gota.coffee\/",
            "Phone": "01 236 46 82",
            "Email": "info@gota.coffee",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/8uGgYtCFFqrhwSDP6",
            "City": "Vienna",
            "Postal Code": "1150",
            "Country": "Austria",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T21:39:18.003+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Austria",
            "Copy of State": "",
            "Copy of City": "Vienna"
        }
    },
    {
        "id": "i-Qc6S7iO5Dp",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Qc6S7iO5Dp",
        "name": "Finest Cup",
        "index": "180",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Qc6S7iO5Dp",
        "values": {
            "Store Name": "Finest Cup",
            "Address": "109-8645 160 Street",
            "Website": "www.finestcup.coffee",
            "Phone": "",
            "Email": "info@finestcup.coffee",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/wuqVUehaFbg1NzQP7",
            "City": "Surrey",
            "Postal Code": "V4N 1G4",
            "Country": "Canada",
            "State": "British Columbia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "British Columbia",
            "Copy of City": "Surrey"
        }
    },
    {
        "id": "i-SMqlJHvBZi",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-SMqlJHvBZi",
        "name": "MUMZWORLD",
        "index": "181",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:34:54.247Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-SMqlJHvBZi",
        "values": {
            "Store Name": "MUMZWORLD",
            "Address": "Dubai Design District",
            "Website": "www.mumzworld.com",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/dWd8iXa8JrtKdBov8",
            "City": "Dubai",
            "Postal Code": "500245",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:34:54.247+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i--g38SzqqJ2",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i--g38SzqqJ2",
        "name": "ALT WIEN KAFFEE",
        "index": "182",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-24T14:32:38.044Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui--g38SzqqJ2",
        "values": {
            "Store Name": "ALT WIEN KAFFEE",
            "Address": "Schleifmuehlgasse 23, A",
            "Website": "https:\/\/www.altwien.at\/",
            "Phone": "",
            "Email": "office@altwien.at",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/JB7jqAbyyTc1mpzS8",
            "City": "Vienna",
            "Postal Code": "1040",
            "Country": "Austria",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-24T21:32:38.044+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Austria",
            "Copy of State": "",
            "Copy of City": "Vienna"
        }
    },
    {
        "id": "i-2hIs4LdQce",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-2hIs4LdQce",
        "name": "Bean Scene Around Espresso Services",
        "index": "183",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:36:38.250Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-2hIs4LdQce",
        "values": {
            "Store Name": "Bean Scene Around Espresso Services",
            "Address": "13 Smith Street",
            "Website": "https:\/\/beanscenearound.com.au\/",
            "Phone": "",
            "Email": "office@beanscenearound.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/GnyDf8U1PB11Xtbi8",
            "City": "Warragul",
            "Postal Code": "3820",
            "Country": "Australia",
            "State": "Victoria",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:36:38.250+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Victoria",
            "Copy of City": "Warragul"
        }
    },
    {
        "id": "i-pUA_A5R8Hu",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-pUA_A5R8Hu",
        "name": "Mad Goat",
        "index": "184",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-pUA_A5R8Hu",
        "values": {
            "Store Name": "Mad Goat",
            "Address": "Bu\u0308lowsvej 24B 3 tv",
            "Website": "https:\/\/madgoat.dk\/collections\/kaffeudstyr?gf_114989=Subminimal",
            "Phone": "4542588444",
            "Email": "halloj@madgoat.dk",
            "Google Maps Pin": "",
            "City": "Frederiksberg",
            "Postal Code": "1870",
            "Country": "Denmark",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Denmark",
            "Copy of State": "",
            "Copy of City": "Frederiksberg"
        }
    },
    {
        "id": "i-azVSZr-zph",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-azVSZr-zph",
        "name": "NOON",
        "index": "185",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-azVSZr-zph",
        "values": {
            "Store Name": "NOON",
            "Address": "",
            "Website": "www.noon.com",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-bxm1yvu3JQ",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-bxm1yvu3JQ",
        "name": "Flair Espresso",
        "index": "186",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-bxm1yvu3JQ",
        "values": {
            "Store Name": "Flair Espresso",
            "Address": "28 Hammond Street, Suite B",
            "Website": "https:\/\/flairespresso.com\/",
            "Phone": "",
            "Email": "service@flairespresso.com",
            "Google Maps Pin": "",
            "City": "Irvine",
            "Postal Code": "92618",
            "Country": "United States",
            "State": "CA",
            "Created by": "Dominic Symons",
            "Type editable": "Online Store",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "CA",
            "Copy of City": "Irvine"
        }
    },
    {
        "id": "i-VCHfFHj5lv",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-VCHfFHj5lv",
        "name": "Espresso Works",
        "index": "187",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T12:58:39.722Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-VCHfFHj5lv",
        "values": {
            "Store Name": "Espresso Works",
            "Address": "Unit 1, 50 Ladner Street",
            "Website": "https:\/\/espressoworks.com.au\/",
            "Phone": "",
            "Email": "info@espressoworks.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/pPQu8WuR2naVwVZ58",
            "City": "O\u2019Connor",
            "Postal Code": "6163",
            "Country": "Australia",
            "State": "Western Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T19:58:39.722+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Western Australia",
            "Copy of City": "O\u2019Connor"
        }
    },
    {
        "id": "i-7OeJMJuJBs",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-7OeJMJuJBs",
        "name": "NovelTea Bookstore Cafe",
        "index": "188",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-7OeJMJuJBs",
        "values": {
            "Store Name": "NovelTea Bookstore Cafe",
            "Address": "604 Prince Street",
            "Website": "www.ntbookstorecafe.ca",
            "Phone": "",
            "Email": "info@ntbookstorecafe.ca",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/3bxVuA4nfEojJJcd7",
            "City": "Truro",
            "Postal Code": "B2N 1G3",
            "Country": "Canada",
            "State": "Nova Scotia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Nova Scotia",
            "Copy of City": "Truro"
        }
    },
    {
        "id": "i-gDpIzH8wYG",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-gDpIzH8wYG",
        "name": "The Shot House",
        "index": "189",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:37:34.642Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-gDpIzH8wYG",
        "values": {
            "Store Name": "The Shot House",
            "Address": "Shop 2 Village Walk",
            "Website": "https:\/\/www.southernaddictionscoffee.com.au\/the-shot-house",
            "Phone": "610356342811",
            "Email": "theshothouse@sacoffee.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/Juy6CfwTbhMBdjq49",
            "City": "Yarragon",
            "Postal Code": "3823",
            "Country": "Australia",
            "State": "Victoria",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:37:34.642+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Victoria",
            "Copy of City": "Yarragon"
        }
    },
    {
        "id": "i-b7frR-O6VL",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-b7frR-O6VL",
        "name": "Zo'i Espresso",
        "index": "190",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:46:53.851Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-b7frR-O6VL",
        "values": {
            "Store Name": "Zo'i Espresso",
            "Address": "444 Dean St",
            "Website": "https:\/\/www.zoiespresso.com.au\/",
            "Phone": "",
            "Email": "orders@zoiespresso.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/X4rhbx7PWnWjT14V8",
            "City": "Albury",
            "Postal Code": "2640",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:46:53.851+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Albury"
        }
    },
    {
        "id": "i-FKB6rGSbR1",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-FKB6rGSbR1",
        "name": "CENTRAL WESTGATE",
        "index": "191",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:46:14.825Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-FKB6rGSbR1",
        "values": {
            "Store Name": "CENTRAL WESTGATE",
            "Address": "199\/3 Moo 6, Sao Thong Hin, Bangyai",
            "Website": "www.central.co.th",
            "Phone": "66025949999",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/9TAgo95dZSYE6MZ26",
            "City": "Nonthaburi",
            "Postal Code": "11140",
            "Country": "Thailand",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:46:14.825+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "DOTBKK",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Thailand",
            "Copy of State": "",
            "Copy of City": "Nonthaburi"
        }
    },
    {
        "id": "i-UGbRr0Ltj5",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-UGbRr0Ltj5",
        "name": "Next",
        "index": "192",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-UGbRr0Ltj5",
        "values": {
            "Store Name": "Next",
            "Address": "Steinfeldgasse 7",
            "Website": "https:\/\/mynext.coffee\/collections\/nanofoamer",
            "Phone": "",
            "Email": "hi@mynext.coffee",
            "Google Maps Pin": "",
            "City": "Vienna",
            "Postal Code": "1190",
            "Country": "Austria",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Austria",
            "Copy of State": "",
            "Copy of City": "Vienna"
        }
    },
    {
        "id": "i-xpaz7ezY4Z",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-xpaz7ezY4Z",
        "name": "The Golden Brewing",
        "index": "193",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-xpaz7ezY4Z",
        "values": {
            "Store Name": "The Golden Brewing",
            "Address": "",
            "Website": "https:\/\/thegoldenbrewing.com.au\/",
            "Phone": "",
            "Email": "info@thegoldenbrewing.com.au",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-BfbYyzPDEK",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-BfbYyzPDEK",
        "name": "Forno Cultura King",
        "index": "194",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-BfbYyzPDEK",
        "values": {
            "Store Name": "Forno Cultura King",
            "Address": "609 King St. W.",
            "Website": "fornocultura.com",
            "Phone": "14166038305",
            "Email": "king@fornocultura.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/KNYdzrpjHfNUkgzW7",
            "City": "Toronto",
            "Postal Code": "M5V 1M3",
            "Country": "Canada",
            "State": "Ontario",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Ontario",
            "Copy of City": "Toronto"
        }
    },
    {
        "id": "i-Jg2Kgs41RT",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Jg2Kgs41RT",
        "name": "Coffee Machines and Beans",
        "index": "195",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:50:13.240Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Jg2Kgs41RT",
        "values": {
            "Store Name": "Coffee Machines and Beans",
            "Address": "1\/48 Shandan Circuit",
            "Website": "https:\/\/machinesandbeans.com.au\/",
            "Phone": "611300357575",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/idWga7iNgPXsw9V66",
            "City": "Albion Park Rail",
            "Postal Code": "2527",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:50:13.240+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Albion Park Rail"
        }
    },
    {
        "id": "i-MU_i8iCpwH",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-MU_i8iCpwH",
        "name": "Virgin Megastore The Ranches Souk",
        "index": "196",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-MU_i8iCpwH",
        "values": {
            "Store Name": "Virgin Megastore The Ranches Souk",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-8nhfXpASNr",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-8nhfXpASNr",
        "name": "Roseberry Street Cafe Pty Ltd",
        "index": "197",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:40:25.530Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-8nhfXpASNr",
        "values": {
            "Store Name": "Roseberry Street Cafe Pty Ltd",
            "Address": "2\/62 Balgowlah Rd",
            "Website": "https:\/\/www.roseberrystcafe.com.au\/",
            "Phone": "610299494444",
            "Email": "info@rstr.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/xNkcGk5Mxat9JcK27",
            "City": "Balgowlah",
            "Postal Code": "2093",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:40:25.530+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Balgowlah"
        }
    },
    {
        "id": "i-bCaLoXypd7",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-bCaLoXypd7",
        "name": "Lay Day Coffee",
        "index": "198",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-bCaLoXypd7",
        "values": {
            "Store Name": "Lay Day Coffee",
            "Address": "",
            "Website": "https:\/\/laydaycoffee.com\/",
            "Phone": "",
            "Email": "hello@laydaycoffee.com",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-5E_vQdqYuu",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-5E_vQdqYuu",
        "name": "Chicco Di Caffe",
        "index": "199",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:25:53.933Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-5E_vQdqYuu",
        "values": {
            "Store Name": "Chicco Di Caffe",
            "Address": "Hamelacha 2 st. Renanim shopping mall",
            "Website": "https:\/\/chiccodicaffe.co.il\/",
            "Phone": "972546628032",
            "Email": "info@chiccodicaffe.co.il",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/V1TNm6VaRyoBcPQ48",
            "City": "Raanana",
            "Postal Code": "",
            "Country": "Israel",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:25:53.933+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Chicco Di Caffe",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Israel",
            "Copy of State": "",
            "Copy of City": "Raanana"
        }
    },
    {
        "id": "i-66AtZy07Lx",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-66AtZy07Lx",
        "name": "Virgin Megastore Sahara Mall",
        "index": "200",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-66AtZy07Lx",
        "values": {
            "Store Name": "Virgin Megastore Sahara Mall",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-6UL4PZkV-2",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-6UL4PZkV-2",
        "name": "Coffee Tools Distributing",
        "index": "201",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-6UL4PZkV-2",
        "values": {
            "Store Name": "Coffee Tools Distributing",
            "Address": "T\/A Coffee Tools Distributing, PO Box 2157",
            "Website": "https:\/\/www.coffeetools.supply\/",
            "Phone": "610731731552",
            "Email": "sales@coffeetools.supply",
            "Google Maps Pin": "",
            "City": "Redcliffe North",
            "Postal Code": "4020",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Distributor",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Distributor",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Queensland",
            "Copy of City": "Redcliffe North"
        }
    },
    {
        "id": "i-4roCf4kJD8",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-4roCf4kJD8",
        "name": "Cowpresso Coffee Roasters",
        "index": "202",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:53:30.802Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-4roCf4kJD8",
        "values": {
            "Store Name": "Cowpresso Coffee Roasters",
            "Address": "21 LORONG KILAT #01-07",
            "Website": "https:\/\/cowpressocoffee.sg\/",
            "Phone": "94300464",
            "Email": "hello@cowpressocoffee.sg",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/Tf4dn95ET8vBZsPB8",
            "City": "Singapore",
            "Postal Code": "598123",
            "Country": "Singapore",
            "State": "Singapore",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:53:30.802+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Cowpresso",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Singapore",
            "Copy of State": "Singapore",
            "Copy of City": "Singapore"
        }
    },
    {
        "id": "i-wUfwVBd0hq",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-wUfwVBd0hq",
        "name": "Alternative Brewing",
        "index": "203",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:26:00.839Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-wUfwVBd0hq",
        "values": {
            "Store Name": "Alternative Brewing",
            "Address": "2620 Ipswich Rd",
            "Website": "https:\/\/alternativebrewing.com.au\/",
            "Phone": "",
            "Email": "hello@AlternativeBrewing.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/FKPUgFDuYqqtjfEy9",
            "City": "Richlands",
            "Postal Code": "4076",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:26:00.839+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Queensland",
            "Copy of City": "Richlands"
        }
    },
    {
        "id": "i-jeZ7arMK5J",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-jeZ7arMK5J",
        "name": "Virgin Megastore Al Zahia Mall",
        "index": "204",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-jeZ7arMK5J",
        "values": {
            "Store Name": "Virgin Megastore Al Zahia Mall",
            "Address": "",
            "Website": "www.virginmegastore.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-jq26YrMk36",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-jq26YrMk36",
        "name": "Underground Coffee Roasters",
        "index": "205",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:38:35.390Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-jq26YrMk36",
        "values": {
            "Store Name": "Underground Coffee Roasters",
            "Address": "Unit 7, 2187 Castlereagh Rd",
            "Website": "https:\/\/undergroundcoffee.com.au\/",
            "Phone": "",
            "Email": "tim@undergroundcoffee.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/bzh5c5SPdRyhEuMW8",
            "City": "Penrith",
            "Postal Code": "2750",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:38:35.390+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Penrith"
        }
    },
    {
        "id": "i-X2ZSTL3ZVC",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-X2ZSTL3ZVC",
        "name": "Retro Espresso Coffee Co",
        "index": "206",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:39:13.469Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-X2ZSTL3ZVC",
        "values": {
            "Store Name": "Retro Espresso Coffee Co",
            "Address": "36 Mayne St.",
            "Website": "https:\/\/retrocoffee.com.au\/",
            "Phone": "(07) 4193 9304",
            "Email": "retroespressoco@gmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/mFQz2LJcpAfqbXWb7",
            "City": "Tiaro",
            "Postal Code": "4650",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:39:13.469+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Queensland",
            "Copy of City": "Tiaro"
        }
    },
    {
        "id": "i-FhuSoay10c",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-FhuSoay10c",
        "name": "Bean Scene Coffee Works",
        "index": "207",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-FhuSoay10c",
        "values": {
            "Store Name": "Bean Scene Coffee Works",
            "Address": "100-1615 Dickson Ave",
            "Website": "www.beanscene.ca",
            "Phone": "778-484-5445",
            "Email": "beanscenecentral@shaw.ca",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/Jwqk7JTdrMtakAyF9",
            "City": "Kelowna",
            "Postal Code": "V1Y 0B1",
            "Country": "Canada",
            "State": "British Columbia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "British Columbia",
            "Copy of City": "Kelowna"
        }
    },
    {
        "id": "i-5PUVsqi4-z",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-5PUVsqi4-z",
        "name": "CENTRAL LARDPRAO",
        "index": "208",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:37:55.932Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-5PUVsqi4-z",
        "values": {
            "Store Name": "CENTRAL LARDPRAO",
            "Address": "1691 Paholyothin Road, Chatuchak, Chatuchak",
            "Website": "www.central.co.th",
            "Phone": "66025411111",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/oy395ktc3i6maPA79",
            "City": "Bangkok",
            "Postal Code": "10900",
            "Country": "Thailand",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:37:55.932+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "DOTBKK",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Thailand",
            "Copy of State": "",
            "Copy of City": "Bangkok"
        }
    },
    {
        "id": "i-EH1l4_1j8V",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-EH1l4_1j8V",
        "name": "L\u00e1ze\u0148sk\u00e1 k\u00e1va",
        "index": "209",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:15:54.683Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-EH1l4_1j8V",
        "values": {
            "Store Name": "L\u00e1ze\u0148sk\u00e1 k\u00e1va",
            "Address": "Masarykova 149",
            "Website": "https:\/\/eshop.lazenskakava.cz\/znacka\/subminimal",
            "Phone": "420608042186",
            "Email": "chutna@lazenskakava.cz",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/Eh58dEvvsvDFX8mX6",
            "City": "Luha\u010dovice",
            "Postal Code": "76326",
            "Country": "Czech Republic",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:15:54.683+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Czech Republic",
            "Copy of State": "",
            "Copy of City": "Luha\u010dovice"
        }
    },
    {
        "id": "i-xuHP7LKTCg",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-xuHP7LKTCg",
        "name": "Other Brother Roasters",
        "index": "210",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-xuHP7LKTCg",
        "values": {
            "Store Name": "Other Brother Roasters",
            "Address": "304-191 Kimberly Rd",
            "Website": "otherbrotherroasters.com",
            "Phone": "",
            "Email": "info@otherbrotherroasters.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/tHsYYHkKRh542bpk8",
            "City": "Winkler",
            "Postal Code": "R6W 4A9",
            "Country": "Canada",
            "State": "Manitoba",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Manitoba",
            "Copy of City": "Winkler"
        }
    },
    {
        "id": "i-wR3aVc2_Nl",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-wR3aVc2_Nl",
        "name": "Rabbit Hole Roasters",
        "index": "211",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-wR3aVc2_Nl",
        "values": {
            "Store Name": "Rabbit Hole Roasters",
            "Address": "9090 Av. du Parc Suite #200",
            "Website": "www.rabbitholeroasters.com",
            "Phone": "",
            "Email": "info@rabbitholeroasters.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/5j516G1bayDvT8Gv5",
            "City": "Montreal",
            "Postal Code": "H2N 1Y8",
            "Country": "Canada",
            "State": "Quebec",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Quebec",
            "Copy of City": "Montreal"
        }
    },
    {
        "id": "i-CgpDLRgUa4",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-CgpDLRgUa4",
        "name": "Subminimal",
        "index": "212",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:15:22.631Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-CgpDLRgUa4",
        "values": {
            "Store Name": "Subminimal",
            "Address": "250 Airport Circle",
            "Website": "https:\/\/subminimal.com\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/naCh7n1ejHDQWy5h7",
            "City": "Corona",
            "Postal Code": "92880",
            "Country": "United States",
            "State": "CA",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:15:22.631+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "CA",
            "Copy of City": "Corona"
        }
    },
    {
        "id": "i-zxWqFtLI3u",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-zxWqFtLI3u",
        "name": "Virgin Megastore Nakheel Mall",
        "index": "213",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-12T15:03:45.106Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-zxWqFtLI3u",
        "values": {
            "Store Name": "Virgin Megastore Nakheel Mall",
            "Address": "2329 Makkah Al Mukarramah Branch Road Store #2 Ground floor, Najm al Qurais Building,",
            "Website": "www.virginmegastore.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/VrHCXJm1mDtqUJaC9",
            "City": "",
            "Postal Code": "12821",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T22:03:45.106+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-UVZKlqqm-7",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-UVZKlqqm-7",
        "name": "Slide Coffee Roasters",
        "index": "214",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:27:59.043Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-UVZKlqqm-7",
        "values": {
            "Store Name": "Slide Coffee Roasters",
            "Address": "1\/2 Lomandra Place",
            "Website": "https:\/\/slidecoffee.com.au\/",
            "Phone": "",
            "Email": "hello@slidecoffee.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ar7GDktg3swVj9Wz5",
            "City": "Coolum Beach",
            "Postal Code": "4573",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:27:59.043+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Queensland",
            "Copy of City": "Coolum Beach"
        }
    },
    {
        "id": "i-cw3ogsxc6a",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-cw3ogsxc6a",
        "name": "Balwyn Coffee Centre",
        "index": "215",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:28:50.264Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-cw3ogsxc6a",
        "values": {
            "Store Name": "Balwyn Coffee Centre",
            "Address": "302 Whitehorse Road",
            "Website": "https:\/\/thebalwyncoffeecentre.com.au\/",
            "Phone": "(03) 9836 4224",
            "Email": "thebalwyncoffeecentre@gmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/DrXyRq6VseQqoMYX6",
            "City": "Balwyn",
            "Postal Code": "3103",
            "Country": "Australia",
            "State": "Victoria",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:28:50.264+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Victoria",
            "Copy of City": "Balwyn"
        }
    },
    {
        "id": "i-sxj64Y_uDR",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-sxj64Y_uDR",
        "name": "Palate & Ply Espresso Bar & Roastery",
        "index": "216",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:36:49.114Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-sxj64Y_uDR",
        "values": {
            "Store Name": "Palate & Ply Espresso Bar & Roastery",
            "Address": "37 Vernon St",
            "Website": "https:\/\/palateandply.com.au\/",
            "Phone": "610434700910",
            "Email": "manager@palateandply.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ivt6F3Jy3BnHvjYE8",
            "City": "Coffs Harbor",
            "Postal Code": "2450",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:36:49.114+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Coffs Harbor"
        }
    },
    {
        "id": "i-oczdjvjakN",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-oczdjvjakN",
        "name": "Virgin Megastore Park Avenue Mall Qurtubah",
        "index": "217",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-12T15:06:40.637Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-oczdjvjakN",
        "values": {
            "Store Name": "Virgin Megastore Park Avenue Mall Qurtubah",
            "Address": "\u062d\u064a, Said Ibn Zayd Rd, Qurtubah",
            "Website": "www.virginmegastore.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/gfUWgnUuiHPeFQeZ8",
            "City": "Qurtubah",
            "Postal Code": "13248",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T22:06:40.637+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Qurtubah"
        }
    },
    {
        "id": "i-Fe5CnQHJsf",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Fe5CnQHJsf",
        "name": "Harvest Coffeehouse",
        "index": "218",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Fe5CnQHJsf",
        "values": {
            "Store Name": "Harvest Coffeehouse",
            "Address": "766 Main Street",
            "Website": "www.harvestcoffee.ca",
            "Phone": "14039044000",
            "Email": "info@harvestcoffee.ca",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/CEBTkrPmnTWhLjEHA",
            "City": "Pincher Creek",
            "Postal Code": "T0K 1W0",
            "Country": "Canada",
            "State": "Alberta",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Alberta",
            "Copy of City": "Pincher Creek"
        }
    },
    {
        "id": "i-Nz5yLjiKOl",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Nz5yLjiKOl",
        "name": "oeko kapseln",
        "index": "219",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Nz5yLjiKOl",
        "values": {
            "Store Name": "oeko kapseln",
            "Address": "Schlo\u00dfplatz 2",
            "Website": "https:\/\/www.oekokapseln.de\/subminimal-brand",
            "Phone": "",
            "Email": "info@oekokapseln.de",
            "Google Maps Pin": "",
            "City": "Bad Brambach",
            "Postal Code": "08648",
            "Country": "Germany",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Germany",
            "Copy of State": "",
            "Copy of City": "Bad Brambach"
        }
    },
    {
        "id": "i-TfQLSLTeDt",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-TfQLSLTeDt",
        "name": "Pretty Clean Shop",
        "index": "220",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-TfQLSLTeDt",
        "values": {
            "Store Name": "Pretty Clean Shop",
            "Address": "3010 Dundas St. West",
            "Website": "prettycleanshop.com",
            "Phone": "416-766 9633",
            "Email": "info@prettycleanshop.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/j8vkCj8Cw3fPTLj56",
            "City": "Toronto",
            "Postal Code": "M6P 1Z3",
            "Country": "Canada",
            "State": "Ontario",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Ontario",
            "Copy of City": "Toronto"
        }
    },
    {
        "id": "i-NPEYUa7Iph",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-NPEYUa7Iph",
        "name": "SOUQ AL MINA ROASTERY",
        "index": "221",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-NPEYUa7Iph",
        "values": {
            "Store Name": "SOUQ AL MINA ROASTERY",
            "Address": "",
            "Website": "www.blacksmith.ae",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Abu Dhabi",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Abu Dhabi"
        }
    },
    {
        "id": "i-3MI7zaIKpa",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-3MI7zaIKpa",
        "name": "Eko kapsulki",
        "index": "222",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-3MI7zaIKpa",
        "values": {
            "Store Name": "Eko kapsulki",
            "Address": "ul. Ksi\u0119dza J\u00f3zefa Londzina 106",
            "Website": "https:\/\/www.ekokapsulki.pl\/subminimal-brand",
            "Phone": "",
            "Email": "info@ekokapsulki.pl",
            "Google Maps Pin": "",
            "City": "Bielsko-Bia\u0142a",
            "Postal Code": "43-382",
            "Country": "Poland",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "The God Shot",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Poland",
            "Copy of State": "",
            "Copy of City": "Bielsko-Bia\u0142a"
        }
    },
    {
        "id": "i-eRatHK2ajj",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-eRatHK2ajj",
        "name": "Virgin Megastore Riyadh Park",
        "index": "223",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:10:02.723Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-eRatHK2ajj",
        "values": {
            "Store Name": "Virgin Megastore Riyadh Park",
            "Address": "Northern Ring Branch Rd, Riyadh Park Mall",
            "Website": "www.virginmegastore.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/QS9LVT4YTbUFYWPg9",
            "City": "Riyadh",
            "Postal Code": "12311",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:10:02.723+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Riyadh"
        }
    },
    {
        "id": "i-NDBlg_XDy3",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-NDBlg_XDy3",
        "name": "CENTRAL FESTIVAL EASTVILLE",
        "index": "224",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:37:27.759Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-NDBlg_XDy3",
        "values": {
            "Store Name": "CENTRAL FESTIVAL EASTVILLE",
            "Address": "69\/3 Pradit Manutham Road, Ladprao",
            "Website": "www.central.co.th",
            "Phone": "66020187777",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/r2ughxKD7HqCi5ms8",
            "City": "Bangkok",
            "Postal Code": "10230",
            "Country": "Thailand",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:37:27.759+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "DOTBKK",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Thailand",
            "Copy of State": "",
            "Copy of City": "Bangkok"
        }
    },
    {
        "id": "i-WeS20fDn8c",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-WeS20fDn8c",
        "name": "Virgin Megastore Doha Festival City",
        "index": "225",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-12T14:45:01.316Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-WeS20fDn8c",
        "values": {
            "Store Name": "Virgin Megastore Doha Festival City",
            "Address": "Doha Festival City Mall, 1st Floor, Gate D, Umm Salal Muhammed,",
            "Website": "www.virginmegastore.qa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/G71FY1oREkSbjLm47",
            "City": "Doha",
            "Postal Code": "",
            "Country": "Qatar",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T21:45:01.316+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Qatar",
            "Copy of State": "",
            "Copy of City": "Doha"
        }
    },
    {
        "id": "i-ROfLbCFLa0",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ROfLbCFLa0",
        "name": "DNA - JORDAN",
        "index": "226",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ROfLbCFLa0",
        "values": {
            "Store Name": "DNA - JORDAN",
            "Address": "",
            "Website": "",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Jordan",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Jordan",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-ElsRXVADBH",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ElsRXVADBH",
        "name": "Outback Equipment",
        "index": "227",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:35:24.161Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ElsRXVADBH",
        "values": {
            "Store Name": "Outback Equipment",
            "Address": "1 Murdoch Cct",
            "Website": "https:\/\/www.outbackequipment.com.au\/",
            "Phone": "1300 854 185",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/sqGq5HjhiriPqYdu9",
            "City": "Acacia Ridge",
            "Postal Code": "4110",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:35:24.161+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-VOcWfON50f",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-VOcWfON50f",
        "name": "DXB.NET",
        "index": "228",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:34:18.044Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-VOcWfON50f",
        "values": {
            "Store Name": "DXB.NET",
            "Address": "Block 32, Street 8, Al-Quoz 1 (opposite to Al Serkal Avenue)",
            "Website": "www.dxb.net",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/KxBneWP5dGce15Xi7",
            "City": "Dubai",
            "Postal Code": "",
            "Country": "United Arab Emirates",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:34:18.044+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United Arab Emirates",
            "Copy of State": "",
            "Copy of City": "Dubai"
        }
    },
    {
        "id": "i-lc05BQDn-h",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-lc05BQDn-h",
        "name": "AIRJO Coffee Roasters",
        "index": "229",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-lc05BQDn-h",
        "values": {
            "Store Name": "AIRJO Coffee Roasters",
            "Address": "",
            "Website": "https:\/\/airjo.com\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "",
            "Postal Code": "",
            "Country": "Australia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "",
            "Copy of City": ""
        }
    },
    {
        "id": "i-NqhXYLc38Z",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-NqhXYLc38Z",
        "name": "Di Bartoli Coffee Centre",
        "index": "230",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:55:55.430Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-NqhXYLc38Z",
        "values": {
            "Store Name": "Di Bartoli Coffee Centre",
            "Address": "Nick Scali Bldg, Level 1, Unit 23\/69 O'Riordan St",
            "Website": "https:\/\/dibartoli.com.au\/",
            "Phone": "610290781388",
            "Email": "info@dibartoli.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/dA7GkYKrULryeoX88",
            "City": "Alexandria",
            "Postal Code": "2015",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:55:55.430+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Rosebery"
        }
    },
    {
        "id": "i-3pt-oEaOH3",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-3pt-oEaOH3",
        "name": "Forno Cultura Queen",
        "index": "231",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-3pt-oEaOH3",
        "values": {
            "Store Name": "Forno Cultura Queen",
            "Address": "1056 Queen St. W",
            "Website": "fornocultura.com",
            "Phone": "14165302444",
            "Email": "queen@fornocultura.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/t8xKYz1BMDc22wXK7",
            "City": "Toronto",
            "Postal Code": "M6J 1H3",
            "Country": "Canada",
            "State": "Ontario",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Ontario",
            "Copy of City": "Toronto"
        }
    },
    {
        "id": "i-GBvaRsCwxB",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-GBvaRsCwxB",
        "name": "Caf\u00e9 Hubert Saint-jean",
        "index": "232",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-GBvaRsCwxB",
        "values": {
            "Store Name": "Caf\u00e9 Hubert Saint-jean",
            "Address": "455, rue king ouest",
            "Website": "cafehubertsaintjean.ca",
            "Phone": "",
            "Email": "info@cafehubertsaintjean.ca",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ATHu2caHubvd7Dkg8",
            "City": "Sherbrooke",
            "Postal Code": "J1H 6G4",
            "Country": "Canada",
            "State": "Quebec",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Quebec",
            "Copy of City": "Sherbrooke"
        }
    },
    {
        "id": "i-RWv4OkKqNC",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-RWv4OkKqNC",
        "name": "Blommers",
        "index": "233",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-11T14:45:22.762Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-RWv4OkKqNC",
        "values": {
            "Store Name": "Blommers",
            "Address": "Het Loog 6,",
            "Website": "https:\/\/www.blommers.coffee\/nl\/brands\/subminimal\/",
            "Phone": "31242340344",
            "Email": "info@blommers.coffee",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/gAooiM61qDxYbPVB8",
            "City": "Nijmegen",
            "Postal Code": "6541 AV",
            "Country": "Netherlands",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-11T21:45:22.762+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "The God Shot",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Netherlands",
            "Copy of State": "",
            "Copy of City": "Nijmegen"
        }
    },
    {
        "id": "i-km4T9qqAm4",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-km4T9qqAm4",
        "name": "Everything Kitchen Miranda",
        "index": "234",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T12:59:32.684Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-km4T9qqAm4",
        "values": {
            "Store Name": "Everything Kitchen Miranda",
            "Address": "Shop 1153\/4, Westfield Miranda, 600 Kingsway",
            "Website": "https:\/\/everything-kitchen.com.au\/",
            "Phone": "(02) 95241137",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/wCNJuizis46y4hqx7",
            "City": "Miranda",
            "Postal Code": "2228",
            "Country": "Australia",
            "State": "New South Wales",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T19:59:32.684+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "New South Wales",
            "Copy of City": "Miranda"
        }
    },
    {
        "id": "i-pMPr8B3WV7",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-pMPr8B3WV7",
        "name": "Boston Bean Coffee Company",
        "index": "235",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:39:50.215Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-pMPr8B3WV7",
        "values": {
            "Store Name": "Boston Bean Coffee Company",
            "Address": "122 Mortlock Terrace",
            "Website": "https:\/\/bostonbean.com.au\/",
            "Phone": "(08) 8683 5140",
            "Email": "admin@bostonbean.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/CCVmySrTDFVYEH7aA",
            "City": "Port Lincoln",
            "Postal Code": "5606",
            "Country": "Australia",
            "State": "South Australia",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:39:50.215+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "South Australia",
            "Copy of City": "Port Lincoln"
        }
    },
    {
        "id": "i-mH1cz0-JGy",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-mH1cz0-JGy",
        "name": "Virgin Megastore Stars Avenue Mall",
        "index": "236",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-23T14:16:10.350Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-mH1cz0-JGy",
        "values": {
            "Store Name": "Virgin Megastore Stars Avenue Mall",
            "Address": "King Abdul Aziz Rd, Stars Avenue Mall",
            "Website": "www.virginmegastore.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/p9ydyfQryLvuRLW27",
            "City": "Jeddah",
            "Postal Code": "",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-23T21:16:10.350+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Jeddah"
        }
    },
    {
        "id": "i-Xfo91oHwky",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Xfo91oHwky",
        "name": "Mokaflor",
        "index": "237",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:19:27.030Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Xfo91oHwky",
        "values": {
            "Store Name": "Mokaflor",
            "Address": "Via delle Torri 55",
            "Website": "https:\/\/www.mokaflor-italian-coffee.com",
            "Phone": "390557321718",
            "Email": "info@mokaflor.it",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/NHJR7qtzuVCjSt7v9",
            "City": "Firenze",
            "Postal Code": "",
            "Country": "Italy",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:19:27.030+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Italy",
            "Copy of State": "",
            "Copy of City": "Firenze"
        }
    },
    {
        "id": "i-cbFGfkz4UW",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-cbFGfkz4UW",
        "name": "Caf\u00e9ier-Boustifo",
        "index": "238",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-cbFGfkz4UW",
        "values": {
            "Store Name": "Caf\u00e9ier-Boustifo",
            "Address": "7, Ste-Anne, Ville-Marie",
            "Website": "www.cafeier-boustifo.com",
            "Phone": "819-629-2772",
            "Email": "cafeier-boustifo@hotmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/ydRoS4mpPkLJZe7c9",
            "City": "Ville-Marie",
            "Postal Code": "J9V 2B6",
            "Country": "Canada",
            "State": "Quebec",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Quebec",
            "Copy of City": "Ville-Marie"
        }
    },
    {
        "id": "i-W9M0SbpqeF",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-W9M0SbpqeF",
        "name": "Subminimal",
        "index": "239",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-W9M0SbpqeF",
        "values": {
            "Store Name": "Subminimal",
            "Address": "14 Robinson Rd",
            "Website": "https:\/\/subminimal.com\/",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "",
            "City": "Singapore",
            "Postal Code": "048545",
            "Country": "Singapore",
            "State": "Singapore",
            "Created by": "Dominic Symons",
            "Type editable": "Distributor,Online Store",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Distributor, Online Store",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Singapore",
            "Copy of State": "Singapore",
            "Copy of City": "Singapore"
        }
    },
    {
        "id": "i-nnjrzgKibF",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-nnjrzgKibF",
        "name": "Cafe Postal",
        "index": "240",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-04T16:14:18.120Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-nnjrzgKibF",
        "values": {
            "Store Name": "Cafe Postal",
            "Address": "1A-202 Provencher Boulevard",
            "Website": "www.cafepostal.ca",
            "Phone": "",
            "Email": "postalsubscription@gmail.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/7BaHKkaidcwTk4Fu9",
            "City": "Winnipeg",
            "Postal Code": "R2H 0G4",
            "Country": "Canada",
            "State": "Manitoba",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-04T23:14:18.120+07:00",
            "Modified by": "Daniel Velho",
            "Notes (PUBLIC)": "",
            "Distributors": "Eight Ounce",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Canada",
            "Copy of State": "Manitoba",
            "Copy of City": "Winnipeg"
        }
    },
    {
        "id": "i-sgl2Zig0Ya",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-sgl2Zig0Ya",
        "name": "The Kitchen Engine",
        "index": "241",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-09T14:22:54.560Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-sgl2Zig0Ya",
        "values": {
            "Store Name": "The Kitchen Engine",
            "Address": "621 W. Mallon, Suite 416",
            "Website": "https:\/\/thekitchenengine.com\/",
            "Phone": "",
            "Email": "sales@thekitchenengine.com",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/BnPXz17AxVN8MdT1A",
            "City": "Spokane",
            "Postal Code": "99201",
            "Country": "United States",
            "State": "WA",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-09T21:22:54.560+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Subminimal",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "United States",
            "Copy of State": "WA",
            "Copy of City": "Spokane"
        }
    },
    {
        "id": "i-yvm5Xs8hxI",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-yvm5Xs8hxI",
        "name": "Kofio",
        "index": "242",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-04-07T14:15:37.372Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-yvm5Xs8hxI",
        "values": {
            "Store Name": "Kofio",
            "Address": "Nov\u00e1kov\u00fdch 393",
            "Website": "https:\/\/www.kofio.cz\/",
            "Phone": "",
            "Email": "sluzebnicek@kofio.cz",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/DM3yZqtCWaNVH2pH9",
            "City": "Prague",
            "Postal Code": "18000",
            "Country": "Czech Republic",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-04-07T21:15:37.372+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Czech Republic",
            "Copy of State": "",
            "Copy of City": "Prague"
        }
    },
    {
        "id": "i-n4GY9bmXWf",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-n4GY9bmXWf",
        "name": "Virgin Megastore Panorama Mall",
        "index": "243",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-12T15:04:23.264Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-n4GY9bmXWf",
        "values": {
            "Store Name": "Virgin Megastore Panorama Mall",
            "Address": "Al Takhassousi St, Al Mathar Ash Shamali",
            "Website": "www.virginmegastore.sa",
            "Phone": "",
            "Email": "",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/gRnFYRNyaPKnMhXo6",
            "City": "Riyadh",
            "Postal Code": "12332",
            "Country": "Saudi Arabia",
            "State": "",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-12T22:04:23.264+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Shift",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Saudi Arabia",
            "Copy of State": "",
            "Copy of City": "Riyadh"
        }
    },
    {
        "id": "i-Hmg9-agJ3B",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-Hmg9-agJ3B",
        "name": "Simply Beans Pty Ltd",
        "index": "244",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T14:26:00.013Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-Hmg9-agJ3B",
        "values": {
            "Store Name": "Simply Beans Pty Ltd",
            "Address": "B6\/10-14 Compton Rd",
            "Website": "https:\/\/www.simplybeans.com.au\/",
            "Phone": "610732082900",
            "Email": "admin@simplybeans.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/FbEqRhGnfZT2mmUi7",
            "City": "Underwood",
            "Postal Code": "4119",
            "Country": "Australia",
            "State": "Queensland",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T21:26:00.013+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Queensland",
            "Copy of City": "Underwood"
        }
    },
    {
        "id": "i-ArEhR7disC",
        "type": "row",
        "href": "https:\/\/coda.io\/apis\/v1\/docs\/mmhAvuLfC-\/tables\/grid-BJimyW-fHu\/rows\/i-ArEhR7disC",
        "name": "Growers Espresso\/Eureka Coffee",
        "index": "245",
        "createdAt": "2026-01-25T13:35:34.631Z",
        "updatedAt": "2026-03-10T13:00:20.814Z",
        "browserLink": "https:\/\/coda.io\/d\/_dmmhAvuLfC-#_tugrid-BJimyW-fHu\/_rui-ArEhR7disC",
        "values": {
            "Store Name": "Growers Espresso\/Eureka Coffee",
            "Address": "332-334 St Georges Rd",
            "Website": "https:\/\/www.eurekacoffee.com.au\/",
            "Phone": "(03) 9486 1886",
            "Email": "growersespresso@eurekacoffee.com.au",
            "Google Maps Pin": "https:\/\/maps.app.goo.gl\/UwfQbecFm8qRX5KX9",
            "City": "Fitzroy",
            "Postal Code": "3068",
            "Country": "Australia",
            "State": "Victoria",
            "Created by": "Dominic Symons",
            "Type editable": "Reseller",
            "Modified": "2026-03-10T20:00:20.814+07:00",
            "Modified by": "Jason Patrick",
            "Notes (PUBLIC)": "",
            "Distributors": "Coffee Tools Distributing",
            "Do not edit. Trigger for automation": "Do not edit. Trigger for automation",
            "Delete": "{\"formatType\":\"button\",\"disabled\":false}",
            "Deleted": "",
            "Created on": "2026-01-25T20:35:34.631+07:00",
            "Type": "Reseller",
            "New Country": "",
            "New City": "",
            "New State": "",
            "Copy of Country": "Australia",
            "Copy of State": "Victoria",
            "Copy of City": "Fitzroy"
        }
    }
]